var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import styled, { css, keyframes, ThemeContext, withTheme } from "styled-components";
import React from "react";
const Padding = css`
  padding: ${(props) => props.padding};
`;
const Margin = css`
  margin: ${(props) => props.margin};
`;
const Zindex = css`
  z-index: ${(props) => props.zIndex ? props.zIndex : 1};
`;
const Position = css`
  position: ${(props) => props.position};
`;
const Overflow = css`
  overflow: ${(props) => props.overflow};
`;
const Border = css`
  border: ${(props) => props.border};
`;
const BorderStyle = css`
  border-style: ${(props) => props.borderStyle};
`;
const WordBreak = css`
  word-break: ${(props) => props.wordBreak};
`;
const Transition = css`
  transition: ${(props) => props.transition};
`;
const Cursor = css`
  cursor: ${(props) => props.cursor};
`;
const MaxWidth = css`
  max-width: ${(props) => props.maxWidth};
`;
const MaxHeight = css`
  max-height: ${(props) => props.maxHeight};
`;
const Shrink = css`
  flex-shrink: ${(props) => props.shrink};
`;
const Wrap = css`
  flex-wrap: ${(props) => props.wrap};
`;
const LineHeight = css`
  line-height: ${(props) => props.lineHeight || "160%"};
`;
const LetterSpacing = css`
  letter-spacing: ${(props) => props.letterSpacing};
`;
const FontSize = css`
  font-size: ${(props) => props.fontSize};
`;
const Color = css`
  color: ${(props) => props.color};
`;
const FontWeight = css`
  font-weight: ${(props) => props.fontWeight};
`;
const TextAlign = css`
  text-align: ${(props) => props.align || props.textAlign};
`;
const TextTransform = css`
  text-transform: ${(props) => props.textTransform};
`;
const FontStyle = css`
  font-style: ${(props) => props.fontStyle};
`;
const FontFamily = css`
  font-family: ${(props) => props.fontFamily};
`;
const UserSelect = css`
  user-select: ${(props) => props.userSelect};
`;
const Background = css`
  background: ${(props) => props.background};
`;
const Left = css`
  left: ${(props) => props.left};
`;
const Top = css`
  top: ${(props) => props.top};
`;
const Opacity = css`
  opacity: ${(props) => props.opacity};
`;
const CommonProps = {
  LineHeight,
  LetterSpacing,
  FontSize,
  FontWeight,
  FontFamily,
  FontStyle,
  Opacity,
  Color,
  TextAlign,
  TextTransform,
  UserSelect,
  Padding,
  Margin,
  Cursor
};
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const convertHexToRGBA$1 = (hex, a) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return `rgba(${[c >> 16 & 255, c >> 8 & 255, c & 255].join(",")},${a})`;
  }
  return false;
};
class TrackedRoute {
  constructor(urlPathName, appRouteName, trackingRouteName) {
    __publicField(this, "getTrackingRouteName", () => this.trackingRouteName);
    this._instance_trackedRoute = true;
    this.urlPathName = urlPathName;
    this.appRouteName = appRouteName;
    this.trackingRouteName = trackingRouteName;
  }
}
const appRoutes = {
  PROMO_REDEMPTION_SUCCESS: "Promo Redemption Success",
  NO_AUTH_SPLASH: "No Auth Splash",
  SPLASH: "Splash",
  SPLASH_SIGN_IN: "Splash Sign In",
  SPLASH_SIGN_UP: "Splash Sign Up",
  DEV_TOOLS: "ModeSelect",
  DEV: "Dev",
  AUTHED_APP_INITIALIZATION: "AuthedAppInitialization",
  ONBOARDING_NAVIGATOR: "Onboarding Navigator",
  ONBOARDED_NAVIGATOR: "Onboarded Navigator",
  START_LIVE_TRADING_SIGN_UP: "StartLiveTradingSignUp",
  LT_INVESTING_EXPERIENCE: "LTInvestingExperience",
  NON_ONBOARDING_REGISTER_LIVE_TRADING_START: "Non-onboarding Register Live Trading Start",
  ENTER_NAME: "Enter Name",
  ENTER_ADDRESS: "Enter Address",
  ENTER_PHONE: "Enter Phone",
  INVESTOR_PROFILE: "InvestorProfile",
  IDENTITY: "Identity",
  ENTER_DATE_OF_BIRTH: "Enter Date of Birth",
  DISCLOSURES: "Disclosures",
  DISCLOSURES_EMPLOYMENT: "Disclosures Employment",
  AGREEMENTS: "Agreements",
  LIVE_ACCOUNT_SUBMITTED: "LiveAccountSubmitted",
  LT_REDEEM_REWARDS: "LiveTradingRedeemReferralRewards",
  ONBOARDING_FUNDING: "OnboardingFunding",
  ONBOARDING_ALMOST_THERE: "AlmostThereOnboarding",
  LT_FUNDING_DEPOSIT: "LiveTradingFundingTransfers",
  LT_DEFAULT_EXPECTED_RETURN: "LTDefaultExpectedReturn",
  START_PAPER_TRADING_SIGN_UP: "StartPaperTradingSignUp",
  PT_INVESTING_EXPERIENCE: "PTInvestingExperience",
  PT_DEFAULT_EXPECTED_RETURN: "PTDefaultExpectedReturn",
  START_ONBOARDING: "Onboarding",
  ONBOARDING_ACCOUNT_SELECTION: "OnboardingAccountSelection",
  BROKERAGE_ACCOUNT_OPT_IN: "OnboardingBrokerageAccountOptIn",
  HOME: "Home",
  NO_AUTH_ACTIVITY_FEED: "No Auth Feed",
  ACTIVITY_FEED: "Activity",
  DASHBOARD: "Dashboard",
  TRADE: "Trade",
  FUNDING: "Funding",
  COMMUNITY: "Community",
  TOOLS: "Tools",
  CLOSED_ACCOUNT: "ClosedAccount",
  SEARCH: "Search",
  EXPLORE: "Explore",
  OPTIMIZER: "Optimizer",
  AI_TOOL_SELECT: "AI Tool Select",
  COMPANY_SNAPSHOT: "Company Snapshot",
  COMPANY_SCREENER: "Company Screener",
  QUERY_TOOL: "Query Tool",
  AI_RESULT: "AI Result",
  QUERY_DOCUMENT_SELECTION_MODAL: "Query Doc Selection Modal",
  SECURITY_PAGE: "Security",
  FILTERED_SECURITY_LIST: "FilteredSecurityList",
  SECURITY_LIVE_PRICING: "SecurityLivePricing",
  SECURITY_FINANCIALS: "Security Financials",
  SECURITY_NEWS: "Security News",
  SECURITY_THOUGHTS: "Security Pros/Cons",
  SECURITY_CURRENT_POSITION: "Security Current Position",
  SECURITY_COMMUNITY: "Security Community",
  SECURITY_IDEAS: "Security Ideas",
  CREATE_ORDER: "NewOrder",
  CREATE_THOUGHT: "CreateThought",
  FAMOUS_INVESTORS_HOME: "FamousInvestors",
  FAMOUS_INVESTOR_PROFILE: "FamousInvestorProfile",
  CONTACTS_IMPORT: "ContactsImport",
  COMMUNITY_STANDALONE: "CommunityStandalone",
  COMMUNITY_SEARCH: "CommunitySearch",
  REFERRAL_ACTIONS: "ReferralActions",
  CONNECTIONS_LIST: "ConnectionsList",
  REWARDS: "Rewards",
  REDEEM_REWARDS: "RedeemReferralRewards",
  ACCOUNT: "Account",
  ACCOUNT_TRANSACTION_HISTORY: "Account Transaction History",
  LEGAL: "Legal",
  SUPPORT: "Support",
  CREATE_SUPPORT_REQUEST: "CreateSupportRequest",
  USER_SETTINGS: "UserSettings",
  PARTNER_SUBSCRIPTIONS: "PartnerSubscriptions",
  USER_PROFILE: "Profile",
  VIEWPOINT_PROFILE: "Viewpoint Profile",
  VIEWPOINT_EXPLORE: "Explore All Viewpoints",
  EDIT_USER_PROFILE: "EditProfile",
  CHANGE_EMAIL: "ChangeEmail",
  CHANGE_PASSWORD: "ChangePassword",
  UPDATE_PREFERENCES: "UpdatePreferences",
  UPDATE_LIVE_ACCOUNT: "UpdateLiveAccount",
  UPDATE_LIVE_ACCOUNT_FORM: "UpdateLiveAccountForm",
  LIVE_ACCOUNT_FURTHER_DOCUMENTATION_ENTRY: "LiveAccountFurtherDocumentationEntry",
  ONBOARDING_CONTACT_RESUBMIT: "OnboardingContactFormResubmit",
  CONTACT_RESUBMIT: "ContactFormResubmit",
  FUNDING_WITHDRAWAL: "FundingWithdrawal",
  FUNDING_DEPOSIT: "FundingDeposit",
  PAPER_FUNDING_TRANSFERS: "FundingTransferPaper",
  FUNDING_MODAL: "FundingModal",
  LINK_BANK_ACCOUNT: "LinkBankAccountModeSelection",
  LINK_BANK_ACCOUNT_PLAID: "LinkBankAccountPlaid",
  LINK_BANK_ACCOUNT_MICRO: "LinkBankAccountMicro",
  VERIFY_BANK_ACCOUNT: "VerifyBankAccount",
  MANAGE_BANK_ACCOUNTS: "ManageBankAccounts",
  MANAGE_RECURRING_DEPOSITS: "ManageRecurringDeposits",
  CREATE_RECURRING_DEPOSITS: "CreateRecurringDeposits",
  BANK_TRANSFER_HISTORY: "BankTransferHistory",
  DEPOSIT_EXECUTION: "DepositExecution",
  INTERESTS_SELECTION: "InterestsSelection",
  INTEREST_WATCHLIST: "InterestsWatchList",
  PROMPT_PICK_OWN_STOCKS: "PickOwnStocksPrompt",
  CTL_RESPONSE: "CtlResponse",
  TRENDING_STOCKS: "TrendingStocks",
  GETTING_REWARDS_INTERSTITIAL: "GettingRewardsInterstitial",
  AUDIO_LIBRARY: "AudioLibrary",
  NEWS_ARTICLE: "NewsArticle",
  CONTENT_READER: "ContentReader",
  CREATE_SHARE: "CreateShare",
  UPCOMING_EARNINGS: "UpcomingEarnings",
  THOUGHTS_LIST: "ThoughtsList",
  PRIVACY_SETTING_SELECT: "PrivacySettingSelect",
  SITE_DISCLOSURES: "Site Disclosures",
  LEARN: "Learn",
  LEARN_HOME: "Learn Home",
  LEARN_REWARD_EARNED: "Learn Reward Earned",
  LEARN_DISCLAIMERS: "Learn Disclaimers",
  LEARN_LESSONS_COMPLETED: "Learn Lessons Completed",
  FINISH_ACCOUNT_SETUP: "Finish Account Setup",
  TRUSTED_CONTACT: "Trusted Contact",
  PURCHASE_MEMBERSHIP: "Purchase Membership",
  PURCHASE_MEMBERSHIP_PLAN: "Purchase Membership Plan",
  INVESTING_JOURNEY: "Investing Journey",
  VIEWPOINT_WELCOME: "ViewpointWelcome",
  VIEWPOINT_SUBSCRIPTION_MANAGEMENT: "ViewpointSubscriptionManagement",
  VIEWPOINT_SUBSCRIPTION_SUCCESS: "ViewpointSubscriptionSuccess",
  PUSH_NOTIFICATION_DETAIL: "Push Notification Detail",
  ANNUAL_MEMBERSHIP_ACCOUNT_OPT_IN: "Annual Membership Account Opt-in",
  MODAL: "Modal",
  USER_LIST_MODAL: "UserListModal",
  CLOSE_ACCOUNT_MODAL: "CloseAccountModal",
  SKIPPING_SIGNUP_REWARD_MODAL: "SkippingSignupRewardModal",
  MORE_INFO_ON_MARGIN_ACCOUNTS: "MoreInfoOnMarginAccountsModal",
  REMOVE_CONNECTION_MODAL: "RemoveConnectionModal",
  VIEWPOINT_SUBSCRIPTION_CONFIRMATION_MODAL: "ViewpointSubscribeConfirmationModal",
  START_LIVE_TRADING_NOW_ACTION_MODAL: "Start Live Trading Now Action Modal",
  CANCEL_VIEWPOINT_SUBSCRIPTION_MODAL: "CancelViewpointSubscriptionModal",
  INVITE_BY_EMAIL: "AddInviteEmailMessage",
  INFO_ICON_EXPLANATION: "InfoIconExplanation",
  ADD_IDEA_WITH_IDEA_TYPE_SELECTION: "AddIdea-IdeaTypeSelection",
  SECURITY_SCREEN_ACTIONS: "SecurityScreenActions",
  RATE_APP_MODAL: "Rate App Modal",
  OTA_UPDATE_APP_MODAL: "OTA Update Prompt Modal",
  FINISH_ACCOUNT_SETUP_MODAL: "Finish Account Setup Modal",
  DEPOSIT_PROMO_MODAL: "Deposit Promo Modal",
  SELECTION_MODAL: "Selection Modal",
  CONFIRM_EMAIL_ADDRESS_MODAL: "Confirm Email Address Modal",
  DISCLOSURES_MODAL: "Disclosures Modal",
  DONT_MISS_OUT_SIGN_UP_BONUS_MODAL: "Dont Miss Out Sign Up Bonus Modal",
  WITHDRAWAL_FUNDING_BREAKDOWN: "Withdrawal Funding Breakdown Modal",
  BROKERAGE_TRANSFER_MODAL: "Brokerage ACAT Transfer Request Modal",
  ANNUAL_ACCOUNT_UPGRADE_MODAL: "Annual Account Upgrade Modal",
  IOS_DROPDOWN_MODAL: "iOS Dropdown Modal",
  SELECT_SINGLE_FORM_OF_CONTACT: "Select Single Form of Contact Modal",
  SHARE_LEARN_MODAL: "Share Learn Modal",
  ONBOARDING_WELCOME_VIDEO: "Onboarding Welcome Video Modal",
  PROMPT_ENABLE_PUSH_NOTIFICATIONS: "Prompt Enable Push Notifications Modal",
  LOGIN_TYPE_SELECTION_MODAL: "Login Type Selection Modal",
  PORTFOLIO_PRICING_UNAVAILABLE_MODAL: "Portfolio Pricing Unavailable Modal",
  GENERIC_FIXED_BOTTOM_MODAL: "Generic Fixed Bottom Modal"
};
const webappRoutes = {
  security: "/securities/:id",
  thoughtWithSlug: "/thoughts/:id/:thoughtSlug",
  thought: "/thoughts/:id",
  featuredViewpoints: "/viewpoint_contributors/featured",
  manageViewpoints: "/viewpoint_contributors/manage",
  viewpointProfile: "/viewpoint_contributors/:name",
  bdTerms: "/terms",
  socureDocSubmission: "/live-account-submission-status",
  resubmitAddress: "/resubmit-address",
  uploadDocuments: "/upload-required-documents",
  onboardingUploadDocuments: "/live_accounts/documentation",
  liveAccountSubmitConfirmation: "/live_accounts/confirmation",
  onboardingAlmostThere: "/almost-there",
  agreements: "/live_accounts/agreements",
  disclosures: "/live_accounts/disclosures",
  disclosuresEmployment: "/live_accounts/disclosures-employment",
  identity: "/live_accounts/identity",
  contact: "/live_accounts/contact",
  investorProfile: "/live_accounts/investor_profile",
  inviteFriends: "/invite-friends",
  trade: "/orders",
  myIdeas: "/ideas",
  onboardResumeProgress: "/onboard",
  portfolio: "/portfolio",
  portfolioHistory: "/portfolio/history",
  portfolioFunding: "/portfolio/funding",
  funding: "/funding",
  recurringDeposits: "/funding/recurring-deposits",
  createRecurringDeposits: "/funding/schedule-new-recurring-deposit",
  linkBank: "/funding/link-bank",
  withdrawFunds: "/funding/withdraw",
  depositFunds: "/funding/deposit",
  usersSignup: "/users/sign_up",
  login: "/login",
  signup: "/signup",
  editProfile: "/users/edit",
  connections: "/users/connections",
  userProfile: "/users/:id/public_profile",
  thoughtLeaders: "/users/thought_leaders",
  privacySettings: "/privacy_settings",
  ask: "/ask",
  rewards: "/referrals",
  rewardRedemption: "/rewards_redemption",
  learnAndEarn: "/learn-and-earn",
  learnAndEarnProgress: "/learn-and-earn-progress",
  learnAndEarnMoreInfo: "/learn-and-earn-more-info",
  selectAccountType: "/account_type",
  brokerage_account_opt_in: "/brokerage_account",
  investingExperience: "/investing_experience",
  subscriptions: "/subscriptions",
  membership: "/membership",
  portfolioExplorer: "/ideas/portfolio_explorer",
  popularStocks: "/ideas/community",
  inviteFriendsFromPlatform: "/invites/provider",
  inviteFriendsFromPlatformSuccess: "/invites/:network/contact_callback",
  inviteFriendsFromPlatformFailure: "/invites/:network/contact_failure",
  inviteContactsFailure: "/contacts/failure",
  trustedContact: "/trusted-contact",
  legal: "/legal",
  faq: "/faq",
  marginDisclosure: "/margin_disclosure",
  privacyPolicy: "/privacy_policy",
  tos: "/terms_of_service",
  tosNvstrFinancial: "/terms_of_service_nvstr_financial",
  tosNvstrTechnologies: "/terms_of_service_nvstr_technologies",
  referralRules: "/referral_rules",
  viewpointGuidelines: "/viewpoint_guidelines",
  shareLink: "/share/:token",
  eDocuments: "/documents",
  dashboard: "/",
  finishAccountSetup: "/finish-account-setup"
};
const PRODUCT_PLATFORMS = {
  mobileApp: "mobileApp",
  webApp: "webApp"
};
const trackingEvents = {
  identify: "identify",
  accountTypeSelected: "Account Type Selected",
  completeApexAccount: "Complete Apex Account",
  bankLinkSkipped: "Bank Link Skipped",
  buttonClicked: "Button Clicked",
  feedLoaded: "Feed Loaded",
  ideaViewed: "Idea Viewed",
  modalViewed: "Modal Viewed",
  onboardingCompleted: "Onboarding Completed",
  onboardingFundingSkipped: "Onboarding Funding Skipped",
  proConViewed: "Pro/Con Viewed",
  tabViewed: "Tab Viewed",
  pageViewed: "Page Viewed",
  learnLessonViewed: "Learn and Earn Lesson Viewed",
  learnLessonRewardViewed: "Learn and Earn Reward Viewed",
  learnLessonDisclaimerViewed: "Learn and Earn Disclaimer Viewed",
  securityViewed: "Security Viewed",
  signUpCreated: "Sign Up Created",
  userCreated: "User Created",
  viewpointSubscriptionPaid: "Viewpoint Subscription Paid",
  screenViewed: "Screen Viewed",
  bankLinked: "Bank Linked",
  brokerageAccountApproved: "Brokerage Account Approved",
  brokerageAccountCreated: "Brokerage Account Created",
  brokerageAccountSubmitted: "Brokerage Account Submitted",
  creditCardLinked: "Credit Card Linked",
  depositCompleted: "Deposit Completed",
  depositReturned: "Deposit Returned",
  depositSkipped: "Deposit Skipped",
  depositSubmitted: "Deposit Submitted",
  emailConfirmed: "Email Confirmed",
  highEquityReached: "High Equity Reached",
  ideaCopied: "Idea Copied",
  ideaCreated: "Idea Created",
  membershipPaid: "Membership Paid",
  orderCommissionPaid: "Order Commission Paid",
  orderExecuted: "Order Executed",
  orderPlaced: "Order Placed",
  orderScreenViewed: "Order Screen Viewed",
  proConCreated: "Pro/Con Created"
};
const types = {
  string: "string",
  number: "number",
  boolean: "boolean",
  object: "object"
};
class CommonValidationType {
  constructor(type, required, props = {}) {
    __publicField(this, "schema", {});
    __publicField(this, "isRequired", false);
    this.schema = __spreadValues({
      type
    }, props);
    this.isRequired = required;
  }
}
class StringType extends CommonValidationType {
  constructor(required, props = {}) {
    super(types.string, required, props);
  }
}
class NumberType extends CommonValidationType {
  constructor(required, props = {}) {
    super(types.number, required, props);
  }
}
class BooleanType extends CommonValidationType {
  constructor(required, props = {}) {
    super(types.boolean, required, props);
  }
}
class ObjectType {
  constructor(object = {}, config = {}) {
    __publicField(this, "schema", {});
    this.schema = __spreadProps(__spreadValues({
      type: types.object,
      properties: Object.entries(object).reduce((acc, cur) => {
        return __spreadProps(__spreadValues({}, acc), {
          [cur[0]]: cur[1].schema
        });
      }, {})
    }, config), {
      required: Object.entries(object).filter(([k, v]) => {
        return v.isRequired;
      }).map(([k]) => k)
    });
  }
}
const getEnumAsArray = (obj) => Object.values(obj);
const account_types = {
  live: "live",
  simulated: "simulated"
};
const account_types_enum$1 = getEnumAsArray(account_types);
const button_types = {
  button: "button",
  link: "link"
};
const button_types_enum$1 = getEnumAsArray(button_types);
const node_location = {
  body: "body",
  footer: "footer",
  header: "header"
};
const node_location_enum$1 = getEnumAsArray(node_location);
const platform = {
  android: "android",
  ios: "ios",
  web: "web"
};
const platform_enum$1 = getEnumAsArray(platform);
const idea_types = {
  buy: "buy",
  sell: "sell"
};
const idea_types_enum$1 = getEnumAsArray(idea_types);
const pro_or_con = {
  con: "con",
  pro: "pro"
};
const pro_or_con_enum$1 = getEnumAsArray(pro_or_con);
var enums = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getEnumAsArray,
  account_types,
  account_types_enum: account_types_enum$1,
  button_types,
  button_types_enum: button_types_enum$1,
  node_location,
  node_location_enum: node_location_enum$1,
  platform,
  platform_enum: platform_enum$1,
  idea_types,
  idea_types_enum: idea_types_enum$1,
  pro_or_con,
  pro_or_con_enum: pro_or_con_enum$1
}, Symbol.toStringTag, { value: "Module" }));
const { account_types_enum, button_types_enum, node_location_enum, platform_enum, idea_types_enum, pro_or_con_enum } = enums;
({
  [trackingEvents.identify]: new ObjectType({}, { additionalProperties: true }).schema,
  [trackingEvents.accountTypeSelected]: new ObjectType({
    "account_type": new StringType(true, {
      enum: account_types_enum
    })
  }, { additionalProperties: false }).schema,
  [trackingEvents.bankLinkSkipped]: {},
  [trackingEvents.buttonClicked]: new ObjectType({
    "button_type": new StringType(true, {
      enum: button_types_enum
    }),
    "context": new StringType(true),
    "description": new StringType(true),
    "position": new StringType(true, {
      enum: node_location_enum
    }),
    "platform": new StringType(true, {
      enum: platform_enum
    })
  }, { "additionalProperties": false }).schema,
  [trackingEvents.feedLoaded]: new ObjectType({
    "item_count": new NumberType(true)
  }).schema,
  [trackingEvents.ideaViewed]: new ObjectType({
    "context": new StringType(true),
    "idea_type": new StringType(true, { enum: idea_types_enum }),
    "ticker_symbol": new StringType(true)
  }, { "additionalProperties": false }).schema,
  [trackingEvents.modalViewed]: new ObjectType({
    "context": new StringType(true),
    "is_error": new BooleanType(true),
    "message": new StringType(true),
    "modal_type": new StringType(true)
  }, { "additionalProperties": false }).schema,
  [trackingEvents.onboardingCompleted]: {},
  [trackingEvents.onboardingFundingSkipped]: {},
  [trackingEvents.pageViewed]: new ObjectType({
    "location": new StringType(true)
  }),
  [trackingEvents.proConViewed]: new ObjectType({
    "context": new StringType(true),
    "pro_or_con": new StringType(true, { enum: pro_or_con_enum }),
    "ticker_symbol": new StringType(true)
  }, { "additionalProperties": false }).schema,
  [trackingEvents.tabViewed]: new ObjectType({
    "context": new StringType(true),
    "platform": new StringType(true, { enum: platform_enum }),
    "position": new StringType(true, { enum: node_location_enum }),
    "description": new StringType(true)
  }, { "additionalProperties": false }).schema
});
const COLOR_THEME_NAMES = {
  aiLight: "ai-analyst-light-color-scheme",
  aiDark: "ai-analyst-dark-color-scheme",
  light: "light-color-scheme",
  dark: "dark-color-scheme",
  theStreet: "the-street-color-scheme",
  custom: "custom-color-scheme"
};
const _tornadoColorPalette = {
  primary: {
    charcoal: "#1f1f1f",
    oak: "#F7F4F2",
    white: "#fff",
    whiteBlueTint: "#F1F5F5"
  },
  secondary: {
    yellow: "#fcfe7d",
    navy: "#211e2c",
    black: "#000",
    blackTransparent: "rgba(30,30,30,0.1)",
    white: "#fff",
    whiteTransparent: "rgba(255,255,255,0.3)",
    cyan: "#9ffbf5",
    blue: "#0000FF",
    darkBlue: "#104a72",
    streetBlue: "#0D4D99",
    streetGreen: "#080",
    streetRed: "#ff0000",
    lightBlue: "#7AC9EA",
    purple: "#6d56fb",
    promoPurple: "#5937f9",
    darkPurple: "#201F2C",
    lavender: "#dcdbff",
    red: "#f5665d",
    green: "#7ecb00",
    brightGreen: "#1AD36F",
    brightRed: "#FF5000",
    darkRed: "#bc332c",
    darkGreen: "#067915",
    silver: "#c0c0c0",
    lightCharcoal: "#343434",
    orange: "rgb(255,156,34)",
    cream: "#F6F3EF",
    lighterGrey: "rgb(235,235,235)",
    osGrey: "rgb(218,224,227)",
    cloud: "#777777",
    darkCloud: "#333",
    lightCloud: "#fafafa"
  },
  element: {
    borderLight: "rgba(31,31,31, 0.05)",
    borderDark: "rgba(247,244,242, 0.05)"
  }
};
const colorPalette = _tornadoColorPalette;
const { charcoal, oak } = colorPalette.primary;
const {
  white,
  darkCloud,
  lightCloud,
  cloud,
  streetBlue,
  streetGreen,
  streetRed,
  orange,
  purple,
  lightCharcoal,
  green,
  red,
  darkRed,
  brightGreen,
  yellow,
  lightBlue
} = colorPalette.secondary;
({
  [COLOR_THEME_NAMES.light]: {
    header: white,
    appBackground: oak,
    componentNoOpacity: white,
    text: charcoal,
    buttonText: white,
    proColor: brightGreen,
    conColor: red,
    neutral: lightCharcoal,
    negative: red,
    positive: brightGreen,
    inputBg: "transparent",
    avatarBackgroundColor: purple,
    buttonColor: purple,
    primaryCtaButton: purple,
    primaryEyeCatchingCtaButton: lightBlue,
    badge: purple,
    error: red,
    warning: orange,
    hoverComponentBackground: convertHexToRGBA$1(purple, 0.1),
    component: convertHexToRGBA$1(white, 0.9),
    disabled: convertHexToRGBA$1(charcoal, 0.05),
    overlay: convertHexToRGBA$1(charcoal, 0.6),
    border: convertHexToRGBA$1(charcoal, 0.2),
    lowContrastBorder: convertHexToRGBA$1(charcoal, 0.05),
    secondaryText: convertHexToRGBA$1(charcoal, 0.5)
  },
  [COLOR_THEME_NAMES.dark]: {
    header: charcoal,
    appBackground: charcoal,
    component: lightCharcoal,
    componentNoOpacity: convertHexToRGBA$1(lightCharcoal, 1),
    disabled: convertHexToRGBA$1(white, 0.05),
    overlay: convertHexToRGBA$1(oak, 0.4),
    border: convertHexToRGBA$1(oak, 0.2),
    lowContrastBorder: convertHexToRGBA$1(oak, 0.05),
    text: white,
    secondaryText: convertHexToRGBA$1(white, 0.4),
    buttonText: charcoal,
    proColor: brightGreen,
    conColor: red,
    neutral: white,
    negative: red,
    positive: brightGreen,
    inputBg: "transparent",
    badge: yellow,
    avatarBackgroundColor: yellow,
    buttonColor: yellow,
    primaryCtaButton: yellow,
    primaryEyeCatchingCtaButton: lightBlue,
    error: red,
    warning: orange,
    hoverComponentBackground: convertHexToRGBA$1(yellow, 0.1)
  },
  [COLOR_THEME_NAMES.theStreet]: {
    header: white,
    appBackground: lightCloud,
    darkerAppBackground: cloud,
    component: convertHexToRGBA$1(white, 0.9),
    componentNoOpacity: convertHexToRGBA$1(white, 1),
    disabled: convertHexToRGBA$1(darkCloud, 0.05),
    overlay: convertHexToRGBA$1(darkCloud, 0.6),
    border: convertHexToRGBA$1(darkCloud, 0.2),
    lowContrastBorder: convertHexToRGBA$1(darkCloud, 0.05),
    text: darkCloud,
    secondaryText: convertHexToRGBA$1(darkCloud, 0.6),
    badge: streetBlue,
    proColor: streetGreen,
    conColor: streetRed,
    neutral: cloud,
    negative: streetRed,
    warning: orange,
    positive: streetGreen,
    avatarBackgroundColor: streetBlue,
    inputBg: "transparent",
    buttonColor: streetBlue,
    primaryCtaButton: streetBlue,
    buttonText: white,
    primaryEyeCatchingCtaButton: streetBlue,
    error: streetRed,
    hoverComponentBackground: convertHexToRGBA$1(streetBlue, 0.5)
  }
});
const breakpoints = {
  mobile: "768px",
  table: "1024px",
  desktop: "1368px"
};
const SCREEN_SIZES = {
  mobile: "mobile",
  tablet: "tablet",
  desktop: "desktop"
};
class TrackedRouteStore {
  constructor() {
    __publicField(this, "addTrackedRoute", (trackedRoute) => {
      if (!trackedRoute._instance_trackedRoute)
        throw Error;
      this.trackedRoutes.push(trackedRoute);
    });
    __publicField(this, "getTrackingNameForWebappRoute", (urlPathName) => {
      const webappTrackedRoutesLookup = this._buildWebappTrackedRoutesLookup();
      if (webappTrackedRoutesLookup[urlPathName])
        return webappTrackedRoutesLookup[urlPathName].trackingRouteName;
      const _mutatable_dirs = urlPathName.split("/");
      if (_mutatable_dirs.length === 1)
        return null;
      _mutatable_dirs[_mutatable_dirs.length - 1] = "*";
      const wildCardPath = _mutatable_dirs.join("/");
      if (webappTrackedRoutesLookup[wildCardPath])
        return webappTrackedRoutesLookup[wildCardPath].trackingRouteName;
      if (_mutatable_dirs.length === 2)
        return null;
      _mutatable_dirs[_mutatable_dirs.length - 2] = "*";
      const doubleWildCardPath = _mutatable_dirs.join("/");
      if (webappTrackedRoutesLookup[doubleWildCardPath])
        return webappTrackedRoutesLookup[doubleWildCardPath].trackingRouteName;
      const modelDetailDirs = urlPathName.split("/");
      modelDetailDirs[_mutatable_dirs.length - 2] = "*";
      const modelDetailWildCardPath = modelDetailDirs.join("/");
      if (webappTrackedRoutesLookup[modelDetailWildCardPath])
        return webappTrackedRoutesLookup[modelDetailWildCardPath].trackingRouteName;
      return null;
    });
    __publicField(this, "getTrackingNameForAppRoute", (routeName) => {
      const matchingTrackedRoutes = this.trackedRoutes.filter((trackedRoute) => trackedRoute.appRouteName === routeName);
      if (matchingTrackedRoutes.length > 1) {
        console.warn("multiple matched routes");
      }
      const matchedRoute = matchingTrackedRoutes[0];
      return (matchedRoute == null ? void 0 : matchedRoute.trackingRouteName) || null;
    });
    __publicField(this, "getTrackingNameForRoute", (route, platform2) => {
      if (platform2 === PRODUCT_PLATFORMS.mobileApp) {
        return this.getTrackingNameForAppRoute(route);
      }
      if (platform2 === PRODUCT_PLATFORMS.webApp) {
        return this.getTrackingNameForWebappRoute(route);
      }
    });
    __publicField(this, "_buildWebappTrackedRoutesLookup", () => {
      const insertWildCard = (url) => {
        const dirs = url.split("/");
        const dirsWithWildCards = dirs.map((dir) => dir[0] === ":" ? "*" : dir);
        return dirsWithWildCards.join("/");
      };
      const routes = [];
      this.trackedRoutes.forEach((trackedRoute) => {
        const webappUrl = trackedRoute.urlPathName;
        if (webappUrl !== null) {
          routes.push(trackedRoute);
        }
      });
      const lookup = {};
      routes.forEach((trackedRoute) => {
        lookup[insertWildCard(trackedRoute.urlPathName)] = trackedRoute;
      });
      return lookup;
    });
    __publicField(this, "_scanForMissingWebappRoutes", () => {
      const missingRoutes = [];
      const { routes: allWebappTrackedRoutes, duplicatedRoutes } = this._getAllWebappTrackedRoutes();
      const allWebappRouteEntries = Object.entries(webappRoutes);
      allWebappRouteEntries.forEach((entry) => {
        const [routeName, route] = entry;
        if (!allWebappTrackedRoutes.includes(route)) {
          missingRoutes.push({ routeName, route });
        }
      });
      return {
        missingRoutes,
        duplicatedRoutes
      };
    });
    __publicField(this, "_scanForMissingAppRoutes", () => {
      const missingRoutes = [];
      const { routes: allAppTrackedRoutes, duplicatedRoutes } = this._getAllAppTrackedRoutes();
      const allAppRouteEntries = Object.entries(appRoutes);
      allAppRouteEntries.forEach((entry) => {
        const [routeName, route] = entry;
        if (!allAppTrackedRoutes.includes(route)) {
          missingRoutes.push({ routeName, route });
        }
      });
      return {
        missingRoutes,
        duplicatedRoutes
      };
    });
    __publicField(this, "_getAllAppTrackedRoutes", () => {
      const routes = [];
      const duplicatedRoutes = [];
      this.trackedRoutes.forEach((trackedRoute) => {
        const webappUrl = trackedRoute.appRouteName;
        if (webappUrl !== null) {
          if (routes.includes(webappUrl)) {
            duplicatedRoutes.push(webappUrl);
          } else {
            routes.push(webappUrl);
          }
        }
      });
      return {
        routes,
        duplicatedRoutes
      };
    });
    __publicField(this, "_getAllWebappTrackedRoutes", () => {
      const routes = [];
      const duplicatedRoutes = [];
      this.trackedRoutes.forEach((trackedRoute) => {
        const webappUrl = trackedRoute.urlPathName;
        if (webappUrl !== null) {
          if (routes.includes(webappUrl)) {
            duplicatedRoutes.push(webappUrl);
          } else {
            routes.push(webappUrl);
          }
        }
      });
      return {
        routes,
        duplicatedRoutes
      };
    });
    this.trackedRoutes = [];
  }
}
const _trackedRouteStore = new TrackedRouteStore();
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.security, appRoutes.SECURITY_PAGE, "Security"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_FINANCIALS, "Security Financials"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_NEWS, "Security News"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_THOUGHTS, "Security Pros/Cons"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_CURRENT_POSITION, "Security Current Position"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_COMMUNITY, "Security Community"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_IDEAS, "Security Ideas"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.thoughtWithSlug, null, "Thought"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.thought, null, "Thought"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.VIEWPOINT_EXPLORE, "View All Viewpoints"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.featuredViewpoints, appRoutes.VIEWPOINT_WELCOME, "Featured Viewpoints"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.manageViewpoints, appRoutes.VIEWPOINT_SUBSCRIPTION_MANAGEMENT, "Viewpoints Management"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.viewpointProfile, appRoutes.VIEWPOINT_PROFILE, "Viewpoint Profile"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.bdTerms, null, "BD Terms"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.socureDocSubmission, appRoutes.LIVE_ACCOUNT_FURTHER_DOCUMENTATION_ENTRY, "Socure Document Upload"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ONBOARDING_CONTACT_RESUBMIT, "Address Resubmit"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.resubmitAddress, appRoutes.CONTACT_RESUBMIT, "Address Resubmit"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.uploadDocuments, null, "Upload Documents"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.onboardingUploadDocuments, null, "Upload Documents (Onboarding)"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.liveAccountSubmitConfirmation, appRoutes.LIVE_ACCOUNT_SUBMITTED, "Live Account Submit Confirmation"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.onboardingAlmostThere, appRoutes.ONBOARDING_ALMOST_THERE, "Onboarding Almost There"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ONBOARDING_FUNDING, "Funding"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.NON_ONBOARDING_REGISTER_LIVE_TRADING_START, "Non-onboarding Register Live Trading Start"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ENTER_NAME, "Enter Name"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ENTER_ADDRESS, "Enter Contact Address"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ENTER_PHONE, "Enter Phone Number"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.agreements, appRoutes.AGREEMENTS, "Agreements"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.disclosures, appRoutes.DISCLOSURES, "Disclosures"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.disclosuresEmployment, appRoutes.DISCLOSURES_EMPLOYMENT, "Disclosures Employment"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.identity, appRoutes.IDENTITY, "Identity"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ENTER_DATE_OF_BIRTH, "Enter Date of Birth"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.contact, null, "Contact"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.investorProfile, appRoutes.INVESTOR_PROFILE, "Investor Profile"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.onboardResumeProgress, appRoutes.START_ONBOARDING, "Resume Onboarding"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.selectAccountType, appRoutes.ONBOARDING_ACCOUNT_SELECTION, "Account Type Selection"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.brokerage_account_opt_in, appRoutes.BROKERAGE_ACCOUNT_OPT_IN, "Brokerage Account Opt-In"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.investingExperience, appRoutes.LT_INVESTING_EXPERIENCE, "Investing Experience Select"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PT_INVESTING_EXPERIENCE, "Investing Experience Select"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LT_DEFAULT_EXPECTED_RETURN, "Default Expected Return Select"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PT_DEFAULT_EXPECTED_RETURN, "Default Expected Return Select"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.START_PAPER_TRADING_SIGN_UP, "Start Paper Trading Signup"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CLOSED_ACCOUNT, "Closed Account"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PARTNER_SUBSCRIPTIONS, "Partner Subscriptions"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SEARCH, "Search"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.EXPLORE, "Explore"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.FILTERED_SECURITY_LIST, "Filtered Security List"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SECURITY_LIVE_PRICING, "Security Live Pricing"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CREATE_ORDER, "Create Trade"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CREATE_THOUGHT, "Create Thought"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CONTACTS_IMPORT, "Contacts Import"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.COMMUNITY_SEARCH, "Community Search"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CONNECTIONS_LIST, "Connections List"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ACCOUNT, "Account Settings"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.USER_SETTINGS, "User Settings"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.legal, appRoutes.LEGAL, "Legal Links"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SUPPORT, "Support"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CREATE_SUPPORT_REQUEST, "Create Support Request"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CHANGE_EMAIL, "Change Email"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CHANGE_PASSWORD, "Change Password"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.UPDATE_PREFERENCES, "Update Preferences"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.UPDATE_LIVE_ACCOUNT, "Update Live Account"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.UPDATE_LIVE_ACCOUNT_FORM, "Update Live Account Form"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.IOS_DROPDOWN_MODAL, "IOS Dropdown Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SELECT_SINGLE_FORM_OF_CONTACT, "Select Single Form Of Contact Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SHARE_LEARN_MODAL, "Share Learn Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ONBOARDING_WELCOME_VIDEO, "Onboarding Welcome Video Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PROMPT_ENABLE_PUSH_NOTIFICATIONS, "Prompt Enable Push Notifications Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LOGIN_TYPE_SELECTION_MODAL, "Login Type Selection Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PORTFOLIO_PRICING_UNAVAILABLE_MODAL, "Portfolio Pricing Unavailable Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.GENERIC_FIXED_BOTTOM_MODAL, "Generic Fixed Bottom Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.linkBank, appRoutes.LINK_BANK_ACCOUNT, "Link Bank Account Method Selection"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LINK_BANK_ACCOUNT_PLAID, "Link Bank Account Plaid"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LINK_BANK_ACCOUNT_MICRO, "Link Bank Account Micro"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.VERIFY_BANK_ACCOUNT, "Verify Bank Account"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.FUNDING_MODAL, "Funding Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.recurringDeposits, appRoutes.MANAGE_RECURRING_DEPOSITS, "Manage Recurring Deposits"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.createRecurringDeposits, appRoutes.CREATE_RECURRING_DEPOSITS, "Create Recurring Deposits"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.MANAGE_BANK_ACCOUNTS, "Manage Bank Account"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.BANK_TRANSFER_HISTORY, "Bank Transfer History"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.DEPOSIT_EXECUTION, "Deposit Execution"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.INTERESTS_SELECTION, "Interests Selection"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.INTEREST_WATCHLIST, "Interests Watchlist"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PROMPT_PICK_OWN_STOCKS, "Pick Own Stocks Prompt"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CTL_RESPONSE, "CTL Response"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.TRENDING_STOCKS, "Trending Stocks"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.GETTING_REWARDS_INTERSTITIAL, "Fetching Rewards"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.UPCOMING_EARNINGS, "Upcoming Earnings"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.THOUGHTS_LIST, "Thought List"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.AUDIO_LIBRARY, "Audio Library"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.INVESTING_JOURNEY, "Investing Journey"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.NEWS_ARTICLE, "News Article"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.CONTENT_READER, "Content Reader"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SITE_DISCLOSURES, "Site Disclosures"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PUSH_NOTIFICATION_DETAIL, "Push Notification Detail"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.dashboard, null, "Webapp Dashboard"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.portfolio, appRoutes.DASHBOARD, "Portfolio"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.NO_AUTH_ACTIVITY_FEED, "No Auth Activity Feed"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ACTIVITY_FEED, "Activity Feed"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.trade, appRoutes.TRADE, "Trade"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.portfolioFunding, appRoutes.FUNDING, "Funding"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.funding, null, "Funding"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.withdrawFunds, appRoutes.FUNDING_WITHDRAWAL, "Funding Transfer - Withdrawal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.depositFunds, appRoutes.FUNDING_DEPOSIT, "Funding Transfer - Deposit"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PAPER_FUNDING_TRANSFERS, "Funding Transfer"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LT_FUNDING_DEPOSIT, "Funding Transfer (Onboarding)"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.myIdeas, null, "My Ideas"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.connections, appRoutes.COMMUNITY, "Community"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.connections, appRoutes.COMMUNITY_STANDALONE, "Community"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.connections, appRoutes.TOOLS, "Tools"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.portfolioHistory, appRoutes.ACCOUNT_TRANSACTION_HISTORY, "Account History"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.eDocuments, null, "E Documents"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.usersSignup, null, "Signup"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.SPLASH, "Splash"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.NO_AUTH_SPLASH, "No Auth Splash"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.login, appRoutes.SPLASH_SIGN_IN, "Login"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.signup, appRoutes.SPLASH_SIGN_UP, "Signup"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.editProfile, appRoutes.EDIT_USER_PROFILE, "Edit User Profile"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.privacySettings, appRoutes.PRIVACY_SETTING_SELECT, "Select Privacy Setting"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.userProfile, appRoutes.USER_PROFILE, "User Profile"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.thoughtLeaders, appRoutes.FAMOUS_INVESTORS_HOME, "Thought Leaders"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.FAMOUS_INVESTOR_PROFILE, "Thought Leader Profile"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.ask, appRoutes.CREATE_SHARE, "Create Ask"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.inviteFriends, appRoutes.REFERRAL_ACTIONS, "All Referral Actions"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.rewards, appRoutes.REWARDS, "Rewards"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.rewardRedemption, appRoutes.REDEEM_REWARDS, "Redeem Rewards"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LT_REDEEM_REWARDS, "Redeem Rewards"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.learnAndEarn, appRoutes.LEARN, "Learn and Earn Lesson"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.learnAndEarnProgress, appRoutes.LEARN_LESSONS_COMPLETED, "Learn and Earn Progress"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.learnAndEarnMoreInfo, appRoutes.LEARN_DISCLAIMERS, "Learn and Earn More Info"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LEARN_REWARD_EARNED, "Learn and Earn Reward Earned"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.LEARN_HOME, "Learn and Earn Home"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.ANNUAL_MEMBERSHIP_ACCOUNT_OPT_IN, "Annual Membership Opt-in"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.AI_TOOL_SELECT, "Digital Analyst Tool Select"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.COMPANY_SNAPSHOT, "Company Snapshot"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.COMPANY_SCREENER, "Company Screener"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.QUERY_TOOL, "Digital Analyst Query Tool"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.AI_RESULT, "Digital Analyst Answer"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.QUERY_DOCUMENT_SELECTION_MODAL, "Query Document Selection Modal"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.OPTIMIZER, "Portfolio Optimizer"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.portfolioExplorer, null, "Portfolio Explorer"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.popularStocks, null, "Popular Stocks"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.subscriptions, null, "Subscriptions Payment"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.membership, null, "Membership Payment"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.inviteFriendsFromPlatform, null, "Invite Friends From Platform"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.inviteFriendsFromPlatformSuccess, null, "Invite Friends From Platform - Success"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.inviteFriendsFromPlatformFailure, null, "Invite Friends From Platform - Failure"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.inviteContactsFailure, null, "Contact Import Failure"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.trustedContact, appRoutes.TRUSTED_CONTACT, "Trusted Contact Form"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PURCHASE_MEMBERSHIP, "Purchase Membership"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PURCHASE_MEMBERSHIP_PLAN, "Purchase Membership Plan"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.faq, null, "FAQ"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.marginDisclosure, null, "Margin Disclosure"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.privacyPolicy, null, "Privacy Policy"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.tos, null, "Terms of Service"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.tosNvstrFinancial, null, "Terms of Service - Nvstr Financial"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.tosNvstrTechnologies, null, "Terms of Service - Nvstr Technologies"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.referralRules, null, "Referral Rules"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.viewpointGuidelines, null, "Viewpoint Contributor Guidelines"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.shareLink, null, "Share Link Visited (Already Logged In)"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.DEV_TOOLS, "Dev Tools"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.DEV, "Dev"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.AUTHED_APP_INITIALIZATION, "App Loading"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.START_LIVE_TRADING_SIGN_UP, "Start Live Trading"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.PROMO_REDEMPTION_SUCCESS, "Promo Redemption Success"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(null, appRoutes.VIEWPOINT_SUBSCRIPTION_SUCCESS, "Viewpoint Subscription Success"));
_trackedRouteStore.addTrackedRoute(new TrackedRoute(webappRoutes.finishAccountSetup, appRoutes.FINISH_ACCOUNT_SETUP, "Finish Account Setup"));
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal$1, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
      var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
      return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
    } }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, v = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date())
        return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return t2 === void 0;
    } }, g = "en", D = {};
    D[g] = M;
    var p = function(t2) {
      return t2 instanceof _;
    }, S = function t2(e2, n2, r2) {
      var i2;
      if (!e2)
        return g;
      if (typeof e2 == "string") {
        var s2 = e2.toLowerCase();
        D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
        var u2 = e2.split("-");
        if (!i2 && u2.length > 1)
          return t2(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i2 = a2;
      }
      return !r2 && i2 && (g = i2), i2 || !r2 && g;
    }, w = function(t2, e2) {
      if (p(t2))
        return t2.clone();
      var n2 = typeof e2 == "object" ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _(n2);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t2, e2) {
      return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t2) {
        this.$L = S(t2.locale, null, true), this.parse(t2);
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (e2 === null)
            return new Date(NaN);
          if (O.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if (typeof e2 == "string" && !/Z$/i.test(e2)) {
            var r2 = e2.match($);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.$x = t2.x || {}, this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return O;
      }, m2.isValid = function() {
        return !(this.$d.toString() === l);
      }, m2.isSame = function(t2, e2) {
        var n2 = w(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return w(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < w(t2);
      }, m2.$g = function(t2, e2, n2) {
        return O.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!O.u(e2) || e2, h2 = O.p(t2), l2 = function(t3, e3) {
          var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, $2 = function(t3, e3) {
          return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
        switch (h2) {
          case c:
            return r2 ? l2(1, 0) : l2(31, 11);
          case f:
            return r2 ? l2(1, M3) : l2(0, M3 + 1);
          case o:
            var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
            return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d:
            return $2(v2 + "Hours", 0);
          case u:
            return $2(v2 + "Minutes", 1);
          case s:
            return $2(v2 + "Seconds", 2);
          case i:
            return $2(v2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = O.p(t2), h2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = h2 + "Date", n2[d] = h2 + "Date", n2[f] = h2 + "Month", n2[c] = h2 + "FullYear", n2[u] = h2 + "Hours", n2[s] = h2 + "Minutes", n2[i] = h2 + "Seconds", n2[r] = h2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === f || o2 === c) {
          var y2 = this.clone().set(d, 1);
          y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          l2 && this.$d[l2]($2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[O.p(t2)]();
      }, m2.add = function(r2, h2) {
        var d2, l2 = this;
        r2 = Number(r2);
        var $2 = O.p(h2), y2 = function(t2) {
          var e2 = w(l2);
          return O.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
        };
        if ($2 === f)
          return this.set(f, this.$M + r2);
        if ($2 === c)
          return this.set(c, this.$y + r2);
        if ($2 === a)
          return y2(1);
        if ($2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return O.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || l;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h2 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
        }, c2 = function(t3) {
          return O.s(s2 % 12 || 12, t3, "0");
        }, d2 = n2.meridiem || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        }, $2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h2(n2.monthsShort, a2, f2, 3), MMMM: h2(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h2(n2.weekdaysMin, this.$W, o2, 2), ddd: h2(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
        return r2.replace(y, function(t3, e3) {
          return e3 || $2[t3] || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, l2) {
        var $2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, v2 = this - M3, g2 = O.m(this, M3);
        return g2 = ($2 = {}, $2[c] = g2 / 12, $2[f] = g2, $2[h] = g2 / 3, $2[o] = (v2 - m3) / 6048e5, $2[a] = (v2 - m3) / 864e5, $2[u] = v2 / n, $2[s] = v2 / e, $2[i] = v2 / t, $2)[y2] || v2, l2 ? g2 : O.a(g2);
      }, m2.daysInMonth = function() {
        return this.endOf(f).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2)
          return this.$L;
        var n2 = this.clone(), r2 = S(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return O.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), T = _.prototype;
    return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
      T[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), w.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _, w), t2.$i = true), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
      return w(1e3 * t2);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var relativeTime$1 = { exports: {} };
(function(module, exports) {
  !function(r, e) {
    module.exports = e();
  }(commonjsGlobal$1, function() {
    return function(r, e, t) {
      r = r || {};
      var n = e.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function i(r2, e2, t2, o2) {
        return n.fromToBase(r2, e2, t2, o2);
      }
      t.en.relativeTime = o, n.fromToBase = function(e2, n2, i2, d2, u) {
        for (var f, a, s, l = i2.$locale().relativeTime || o, h = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], m = h.length, c = 0; c < m; c += 1) {
          var y = h[c];
          y.d && (f = d2 ? t(e2).diff(i2, y.d, true) : i2.diff(e2, y.d, true));
          var p = (r.rounding || Math.round)(Math.abs(f));
          if (s = f > 0, p <= y.r || !y.r) {
            p <= 1 && c > 0 && (y = h[c - 1]);
            var v = l[y.l];
            u && (p = u("" + p)), a = typeof v == "string" ? v.replace("%d", p) : v(p, n2, y.l, s);
            break;
          }
        }
        if (n2)
          return a;
        var M = s ? l.future : l.past;
        return typeof M == "function" ? M(a) : M.replace("%s", a);
      }, n.to = function(r2, e2) {
        return i(r2, e2, this, true);
      }, n.from = function(r2, e2) {
        return i(r2, e2, this);
      };
      var d = function(r2) {
        return r2.$u ? t.utc() : t();
      };
      n.toNow = function(r2) {
        return this.to(d(this), r2);
      }, n.fromNow = function(r2) {
        return this.from(d(this), r2);
      };
    };
  });
})(relativeTime$1);
var relativeTime = relativeTime$1.exports;
var advancedFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal$1, function() {
    return function(e, t) {
      var r = t.prototype, n = r.format;
      r.format = function(e2) {
        var t2 = this, r2 = this.$locale();
        if (!this.isValid())
          return n.bind(this)(e2);
        var s = this.$utils(), a = (e2 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e3) {
          switch (e3) {
            case "Q":
              return Math.ceil((t2.$M + 1) / 3);
            case "Do":
              return r2.ordinal(t2.$D);
            case "gggg":
              return t2.weekYear();
            case "GGGG":
              return t2.isoWeekYear();
            case "wo":
              return r2.ordinal(t2.week(), "W");
            case "w":
            case "ww":
              return s.s(t2.week(), e3 === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return s.s(t2.isoWeek(), e3 === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return s.s(String(t2.$H === 0 ? 24 : t2.$H), e3 === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(t2.$d.getTime() / 1e3);
            case "x":
              return t2.$d.getTime();
            case "z":
              return "[" + t2.offsetName() + "]";
            case "zzz":
              return "[" + t2.offsetName("long") + "]";
            default:
              return e3;
          }
        });
        return n.bind(this)(a);
      };
    };
  });
})(advancedFormat$1);
var advancedFormat = advancedFormat$1.exports;
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
class _TrackingEvent {
  constructor() {
    __publicField(this, "addEventSender", (eventSender) => {
      this.eventSender = eventSender;
    });
    __publicField(this, "addDefaultProperties", (properties) => {
      this.defaultProperties = __spreadValues(__spreadValues({}, this.defaultProperties), properties);
    });
    __publicField(this, "create", (name2, properties = {}) => {
      if (!this.eventSender) {
        console.error("Missing event sender, did addEventSender get removed?");
        return;
      }
      if (this.logEvents) {
        console.log(name2, __spreadValues(__spreadValues({}, properties), this.defaultProperties));
      }
      this.eventSender(name2, __spreadValues(__spreadValues({}, properties), this.defaultProperties));
    });
    this.logEvents = false;
    this.defaultProperties = {};
    this.eventSender = null;
  }
}
new _TrackingEvent();
const parseBreakpointToInt = (v) => parseFloat(v.split("px")[0]);
const getScreenSize = () => {
  const width = window.innerWidth;
  if (width <= parseBreakpointToInt(breakpoints.mobile))
    return SCREEN_SIZES.mobile;
  if (width <= parseBreakpointToInt(breakpoints.desktop))
    return SCREEN_SIZES.tablet;
  return SCREEN_SIZES.desktop;
};
const useScreenSize = () => {
  const [screenSize, setScreenSize] = React.useState(getScreenSize());
  const setScreenSizeState = React.useCallback((newScreenSize) => {
    if (newScreenSize !== screenSize) {
      setScreenSize(newScreenSize);
    }
  }, [screenSize]);
  React.useEffect(() => {
    const handleResize = () => {
      setScreenSizeState(getScreenSize());
    };
    window.addEventListener("resize", handleResize, true);
    return () => window.removeEventListener("resize", handleResize, true);
  }, [setScreenSizeState]);
  return screenSize;
};
const INPUT_MASK_TYPES = {
  phone: "phone",
  dollarAmount: "dollarAmount",
  centsAmount: "centsAmount"
};
const LAYOUT = {
  top: "flex-start",
  left: "flex-start",
  right: "flex-end",
  center: "center",
  bottom: "flex-end"
};
const Width$1 = css`
  width: ${(props) => props.width};
`;
const Height$1 = css`
  height: ${(props) => props.height ? props.height : "auto"};
`;
const HorizontalAlign$1 = css`
  justify-content: ${(props) => props.hAlign && LAYOUT[props.hAlign] ? LAYOUT[props.hAlign] : LAYOUT.left};
`;
const VerticalAlign$1 = css`
  align-items: ${(props) => props.vAlign && LAYOUT[props.vAlign] ? LAYOUT[props.vAlign] : "stretch"};
`;
const Row = styled("div")`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  ${(props) => props.shrink ? Shrink : ""};
  ${(props) => props.wrap ? Wrap : ""};

  ${(props) => props.width ? Width$1 : ""};
  ${(props) => props.height ? Height$1 : ""};

  ${(props) => props.hAlign ? HorizontalAlign$1 : ""};
  ${(props) => props.vAlign ? VerticalAlign$1 : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.borderStyle ? BorderStyle : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.background ? Background : ""};

  ${(props) => props.left ? Left : ""};
  ${(props) => props.top ? Top : ""};
`;
const Width = css`
  flex-basis: ${(props) => props.width};
`;
const Height = css`
  height: ${(props) => props.height};
`;
const HorizontalAlign = css`
  align-items: ${(props) => props.hAlign && LAYOUT[props.hAlign] ? LAYOUT[props.hAlign] : "stretch"};
`;
const VerticalAlign = css`
  justify-content: ${(props) => props.vAlign && LAYOUT[props.vAlign] ? LAYOUT[props.vAlign] : "stretch"};
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  ${(props) => props.shrink ? Shrink : ""};
  ${(props) => props.wrap ? Wrap : ""};

  ${(props) => props.width ? Width : ""};
  ${(props) => props.height ? Height : ""};

  ${(props) => props.hAlign ? HorizontalAlign : ""};
  ${(props) => props.vAlign ? VerticalAlign : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.borderStyle ? BorderStyle : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.background ? Background : ""};
  ${(props) => props.left ? Left : ""};
  ${(props) => props.top ? Top : ""};
`;
const Place = styled("div")`
  position: relative;
  top: ${(props) => props.top || "auto"};
  bottom: ${(props) => props.bottom || "auto"};
  right: ${(props) => props.right || "auto"};
  left: ${(props) => props.left || "auto"};
  display: ${(props) => props.display || "block"};
  height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "auto"};
  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.zIndex ? Zindex : ""};
  ${(props) => props.position ? Position : ""};
  ${(props) => props.overflow ? Overflow : ""};
  ${(props) => props.border ? Border : ""};
  ${(props) => props.wordbreak ? WordBreak : ""};
  ${(props) => props.maxWidth ? MaxWidth : ""};
  ${(props) => props.maxHeight ? MaxHeight : ""};
  ${(props) => props.transition ? Transition : ""};
  ${(props) => props.cursor ? Cursor : ""};
`;
const Wrapper$r = styled.div.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${({ color }) => color};
  }
`;
const Close = ({ width, color }) => {
  const ratio = 13 / 12;
  const height = width / ratio;
  return /* @__PURE__ */ React.createElement(Wrapper$r, {
    color
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M12.3327 1.34163L11.1577 0.166626L6.49935 4.82496L1.84102 0.166626L0.666016 1.34163L5.32435 5.99996L0.666016 10.6583L1.84102 11.8333L6.49935 7.17496L11.1577 11.8333L12.3327 10.6583L7.67435 5.99996L12.3327 1.34163Z"
  })));
};
const animation = keyframes`
  0% {
    transform: translateY(20px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
`;
const ModalPosition = styled.div`
  margin-top: 50px;

  height: 100vh;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 101;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 625px) {
    margin-top: 16px;
  }
`;
const ModalWrapper = styled.div`
  max-width: 570px;
  height: ${({ height }) => height || "500px"};

  position: relative;
  z-index: 102;

  border-radius: 5px;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  overflow: auto;

  -webkit-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  -moz-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  -o-animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
  animation: ${({ isAnimated }) => isAnimated ? css`
          ${animation} 150ms ease-in
        ` : "unset"};
`;
const BackgroundStyle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  border-radius: 2px;
`;
const DismissButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
`;
const Modal = ({ children, isAnimated, onDismiss, modalProps }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Overlay, {
    isAnimated,
    onDismiss
  }), /* @__PURE__ */ React.createElement(ModalPosition, null, /* @__PURE__ */ React.createElement(ModalWrapper, __spreadValues({
    isAnimated
  }, modalProps), children, /* @__PURE__ */ React.createElement(DismissButton, {
    onClick: onDismiss
  }, /* @__PURE__ */ React.createElement(Close, {
    width: 16
  })), /* @__PURE__ */ React.createElement(BackgroundStyle, null))));
};
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 0.9;
  }
`;
const Wrapper$q = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  opacity: 0.9;
  background-color: ${({ isDarkTheme }) => isDarkTheme ? "#222" : "#fff"};

  -webkit-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  -moz-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  -o-animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
  animation: ${({ isAnimated }) => isAnimated ? css`${fadeIn} 300ms` : "unset"};
`;
const Overlay = ({ isAnimated, onDismiss }) => {
  return /* @__PURE__ */ React.createElement(Wrapper$q, {
    isAnimated,
    onClick: onDismiss
  });
};
const convertToPx = (v) => `${v}px`;
const Spacing = ({
  name: name2,
  horizontal,
  vertical,
  all,
  top,
  bottom,
  left,
  right,
  style: additionalStyling,
  children
}) => {
  let style2 = {};
  if (all) {
    style2.paddingLeft = convertToPx(all);
    style2.paddingRight = convertToPx(all);
    style2.paddingTop = convertToPx(all);
    style2.paddingBottom = convertToPx(all);
  }
  if (horizontal) {
    style2.paddingLeft = convertToPx(horizontal);
    style2.paddingRight = convertToPx(horizontal);
  }
  if (vertical) {
    style2.paddingTop = convertToPx(vertical);
    style2.paddingBottom = convertToPx(vertical);
  }
  if (top) {
    style2.paddingTop = convertToPx(top);
  }
  if (bottom) {
    style2.paddingBottom = convertToPx(bottom);
  }
  if (left) {
    style2.paddingLeft = convertToPx(left);
  }
  if (right) {
    style2.paddingRight = convertToPx(right);
  }
  return /* @__PURE__ */ React.createElement("div", {
    name: name2,
    style: __spreadValues(__spreadValues({}, style2), additionalStyling)
  }, children);
};
const convertHexToRGBA = (hex, a) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return `rgba(${[c >> 16 & 255, c >> 8 & 255, c & 255].join(",")},${a})`;
  }
  return false;
};
const isInteger = (n) => {
  return Number.isInteger(n);
};
const Container = (props) => {
  const {
    name: name2,
    style: additionalStyling,
    children,
    height,
    width,
    fullWidth,
    maxWidth,
    maxHeight,
    textCenter,
    gap,
    borderRadius,
    flex,
    flexWrap,
    centerAll,
    verticallyCenter,
    spaceBetween,
    spaceAround,
    row,
    column,
    relative,
    columnCenter,
    alignCenter,
    alignRight,
    background,
    border,
    borderBottom,
    zIndex,
    debugBorder
  } = props;
  const style2 = {};
  if (background) {
    style2.backgroundColor = background;
  }
  if (textCenter) {
    style2.textAlign = "center";
  }
  if (border) {
    style2.borderWidth = 1;
    style2.borderColor = border;
  }
  if (debugBorder) {
    style2.borderWidth = 1;
    style2.borderStyle = "solid";
    style2.borderColor = typeof debugBorder === "string" ? debugBorder : "#e1a";
  }
  if (borderBottom) {
    style2.borderBottomWidth = 1;
    style2.borderBottomColor = borderBottom;
  }
  if (gap) {
    style2.gap = gap;
  }
  if (isInteger(borderRadius)) {
    style2.borderRadius = borderRadius;
  }
  if (isInteger(flex)) {
    style2.display = "flex";
    style2.flex = flex;
  }
  if (flexWrap) {
    style2.flexWrap = "wrap";
  }
  if (isInteger(height)) {
    style2.height = height;
  }
  if (isInteger(width)) {
    style2.width = width;
  }
  if (fullWidth) {
    style2.width = "100%";
  }
  if (isInteger(maxWidth)) {
    style2.maxWidth = maxWidth;
  }
  if (isInteger(maxHeight)) {
    style2.maxHeight = maxHeight;
  }
  if (isInteger(zIndex)) {
    style2.zIndex = zIndex;
  }
  if (column) {
    style2.display = "flex";
    style2.flexDirection = "column";
  }
  if (centerAll) {
    style2.display = "flex";
    style2.alignItems = "center";
    style2.justifyContent = "center";
  }
  if (verticallyCenter) {
    style2.display = "flex";
    style2.flexDirection = "row";
    style2.alignItems = "center";
  }
  if (columnCenter) {
    style2.display = "flex";
    style2.flexDirection = "column";
    style2.alignItems = "center";
    style2.justifyContent = "flex-start";
  }
  if (alignCenter) {
    style2.display = "flex";
    style2.flexDirection = "row";
    style2.justifyContent = "center";
  }
  if (row) {
    style2.display = "flex";
    style2.flexDirection = "row";
  }
  if (alignRight) {
    style2.flexDirection = column ? "column" : "row";
    style2[column ? "alignItems" : "justifyContent"] = "flex-end";
  }
  if (spaceBetween) {
    style2.justifyContent = "space-between";
  }
  if (spaceAround) {
    style2.justifyContent = "space-around";
  }
  if (relative) {
    style2.position = "relative";
  }
  return /* @__PURE__ */ React.createElement(Spacing, __spreadProps(__spreadValues({}, props), {
    style: __spreadValues(__spreadValues({}, style2), additionalStyling || {})
  }), children);
};
const Wrapper$p = styled.div.attrs((props) => ({
  expandheight: props.expandheight || "false"
}))`
  max-width: ${({ maxWidth }) => maxWidth || "95%"};
  width: ${({ width }) => width || "800px"};
  position: relative;
  margin: 12px auto;
  padding: ${({ noPadding }) => noPadding ? "0px" : " 16px 24px"};
  border-radius: 5px;
  text-align: left;
  cursor: default;

  background: ${({ theme, transparentBackground }) => transparentBackground ? "transparent" : theme.screenSize === SCREEN_SIZES.mobile ? theme.themeColors.componentNoOpacity : theme.themeColors.component};
  color: ${({ theme }) => theme.themeColors.text};

  ${({ expandHeight }) => expandHeight === "true" ? "flex: 0 1 auto; display: flex; justify-content: center; height: unset;" : ""}
  min-height: ${({ minHeight }) => minHeight || "min-content"};
  height: ${({ fullHeight, height }) => fullHeight ? "calc(100vh - 60px)" : height || "min-content"};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;

    max-width: ${({ width }) => width || "100%"};
    width: 100%;
    height: ${({ fullHeight, expandHeight, height }) => height || (fullHeight || expandHeight ? "calc(100vh - 64px)" : "unset")}; // 64px === nav height
    max-height: ${({ expandHeight }) => expandHeight ? "800px" : "unset"}; // 64px === nav height

    ${({ theme, mobileTransparentBackground }) => mobileTransparentBackground && theme.screenSize === SCREEN_SIZES.mobile ? "background: " + theme.themeColors.componentNoOpacity + ";" : ""};
  }

  @media (max-width: 430px) {
    padding: ${({ noPadding }) => noPadding ? "0px" : " 16px"};
  }
  @media (max-width: 340px) {
    padding: ${({ noPadding }) => noPadding ? "0px" : " 8px"};
  }
`;
const Page = (props) => {
  const { children, noAutoScroll } = props;
  React.useEffect(() => {
    if (!noAutoScroll) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }, []);
  return /* @__PURE__ */ React.createElement(Wrapper$p, __spreadValues({}, props), children);
};
const Text = styled("div")`
  box-sizing: border-box;
  line-height: 160%;
  ${(props) => props.lineHeight ? LineHeight : ""};
  ${(props) => props.letterSpacing ? LetterSpacing : ""};
  ${(props) => props.fontSize ? FontSize : ""};
  ${(props) => props.fontWeight ? FontWeight : ""};
  ${(props) => props.fontFamily ? FontFamily : ""};
  ${(props) => props.fontStyle ? FontStyle : ""};
  ${(props) => props.color ? Color : ""};
  ${(props) => props.opacity ? Opacity : ""};

  ${(props) => props.textAlign ? TextAlign : ""};
  ${(props) => props.textTransform ? TextTransform : ""};
  ${(props) => props.userSelect ? UserSelect : ""};

  ${(props) => props.padding ? Padding : ""};
  ${(props) => props.margin ? Margin : ""};
  ${(props) => props.cursor ? Cursor : ""};
`;
const Wrapper$o = styled.span`
  box-sizing: border-box;
  line-height: 160%;

  ${(props) => props.lineHeight ? LineHeight : ""};
  ${(props) => props.letterSpacing ? LetterSpacing : ""};
  ${(props) => props.fontSize ? FontSize : ""};
  ${(props) => props.bold ? "font-weight: 800;" : props.thin ? "font-weight: 100;" : props.fontWeight ? FontWeight : ""};
  ${(props) => props.fontStyle ? FontStyle : ""};

  ${(props) => props.opacity ? Opacity : ""};

  ${(props) => props.textAlign ? TextAlign : ""};
  ${(props) => props.textTransform ? TextTransform : ""};
  ${(props) => props.userSelect ? UserSelect : ""};
  ${(props) => props.cursor ? Cursor : ""};
  ${(props) => props.truncate ? "display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" : ""};

  color: ${({ color, isLowContrast, theme }) => isLowContrast ? theme.themeColors.secondaryText : color || theme.themeColors.text};
  ${(props) => props.fontFamily ? FontFamily : ""};

  * {
    color: ${({ color, isLowContrast, theme }) => isLowContrast ? theme.themeColors.secondaryText : color || theme.themeColors.text};
    ${(props) => props.fontFamily ? FontFamily : ""};
    ${(props) => props.fontSize ? FontSize : ""};
    ${(props) => props.letterSpacing ? LetterSpacing : ""};
    ${(props) => props.lineHeight ? LineHeight : ""};
    ${(props) => props.truncate ? "display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" : ""};
  }
`;
const BaseText = (props) => {
  const {
    isLowContrast,
    isSmall,
    isLarge,
    fontSettings: props_fontSettings,
    uppercase,
    center,
    bold,
    truncate,
    children
  } = props;
  const theme = React.useContext(ThemeContext);
  const screenSize = (theme == null ? void 0 : theme.screenSize) || null;
  const isMobile = screenSize === SCREEN_SIZES.mobile;
  const fontSettings = props_fontSettings || { small: {}, standard: {} };
  const fontSettingsStyleProps = (isSmall || isMobile) && !isLarge ? fontSettings.small : fontSettings.standard;
  const aliasedStyles = {};
  if (uppercase) {
    aliasedStyles.textTransform = "uppercase";
  }
  if (center) {
    aliasedStyles.textAlign = "center";
  }
  if (bold) {
    return /* @__PURE__ */ React.createElement(Wrapper$o, __spreadValues(__spreadValues(__spreadValues({
      className: "base-text"
    }, fontSettingsStyleProps), aliasedStyles), props), /* @__PURE__ */ React.createElement("b", null, children));
  }
  return /* @__PURE__ */ React.createElement(Wrapper$o, __spreadValues(__spreadValues(__spreadValues({
    className: "base-text"
  }, fontSettingsStyleProps), aliasedStyles), props), children);
};
const Wrapper$n = styled.span`
  * {
    color: ${({ value, theme }) => value === 0 ? theme.themeColors.neutral : value > 0 ? theme.themeColors.positive : theme.themeColors.negative};
  }
`;
const ValueChangeText = ({ value, children }) => {
  return /* @__PURE__ */ React.createElement(Wrapper$n, {
    value
  }, children);
};
const defineFontSettings = (small, standard) => {
  return {
    small,
    standard
  };
};
const Body1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "14px", lineHeight: "20px" }, { fontSize: "18px", lineHeight: "24px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body2 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "16px", lineHeight: "24px" }, { fontSize: "20px", lineHeight: "28px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "12px", lineHeight: "18px" }, { fontSize: "16px", lineHeight: "24px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body4 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "14px", lineHeight: "18px" }, { fontSize: "16px", lineHeight: "18px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "12px", lineHeight: "18px" }, { fontSize: "14px", lineHeight: "18px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body6 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "18px", lineHeight: "24px" }, { fontSize: "24px", lineHeight: "28px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body7 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "10px", lineHeight: "14px" }, { fontSize: "12px", lineHeight: "14px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body8 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "9px", lineHeight: "12px" }, { fontSize: "12px", lineHeight: "14px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body9 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "14px", lineHeight: "18px" }, { fontSize: "14px", lineHeight: "18px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Body10 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "12px", lineHeight: "14px" }, { fontSize: "14px", lineHeight: "18px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), children);
};
const Wrapper$m = styled.h1`
  font-size: inherit;
  line-height: inherit;
`;
const H1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "36px", lineHeight: "40px", textCase: "uppercase" }, { fontSize: "64px", lineHeight: "76px", textCase: "uppercase" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), /* @__PURE__ */ React.createElement(Wrapper$m, null, children));
};
const Wrapper$l = styled.h3`
  font-size: inherit;
  line-height: inherit;
`;
const H3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "24px", lineHeight: "36px", textCase: "uppercase" }, { fontSize: "36px", lineHeight: "68px", textCase: "uppercase" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), /* @__PURE__ */ React.createElement(Wrapper$l, null, children));
};
const Wrapper$k = styled.h5`
  font-size: inherit;
  line-height: inherit;
`;
const H5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings({ fontSize: "18px", lineHeight: "24px" }, { fontSize: "24px", lineHeight: "36px" });
  return /* @__PURE__ */ React.createElement(BaseText, __spreadValues({
    fontSettings
  }, props), /* @__PURE__ */ React.createElement(Wrapper$k, null, children));
};
const smallSize = css`
  svg {
    width: 150px;
  }
`;
const Wrapper$j = styled.div`
  ${(props) => props.isSmall ? smallSize : ""};
  g {
    fill: ${(props) => props.isDarkMode ? "#fff" : "#222"};
  }
`;
function LogoFull({ isDarkMode, isSmall }) {
  return /* @__PURE__ */ React.createElement(Wrapper$j, {
    isDarkMode,
    isSmall
  }, /* @__PURE__ */ React.createElement("svg", {
    width: 184,
    height: 21,
    viewBox: "0 0 184 21",
    className: "full-logo-tornado"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M45.674 4.201v16.542h-4.55V4.201h-8.723V0h21.982v4.201h-8.71zm29.118 7.304v.153c0 5.732-3.2 9.21-10.838 9.21-7.638 0-10.865-3.492-10.865-9.21v-.153c0-5.731 3.227-9.21 10.865-9.21 7.624 0 10.838 3.492 10.838 9.21zm-4.591.126v-.098c0-3.812-1.934-5.133-6.26-5.133-4.327 0-6.261 1.321-6.261 5.133v.098c0 3.812 1.934 5.133 6.26 5.133 4.327.014 6.26-1.307 6.26-5.133zm18.587-9.335c.64 0 .946.027 1.35.125v4.535c-3.103-.71-8.404-.556-8.404 2.337v11.45h-4.577V2.421h4.577v6.024c0-3.144 1.837-6.15 7.054-6.15zm8.25 5.954c0-3.005 1.836-5.954 7.331-5.954 5.273 0 8.348 2.518 8.348 7.373v11.074h-4.578V10.24c0-2.393-1.502-3.965-5.467-3.965-2.727 0-5.62.557-5.62 2.825v11.658h-4.578V2.421h4.577V8.25h-.014zm23.205.96h-4.633v-.098c0-4.354 3.59-6.816 9.642-6.816 6.775 0 9.766 2.03 9.766 6.942v11.505h-4.549v-4.535c0 1.878-1.962 4.66-7.61 4.66-5.217 0-8.097-1.224-8.097-4.813v-.223c0-5.398 6.97-5.273 15.707-6.51v-.029c0-2.142-1.113-3.158-5.398-3.158-3.534 0-4.842 1.016-4.842 3.005v.07h.014zm3.13 8.653c3.618 0 7.096-.375 7.096-2.462v-2.616c-8.473.946-11.116 1.405-11.116 3.033v.098c0 1.21.974 1.947 4.02 1.947zM154.606 0h4.55v20.743h-4.55V15.61c0 2.337-1.934 5.272-7.665 5.272-6.776 0-9.516-3.687-9.516-9.238v-.097c0-5.55 2.754-9.238 9.516-9.238 5.731 0 7.665 2.922 7.665 5.273V0zm-6.218 6.135c-4.272 0-6.386 1.35-6.386 5.398v.098c0 4.048 2.114 5.398 6.386 5.398 3.255 0 6.204-.46 6.204-2.296V8.417c.014-1.823-2.949-2.282-6.204-2.282zm34.85 5.37v.153c0 5.732-3.2 9.21-10.838 9.21-7.638 0-10.865-3.492-10.865-9.21v-.153c0-5.731 3.227-9.21 10.865-9.21 7.624 0 10.838 3.492 10.838 9.21zm-4.591.126v-.098c0-3.812-1.934-5.133-6.261-5.133s-6.26 1.321-6.26 5.133v.098c0 3.812 1.933 5.133 6.26 5.133 4.327.014 6.261-1.307 6.261-5.133zM14.872 20.743c-.139-.556-.626-1.071-1.21-1.725-1.586-1.753-3.604-6.233 1.655-9.057C19.964 7.471 24.792 4.438 26.628 0H11.756c.139.556.626 1.071 1.21 1.725 1.586 1.753 3.604 6.233-1.655 9.057C6.664 13.272 1.822 16.305 0 20.743h14.872z"
  }))));
}
const Wrapper$i = styled.div`
  g {
    fill: ${(props) => props.isDarkMode ? "#fff" : "black"};
  }

  @media (prefers-color-scheme: dark) {
    g {
      fill: #fff;
    }
  }
`;
function LogoShort({ isDarkMode, height, width }) {
  return /* @__PURE__ */ React.createElement(Wrapper$i, {
    isDarkMode
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: `0 0 59 51`
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M31.3589 51C31.0356 49.6297 29.8906 48.3508 28.5032 46.7457C24.7719 42.4522 20.0169 31.4378 32.4096 24.4821C43.3205 18.3485 54.6895 10.8969 59 0L27.6546 0C27.9779 1.37027 29.1228 2.64918 30.5103 4.25435C34.2416 8.54785 38.9966 19.5622 26.6039 26.5179C15.6795 32.6515 4.3105 40.1031 0 51L31.3589 51Z"
  }))));
}
const Wrapper$h = styled.div`
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  overflow: visible;
  margin: 12px 24px;
  width: 60px;
  height: 60px;
  & > svg {
    width: 45px;
    height: 45px;
  }

  & > svg {
    display: block;
    overflow: visible;
    animation-name: spin-cycle;
  }

  @keyframes spin-cycle {
    from {
      fill: ${({ theme }) => theme.themeColors.primaryCtaButton};
      transform: scale(1);
    }
    to {
      fill: rgba(255, 255, 255, 0);
      transform: scale(1);
    }
  }

  & > svg > * {
    transform: translate3d(0, 0, 0);
    transform-origin: center;
    animation-iteration-count: infinite;
    fill: rgba(255, 255, 255, 0.2);
    animation-name: spin-cycle;
    animation-duration: 0.8s;
  }
  & > svg > *:nth-of-type(8) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
  }
  & > svg > *:nth-of-type(7) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }
  & > svg > *:nth-of-type(6) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
  & > svg > *:nth-of-type(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
  }
  & > svg > *:nth-of-type(4) {
    -webkit-animation-delay: 0.5s;
    animation-delay: 0.5s;
  }
  & > svg > *:nth-of-type(3) {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  
  & > svg > *:nth-of-type(2) {
    -webkit-animation-delay: 0.7s;
    animation-delay: 0.7s;
  }
  & > svg > *:nth-of-type(1) {
    animation-delay: 0.8s;
  }
`;
function LoadingSpinner({ isDarkMode }) {
  return /* @__PURE__ */ React.createElement(Wrapper$h, {
    isDarkMode
  }, /* @__PURE__ */ React.createElement("svg", {
    viewBox: "156 -189 512 512"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M636 99h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32S653.7 99 636 99z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M547.8-23.5C535.2-11 515-11 502.5-23.5s-12.5-32.8 0-45.2l45.2-45.2c12.5-12.5 32.8-12.5 45.2 0s12.5 32.8 0 45.2L547.8-23.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M412-61c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64C444-75.3 429.7-61 412-61z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M276.2-23.5L231-68.8c-12.5-12.5-12.5-32.8 0-45.2s32.8-12.5 45.2 0l45.2 45.2c12.5 12.5 12.5 32.8 0 45.2S288.8-11 276.2-23.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M284 67c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64C269.7 35 284 49.3 284 67z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M276.2 248c-12.5 12.5-32.8 12.5-45.2 0 -12.5-12.5-12.5-32.8 0-45.2l45.2-45.2c12.5-12.5 32.8-12.5 45.2 0s12.5 32.8 0 45.2L276.2 248z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M412 323c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64C444 308.7 429.7 323 412 323z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M547.8 157.5l45.2 45.2c12.5 12.5 12.5 32.8 0 45.2 -12.5 12.5-32.8 12.5-45.2 0l-45.2-45.2c-12.5-12.5-12.5-32.8 0-45.2S535.2 145 547.8 157.5z"
  })));
}
const SVG$d = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Check$1 = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$d, {
    width,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5.4025 10.2565L1.37237 6.21402L0 7.58091L5.4025 13L17 1.36689L15.6373 0L5.4025 10.2565Z"
  }));
};
const SVG$c = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Check = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$c, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M8.99984 0.666992C4.39984 0.666992 0.666504 4.40033 0.666504 9.00033C0.666504 13.6003 4.39984 17.3337 8.99984 17.3337C13.5998 17.3337 17.3332 13.6003 17.3332 9.00033C17.3332 4.40033 13.5998 0.666992 8.99984 0.666992ZM8.99984 15.667C5.32484 15.667 2.33317 12.6753 2.33317 9.00033C2.33317 5.32533 5.32484 2.33366 8.99984 2.33366C12.6748 2.33366 15.6665 5.32533 15.6665 9.00033C15.6665 12.6753 12.6748 15.667 8.99984 15.667ZM12.8248 5.31699L7.33317 10.8087L5.17484 8.65866L3.99984 9.83366L7.33317 13.167L13.9998 6.50033L12.8248 5.31699Z",
    fill: "#201F2C"
  }));
};
const Lock = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
  })));
};
const SVG$b = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Plus = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$b, {
    width,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
  }));
};
const SVG$a = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Delete = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$a, {
    width,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
  }));
};
const SVG$9 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Bank = () => {
  return /* @__PURE__ */ React.createElement(SVG$9, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z"
  }));
};
const SVG$8 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Shield = () => {
  return /* @__PURE__ */ React.createElement(SVG$8, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z"
  }));
};
const SVG$7 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Paper = () => {
  return /* @__PURE__ */ React.createElement(SVG$7, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"
  }));
};
const SVG$6 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const PlusCircle = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$6, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }));
};
const SVG$5 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const MinusCircle = ({ width, color }) => {
  return /* @__PURE__ */ React.createElement(SVG$5, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  }));
};
const SVG$4 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${(props) => props.color};
  }
`;
const Warning = () => {
  return /* @__PURE__ */ React.createElement(SVG$4, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
  }));
};
const SVG$3 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${({ theme, color }) => {
  var _a;
  return color || ((_a = theme == null ? void 0 : theme.themeColors) == null ? void 0 : _a.text);
}};
  }
`;
const Copy = () => {
  return /* @__PURE__ */ React.createElement(SVG$3, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
  }));
};
const SVG$2 = styled.svg.attrs((props) => ({
  color: props.color || "#222"
}))`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const CaretUp = () => {
  return /* @__PURE__ */ React.createElement(SVG$2, {
    viewBox: "-1 -1 12 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 5.65687L0.550251 5.65687C0.104798 5.65687 -0.118284 5.1183 0.196699 4.80331L4.64645 0.353566C4.84171 0.158303 5.15829 0.158303 5.35355 0.353566L9.8033 4.80331C10.1183 5.1183 9.8952 5.65687 9.44975 5.65687L5 5.65687Z"
  }));
};
const SVG$1 = styled.svg`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const CaretDown = () => {
  return /* @__PURE__ */ React.createElement(SVG$1, {
    viewBox: "-1 -1 12 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 0.656854L9.44975 0.656854C9.8952 0.656854 10.1183 1.19543 9.8033 1.51041L5.35355 5.96015C5.15829 6.15542 4.84171 6.15542 4.64645 5.96015L0.196699 1.51041C-0.118283 1.19542 0.1048 0.656854 0.550253 0.656854L5 0.656854Z"
  }));
};
const SVG = styled.svg`
  path {
    fill: ${({ color, theme }) => color || theme.themeColors.text};
  }
`;
const Minus = () => {
  return /* @__PURE__ */ React.createElement(SVG, {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M20 14H4V10H20V14Z"
  }));
};
const Calendar = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
  })));
};
const Compass = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M7,17L10.2,10.2L17,7L13.8,13.8L7,17M12,11.1A0.9,0.9 0 0,0 11.1,12A0.9,0.9 0 0,0 12,12.9A0.9,0.9 0 0,0 12.9,12A0.9,0.9 0 0,0 12,11.1M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z"
  })));
};
const Fire = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z"
  })));
};
const Heartbeat = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M7.5,4A5.5,5.5 0 0,0 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5A5.5,5.5 0 0,0 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5A1,1 0 0,0 2,13.5A1,1 0 0,0 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21A1,1 0 0,0 22,13.5A1,1 0 0,0 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z"
  })));
};
const Lightbulb = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M12,2A7,7 0 0,1 19,9C19,11.38 17.81,13.47 16,14.74V17A1,1 0 0,1 15,18H9A1,1 0 0,1 8,17V14.74C6.19,13.47 5,11.38 5,9A7,7 0 0,1 12,2M9,21V20H15V21A1,1 0 0,1 14,22H10A1,1 0 0,1 9,21M12,4A5,5 0 0,0 7,9C7,11.05 8.23,12.81 10,13.58V16H14V13.58C15.77,12.81 17,11.05 17,9A5,5 0 0,0 12,4Z"
  })));
};
const Microchip = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z"
  })));
};
const Money = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z"
  })));
};
const PercentSign = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4A3,3 0 0,0 4,7A3,3 0 0,0 7,10A3,3 0 0,0 10,7A3,3 0 0,0 7,4M17,14A3,3 0 0,0 14,17A3,3 0 0,0 17,20A3,3 0 0,0 20,17A3,3 0 0,0 17,14Z"
  })));
};
const Podcast = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M17,18.25V21.5H7V18.25C7,16.87 9.24,15.75 12,15.75C14.76,15.75 17,16.87 17,18.25M12,5.5A6.5,6.5 0 0,1 18.5,12C18.5,13.25 18.15,14.42 17.54,15.41L16,14.04C16.32,13.43 16.5,12.73 16.5,12C16.5,9.5 14.5,7.5 12,7.5C9.5,7.5 7.5,9.5 7.5,12C7.5,12.73 7.68,13.43 8,14.04L6.46,15.41C5.85,14.42 5.5,13.25 5.5,12A6.5,6.5 0 0,1 12,5.5M12,1.5A10.5,10.5 0 0,1 22.5,12C22.5,14.28 21.77,16.39 20.54,18.11L19.04,16.76C19.96,15.4 20.5,13.76 20.5,12A8.5,8.5 0 0,0 12,3.5A8.5,8.5 0 0,0 3.5,12C3.5,13.76 4.04,15.4 4.96,16.76L3.46,18.11C2.23,16.39 1.5,14.28 1.5,12A10.5,10.5 0 0,1 12,1.5M12,9.5A2.5,2.5 0 0,1 14.5,12A2.5,2.5 0 0,1 12,14.5A2.5,2.5 0 0,1 9.5,12A2.5,2.5 0 0,1 12,9.5Z"
  })));
};
const Plug = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z"
  })));
};
const Tree = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    d: "M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16M20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18H24L20.14 12M13 19H17V22H13V19Z"
  })));
};
const Wrapper$g = styled.div``;
const ToggleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
`;
const ToggleButtonWrapper = styled.div`
  flex: 1;

  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }) => theme.themeColors.primaryCtaButton};

  padding: 16px 12px;

  text-align: center;
  font-size: 14px;
  line-height: 18px;
  font-family: 'Bolton-Bold', Arial;
  font-weight: 500;

  cursor: pointer;

  ${({ isSelected, theme }) => isSelected ? `background-color: ${theme.themeColors.primaryCtaButton}; color: ${theme.themeColors.buttonText};` : `background-color: transparent; color: ${theme.themeColors.primaryCtaButton};`}

  ${({ isSelected, index }) => {
  if (index === 0) {
    return `
        border-right-width: ${isSelected ? "1px" : 0};
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      `;
  } else {
    return `
        border-left-width: ${isSelected ? 0 : "1px"};
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      `;
  }
}}
  
  &:hover {
    ${({ isSelected, theme }) => isSelected ? `` : `background-color: ${convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)}`}
  }
`;
const ErrorText$2 = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
  text-align: center;
`;
const createToggleItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const ToggleButton = (props) => {
  const { index, name: name2, value, onClick, text, isSelected, color } = props;
  const handleClick = () => {
    return onClick(name2)(value);
  };
  return /* @__PURE__ */ React.createElement(ToggleButtonWrapper, {
    className: "no-select",
    isSelected,
    index,
    onClick: handleClick,
    color
  }, text);
};
const Toggle = ({
  name: name2,
  value,
  error,
  color,
  items,
  onChange
}) => {
  const checkIfActive = React.useCallback((itemValue) => itemValue === value, [value]);
  return /* @__PURE__ */ React.createElement(Wrapper$g, null, /* @__PURE__ */ React.createElement(ToggleContainer, null, /* @__PURE__ */ React.createElement(ToggleButton, __spreadProps(__spreadValues({
    key: items[0].text,
    index: 0,
    name: name2
  }, items[0]), {
    isSelected: checkIfActive(items[0].value),
    onClick: onChange,
    color
  })), /* @__PURE__ */ React.createElement(ToggleButton, __spreadProps(__spreadValues({
    key: items[1].text,
    index: 1,
    name: name2
  }, items[1]), {
    isSelected: checkIfActive(items[1].value),
    onClick: onChange,
    color
  }))), error && /* @__PURE__ */ React.createElement(ErrorText$2, null, /* @__PURE__ */ React.createElement(Text, {
    fontSize: "14px"
  }, error)));
};
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  border-radius: 8px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.themeColors.border};
  background: ${({ theme }) => theme.themeColors.component};
`;
const ToggleRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid ${({ theme }) => theme.themeColors.border};

  :last-child {
    border: none;
  }

  padding: 12px 16px;

  text-align: left;
  font-size: 14px;
  line-height: 18px;
  font-family: 'Bolton-Bold', Arial;
  font-weight: 500;

  cursor: pointer;

  &:hover {
    ${({ isSelected, theme }) => isSelected ? `` : `background-color: ${convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)}`}
  }

  svg {
    path {
      fill: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
const ErrorText$1 = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
  text-align: center;
`;
const createListToggleItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const ToggleRow = (props) => {
  const { name: name2, value, onClick, text, isSelected, color } = props;
  const handleClick = () => {
    return onClick(name2)(value);
  };
  return /* @__PURE__ */ React.createElement(ToggleRowWrapper, {
    className: "no-select",
    isSelected,
    onClick: handleClick,
    color
  }, /* @__PURE__ */ React.createElement(Body5, null, text), isSelected && /* @__PURE__ */ React.createElement(Check$1, {
    width: "17px"
  }));
};
const ListToggle = ({
  name: name2,
  value,
  error,
  items,
  onClick
}) => {
  const checkIfActive = React.useCallback((itemValue) => itemValue === value, [value]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListContainer, null, items.map((r, i) => /* @__PURE__ */ React.createElement(ToggleRow, __spreadProps(__spreadValues({
    key: r.text,
    index: i,
    name: name2
  }, r), {
    isSelected: checkIfActive(r.value),
    onClick
  })))), error && /* @__PURE__ */ React.createElement(ErrorText$1, null, /* @__PURE__ */ React.createElement(Text, {
    fontSize: "14px"
  }, error)));
};
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf$1(object);
    if (object === null)
      break;
  }
  return object;
}
function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get2(target2, property2, receiver2) {
      var base = _superPropBase(target2, property2);
      if (!base)
        return;
      var desc = Object.getOwnPropertyDescriptor(base, property2);
      if (desc.get) {
        return desc.get.call(receiver2);
      }
      return desc.value;
    };
  }
  return _get(target, property, receiver || target);
}
function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set2(target2, property2, value2, receiver2) {
      var base = _superPropBase(target2, property2);
      var desc;
      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property2);
        if (desc.set) {
          desc.set.call(receiver2, value2);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }
      desc = Object.getOwnPropertyDescriptor(receiver2, property2);
      if (desc) {
        if (!desc.writable) {
          return false;
        }
        desc.value = value2;
        Object.defineProperty(receiver2, property2, desc);
      } else {
        _defineProperty(receiver2, property2, value2);
      }
      return true;
    };
  }
  return set(target, property, value, receiver);
}
function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);
  if (!s && isStrict) {
    throw new Error("failed to set property");
  }
  return value;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function isString(str) {
  return typeof str === "string" || str instanceof String;
}
var DIRECTION = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function objectIncludes(b, a) {
  if (a === b)
    return true;
  var arrA = Array.isArray(a), arrB = Array.isArray(b), i;
  if (arrA && arrB) {
    if (a.length != b.length)
      return false;
    for (i = 0; i < a.length; i++) {
      if (!objectIncludes(a[i], b[i]))
        return false;
    }
    return true;
  }
  if (arrA != arrB)
    return false;
  if (a && b && _typeof(a) === "object" && _typeof(b) === "object") {
    var dateA = a instanceof Date, dateB = b instanceof Date;
    if (dateA && dateB)
      return a.getTime() == b.getTime();
    if (dateA != dateB)
      return false;
    var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
    if (regexpA && regexpB)
      return a.toString() == b.toString();
    if (regexpA != regexpB)
      return false;
    var keys = Object.keys(a);
    for (i = 0; i < keys.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
        return false;
    }
    for (i = 0; i < keys.length; i++) {
      if (!objectIncludes(b[keys[i]], a[keys[i]]))
        return false;
    }
    return true;
  } else if (a && b && typeof a === "function" && typeof b === "function") {
    return a.toString() === b.toString();
  }
  return false;
}
var ActionDetails = /* @__PURE__ */ function() {
  function ActionDetails2(value, cursorPos, oldValue, oldSelection) {
    _classCallCheck$1(this, ActionDetails2);
    this.value = value;
    this.cursorPos = cursorPos;
    this.oldValue = oldValue;
    this.oldSelection = oldSelection;
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
  }
  _createClass$1(ActionDetails2, [{
    key: "startChangePos",
    get: function get() {
      return Math.min(this.cursorPos, this.oldSelection.start);
    }
  }, {
    key: "insertedCount",
    get: function get() {
      return this.cursorPos - this.startChangePos;
    }
  }, {
    key: "inserted",
    get: function get() {
      return this.value.substr(this.startChangePos, this.insertedCount);
    }
  }, {
    key: "removedCount",
    get: function get() {
      return Math.max(this.oldSelection.end - this.startChangePos || this.oldValue.length - this.value.length, 0);
    }
  }, {
    key: "removed",
    get: function get() {
      return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
  }, {
    key: "head",
    get: function get() {
      return this.value.substring(0, this.startChangePos);
    }
  }, {
    key: "tail",
    get: function get() {
      return this.value.substring(this.startChangePos + this.insertedCount);
    }
  }, {
    key: "removeDirection",
    get: function get() {
      if (!this.removedCount || this.insertedCount)
        return DIRECTION.NONE;
      return this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos ? DIRECTION.RIGHT : DIRECTION.LEFT;
    }
  }]);
  return ActionDetails2;
}();
var ChangeDetails = /* @__PURE__ */ function() {
  function ChangeDetails2(details) {
    _classCallCheck$1(this, ChangeDetails2);
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: false,
      tailShift: 0
    }, details);
  }
  _createClass$1(ChangeDetails2, [{
    key: "aggregate",
    value: function aggregate(details) {
      this.rawInserted += details.rawInserted;
      this.skip = this.skip || details.skip;
      this.inserted += details.inserted;
      this.tailShift += details.tailShift;
      return this;
    }
  }, {
    key: "offset",
    get: function get() {
      return this.tailShift + this.inserted.length;
    }
  }]);
  return ChangeDetails2;
}();
var ContinuousTailDetails = /* @__PURE__ */ function() {
  function ContinuousTailDetails2() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var stop = arguments.length > 2 ? arguments[2] : void 0;
    _classCallCheck$1(this, ContinuousTailDetails2);
    this.value = value;
    this.from = from;
    this.stop = stop;
  }
  _createClass$1(ContinuousTailDetails2, [{
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }, {
    key: "extend",
    value: function extend(tail) {
      this.value += String(tail);
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      return masked.append(this.toString(), {
        tail: true
      }).aggregate(masked._appendPlaceholder());
    }
  }, {
    key: "state",
    get: function get() {
      return {
        value: this.value,
        from: this.from,
        stop: this.stop
      };
    },
    set: function set2(state) {
      Object.assign(this, state);
    }
  }, {
    key: "shiftBefore",
    value: function shiftBefore(pos) {
      if (this.from >= pos || !this.value.length)
        return "";
      var shiftChar = this.value[0];
      this.value = this.value.slice(1);
      return shiftChar;
    }
  }]);
  return ContinuousTailDetails2;
}();
function IMask(el) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new IMask.InputMask(el, opts);
}
var Masked = /* @__PURE__ */ function() {
  function Masked2(opts) {
    _classCallCheck$1(this, Masked2);
    this._value = "";
    this._update(Object.assign({}, Masked2.DEFAULTS, opts));
    this.isInitialized = true;
  }
  _createClass$1(Masked2, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      if (!Object.keys(opts).length)
        return;
      this.withValueRefresh(this._update.bind(this, opts));
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      Object.assign(this, opts);
    }
  }, {
    key: "state",
    get: function get() {
      return {
        _value: this.value
      };
    },
    set: function set2(state) {
      this._value = state._value;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._value = "";
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set2(value) {
      this.resolve(value);
    }
  }, {
    key: "resolve",
    value: function resolve(value) {
      this.reset();
      this.append(value, {
        input: true
      }, "");
      this.doCommit();
      return this.value;
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.value;
    },
    set: function set2(value) {
      this.reset();
      this.append(value, {}, "");
      this.doCommit();
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.doParse(this.value);
    },
    set: function set2(value) {
      this.value = this.doFormat(value);
    }
  }, {
    key: "rawInputValue",
    get: function get() {
      return this.extractInput(0, this.value.length, {
        raw: true
      });
    },
    set: function set2(value) {
      this.reset();
      this.append(value, {
        raw: true
      }, "");
      this.doCommit();
    }
  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      return cursorPos;
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return this.value.slice(fromPos, toPos);
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
    }
  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString(tail))
        tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      if (!ch)
        return new ChangeDetails();
      this._value += ch;
      return new ChangeDetails({
        inserted: ch,
        rawInserted: ch
      });
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(ch) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var checkTail = arguments.length > 2 ? arguments[2] : void 0;
      var consistentState = this.state;
      var details = this._appendCharRaw(this.doPrepare(ch, flags), flags);
      if (details.inserted) {
        var consistentTail;
        var appended = this.doValidate(flags) !== false;
        if (appended && checkTail != null) {
          var beforeTailState = this.state;
          if (this.overwrite) {
            consistentTail = checkTail.state;
            checkTail.shiftBefore(this.value.length);
          }
          var tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted === checkTail.toString();
          if (appended && tailDetails.inserted)
            this.state = beforeTailState;
        }
        if (!appended) {
          details = new ChangeDetails();
          this.state = consistentState;
          if (checkTail && consistentTail)
            checkTail.state = consistentTail;
        }
      }
      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      return new ChangeDetails();
    }
  }, {
    key: "append",
    value: function append(str, flags, tail) {
      if (!isString(str))
        throw new Error("value should be string");
      var details = new ChangeDetails();
      var checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
      if (flags && flags.tail)
        flags._beforeTailState = this.state;
      for (var ci = 0; ci < str.length; ++ci) {
        details.aggregate(this._appendChar(str[ci], flags, checkTail));
      }
      if (checkTail != null) {
        details.tailShift += this.appendTail(checkTail).tailShift;
      }
      return details;
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
      return new ChangeDetails();
    }
  }, {
    key: "withValueRefresh",
    value: function withValueRefresh(fn) {
      if (this._refreshing || !this.isInitialized)
        return fn();
      this._refreshing = true;
      var rawInput = this.rawInputValue;
      var value = this.value;
      var ret = fn();
      this.rawInputValue = rawInput;
      if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
        this.append(value.slice(this.value.length), {}, "");
      }
      delete this._refreshing;
      return ret;
    }
  }, {
    key: "runIsolated",
    value: function runIsolated(fn) {
      if (this._isolated || !this.isInitialized)
        return fn(this);
      this._isolated = true;
      var state = this.state;
      var ret = fn(this);
      this.state = state;
      delete this._isolated;
      return ret;
    }
  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.prepare ? this.prepare(str, this, flags) : str;
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.commit)
        this.commit(this.value, this);
    }
  }, {
    key: "doFormat",
    value: function doFormat(value) {
      return this.format ? this.format(value, this) : value;
    }
  }, {
    key: "doParse",
    value: function doParse(str) {
      return this.parse ? this.parse(str, this) : str;
    }
  }, {
    key: "splice",
    value: function splice(start, deleteCount, inserted, removeDirection) {
      var tailPos = start + deleteCount;
      var tail = this.extractTail(tailPos);
      var startChangePos = this.nearestInputPos(start, removeDirection);
      var changeDetails = new ChangeDetails({
        tailShift: startChangePos - start
      }).aggregate(this.remove(startChangePos)).aggregate(this.append(inserted, {
        input: true
      }, tail));
      return changeDetails;
    }
  }]);
  return Masked2;
}();
Masked.DEFAULTS = {
  format: function format(v) {
    return v;
  },
  parse: function parse(v) {
    return v;
  }
};
IMask.Masked = Masked;
function maskedClass(mask) {
  if (mask == null) {
    throw new Error("mask property should be defined");
  }
  if (mask instanceof RegExp)
    return IMask.MaskedRegExp;
  if (isString(mask))
    return IMask.MaskedPattern;
  if (mask instanceof Date || mask === Date)
    return IMask.MaskedDate;
  if (mask instanceof Number || typeof mask === "number" || mask === Number)
    return IMask.MaskedNumber;
  if (Array.isArray(mask) || mask === Array)
    return IMask.MaskedDynamic;
  if (IMask.Masked && mask.prototype instanceof IMask.Masked)
    return mask;
  if (mask instanceof Function)
    return IMask.MaskedFunction;
  if (mask instanceof IMask.Masked)
    return mask.constructor;
  console.warn("Mask not found for mask", mask);
  return IMask.Masked;
}
function createMask(opts) {
  if (IMask.Masked && opts instanceof IMask.Masked)
    return opts;
  opts = Object.assign({}, opts);
  var mask = opts.mask;
  if (IMask.Masked && mask instanceof IMask.Masked)
    return mask;
  var MaskedClass = maskedClass(mask);
  if (!MaskedClass)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new MaskedClass(opts);
}
IMask.createMask = createMask;
var _excluded$5 = ["mask"];
var DEFAULT_INPUT_DEFINITIONS = {
  "0": /\d/,
  "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  "*": /./
};
var PatternInputDefinition = /* @__PURE__ */ function() {
  function PatternInputDefinition2(opts) {
    _classCallCheck$1(this, PatternInputDefinition2);
    var mask = opts.mask, blockOpts = _objectWithoutProperties$1(opts, _excluded$5);
    this.masked = createMask({
      mask
    });
    Object.assign(this, blockOpts);
  }
  _createClass$1(PatternInputDefinition2, [{
    key: "reset",
    value: function reset() {
      this._isFilled = false;
      this.masked.reset();
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      if (fromPos === 0 && toPos >= 1) {
        this._isFilled = false;
        return this.masked.remove(fromPos, toPos);
      }
      return new ChangeDetails();
    }
  }, {
    key: "value",
    get: function get() {
      return this.masked.value || (this._isFilled && !this.isOptional ? this.placeholderChar : "");
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.masked.unmaskedValue;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return Boolean(this.masked.value) || this.isOptional;
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(str) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this._isFilled)
        return new ChangeDetails();
      var state = this.masked.state;
      var details = this.masked._appendChar(str, flags);
      if (details.inserted && this.doValidate(flags) === false) {
        details.inserted = details.rawInserted = "";
        this.masked.state = state;
      }
      if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
        details.inserted = this.placeholderChar;
      }
      details.skip = !details.inserted && !this.isOptional;
      this._isFilled = Boolean(details.inserted);
      return details;
    }
  }, {
    key: "append",
    value: function append() {
      var _this$masked;
      return (_this$masked = this.masked).append.apply(_this$masked, arguments);
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this._isFilled || this.isOptional)
        return details;
      this._isFilled = true;
      details.inserted = this.placeholderChar;
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$masked2;
      return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
    }
  }, {
    key: "appendTail",
    value: function appendTail() {
      var _this$masked3;
      return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : void 0;
      return this.masked.extractInput(fromPos, toPos, flags);
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this.value.length;
      var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return this.isComplete ? boundPos : minPos;
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          return this.isComplete ? boundPos : maxPos;
        case DIRECTION.NONE:
        default:
          return boundPos;
      }
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this$masked4, _this$parent;
      return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      this.masked.doCommit();
    }
  }, {
    key: "state",
    get: function get() {
      return {
        masked: this.masked.state,
        _isFilled: this._isFilled
      };
    },
    set: function set2(state) {
      this.masked.state = state.masked;
      this._isFilled = state._isFilled;
    }
  }]);
  return PatternInputDefinition2;
}();
var PatternFixedDefinition = /* @__PURE__ */ function() {
  function PatternFixedDefinition2(opts) {
    _classCallCheck$1(this, PatternFixedDefinition2);
    Object.assign(this, opts);
    this._value = "";
  }
  _createClass$1(PatternFixedDefinition2, [{
    key: "value",
    get: function get() {
      return this._value;
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.isUnmasking ? this.value : "";
    }
  }, {
    key: "reset",
    value: function reset() {
      this._isRawInput = false;
      this._value = "";
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
      this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
      if (!this._value)
        this._isRawInput = false;
      return new ChangeDetails();
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this._value.length;
      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return minPos;
        case DIRECTION.NONE:
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
        default:
          return maxPos;
      }
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
      var flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
    }
  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(str) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var details = new ChangeDetails();
      if (this._value)
        return details;
      var appended = this.char === str[0];
      var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && !flags.tail;
      if (isResolved)
        details.rawInserted = this.char;
      this._value = details.inserted = this.char;
      this._isRawInput = isResolved && (flags.raw || flags.input);
      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this._value)
        return details;
      this._value = details.inserted = this.char;
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return new ContinuousTailDetails("");
    }
  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString(tail))
        tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
  }, {
    key: "append",
    value: function append(str, flags, tail) {
      var details = this._appendChar(str, flags);
      if (tail != null) {
        details.tailShift += this.appendTail(tail).tailShift;
      }
      return details;
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
    }
  }, {
    key: "state",
    get: function get() {
      return {
        _value: this._value,
        _isRawInput: this._isRawInput
      };
    },
    set: function set2(state) {
      Object.assign(this, state);
    }
  }]);
  return PatternFixedDefinition2;
}();
var _excluded$4 = ["chunks"];
var ChunksTailDetails = /* @__PURE__ */ function() {
  function ChunksTailDetails2() {
    var chunks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    _classCallCheck$1(this, ChunksTailDetails2);
    this.chunks = chunks;
    this.from = from;
  }
  _createClass$1(ChunksTailDetails2, [{
    key: "toString",
    value: function toString() {
      return this.chunks.map(String).join("");
    }
  }, {
    key: "extend",
    value: function extend(tailChunk) {
      if (!String(tailChunk))
        return;
      if (isString(tailChunk))
        tailChunk = new ContinuousTailDetails(String(tailChunk));
      var lastChunk = this.chunks[this.chunks.length - 1];
      var extendLast = lastChunk && (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && tailChunk.from === lastChunk.from + lastChunk.toString().length;
      if (tailChunk instanceof ContinuousTailDetails) {
        if (extendLast) {
          lastChunk.extend(tailChunk.toString());
        } else {
          this.chunks.push(tailChunk);
        }
      } else if (tailChunk instanceof ChunksTailDetails2) {
        if (tailChunk.stop == null) {
          var firstTailChunk;
          while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
            firstTailChunk = tailChunk.chunks.shift();
            firstTailChunk.from += tailChunk.from;
            this.extend(firstTailChunk);
          }
        }
        if (tailChunk.toString()) {
          tailChunk.stop = tailChunk.blockIndex;
          this.chunks.push(tailChunk);
        }
      }
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      if (!(masked instanceof IMask.MaskedPattern)) {
        var tail = new ContinuousTailDetails(this.toString());
        return tail.appendTo(masked);
      }
      var details = new ChangeDetails();
      for (var ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
        var chunk = this.chunks[ci];
        var lastBlockIter = masked._mapPosToBlock(masked.value.length);
        var stop = chunk.stop;
        var chunkBlock = void 0;
        if (stop != null && (!lastBlockIter || lastBlockIter.index <= stop)) {
          if (chunk instanceof ChunksTailDetails2 || masked._stops.indexOf(stop) >= 0) {
            details.aggregate(masked._appendPlaceholder(stop));
          }
          chunkBlock = chunk instanceof ChunksTailDetails2 && masked._blocks[stop];
        }
        if (chunkBlock) {
          var tailDetails = chunkBlock.appendTail(chunk);
          tailDetails.skip = false;
          details.aggregate(tailDetails);
          masked._value += tailDetails.inserted;
          var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
          if (remainChars)
            details.aggregate(masked.append(remainChars, {
              tail: true
            }));
        } else {
          details.aggregate(masked.append(chunk.toString(), {
            tail: true
          }));
        }
      }
      return details;
    }
  }, {
    key: "state",
    get: function get() {
      return {
        chunks: this.chunks.map(function(c) {
          return c.state;
        }),
        from: this.from,
        stop: this.stop,
        blockIndex: this.blockIndex
      };
    },
    set: function set2(state) {
      var chunks = state.chunks, props = _objectWithoutProperties$1(state, _excluded$4);
      Object.assign(this, props);
      this.chunks = chunks.map(function(cstate) {
        var chunk = "chunks" in cstate ? new ChunksTailDetails2() : new ContinuousTailDetails();
        chunk.state = cstate;
        return chunk;
      });
    }
  }, {
    key: "shiftBefore",
    value: function shiftBefore(pos) {
      if (this.from >= pos || !this.chunks.length)
        return "";
      var chunkShiftPos = pos - this.from;
      var ci = 0;
      while (ci < this.chunks.length) {
        var chunk = this.chunks[ci];
        var shiftChar = chunk.shiftBefore(chunkShiftPos);
        if (chunk.toString()) {
          if (!shiftChar)
            break;
          ++ci;
        } else {
          this.chunks.splice(ci, 1);
        }
        if (shiftChar)
          return shiftChar;
      }
      return "";
    }
  }]);
  return ChunksTailDetails2;
}();
var MaskedRegExp = /* @__PURE__ */ function(_Masked) {
  _inherits$1(MaskedRegExp2, _Masked);
  var _super = _createSuper$1(MaskedRegExp2);
  function MaskedRegExp2() {
    _classCallCheck$1(this, MaskedRegExp2);
    return _super.apply(this, arguments);
  }
  _createClass$1(MaskedRegExp2, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.mask)
        opts.validate = function(value) {
          return value.search(opts.mask) >= 0;
        };
      _get(_getPrototypeOf$1(MaskedRegExp2.prototype), "_update", this).call(this, opts);
    }
  }]);
  return MaskedRegExp2;
}(Masked);
IMask.MaskedRegExp = MaskedRegExp;
var _excluded$3 = ["_blocks"];
var MaskedPattern = /* @__PURE__ */ function(_Masked) {
  _inherits$1(MaskedPattern2, _Masked);
  var _super = _createSuper$1(MaskedPattern2);
  function MaskedPattern2() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$1(this, MaskedPattern2);
    opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
    return _super.call(this, Object.assign({}, MaskedPattern2.DEFAULTS, opts));
  }
  _createClass$1(MaskedPattern2, [{
    key: "_update",
    value: function _update() {
      var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      opts.definitions = Object.assign({}, this.definitions, opts.definitions);
      _get(_getPrototypeOf$1(MaskedPattern2.prototype), "_update", this).call(this, opts);
      this._rebuildMask();
    }
  }, {
    key: "_rebuildMask",
    value: function _rebuildMask() {
      var _this = this;
      var defs = this.definitions;
      this._blocks = [];
      this._stops = [];
      this._maskedBlocks = {};
      var pattern = this.mask;
      if (!pattern || !defs)
        return;
      var unmaskingBlock = false;
      var optionalBlock = false;
      for (var i = 0; i < pattern.length; ++i) {
        if (this.blocks) {
          var _ret = function() {
            var p = pattern.slice(i);
            var bNames = Object.keys(_this.blocks).filter(function(bName2) {
              return p.indexOf(bName2) === 0;
            });
            bNames.sort(function(a, b) {
              return b.length - a.length;
            });
            var bName = bNames[0];
            if (bName) {
              var maskedBlock = createMask(Object.assign({
                parent: _this,
                lazy: _this.lazy,
                placeholderChar: _this.placeholderChar,
                overwrite: _this.overwrite
              }, _this.blocks[bName]));
              if (maskedBlock) {
                _this._blocks.push(maskedBlock);
                if (!_this._maskedBlocks[bName])
                  _this._maskedBlocks[bName] = [];
                _this._maskedBlocks[bName].push(_this._blocks.length - 1);
              }
              i += bName.length - 1;
              return "continue";
            }
          }();
          if (_ret === "continue")
            continue;
        }
        var char = pattern[i];
        var _isInput = char in defs;
        if (char === MaskedPattern2.STOP_CHAR) {
          this._stops.push(this._blocks.length);
          continue;
        }
        if (char === "{" || char === "}") {
          unmaskingBlock = !unmaskingBlock;
          continue;
        }
        if (char === "[" || char === "]") {
          optionalBlock = !optionalBlock;
          continue;
        }
        if (char === MaskedPattern2.ESCAPE_CHAR) {
          ++i;
          char = pattern[i];
          if (!char)
            break;
          _isInput = false;
        }
        var def = _isInput ? new PatternInputDefinition({
          parent: this,
          lazy: this.lazy,
          placeholderChar: this.placeholderChar,
          mask: defs[char],
          isOptional: optionalBlock
        }) : new PatternFixedDefinition({
          char,
          isUnmasking: unmaskingBlock
        });
        this._blocks.push(def);
      }
    }
  }, {
    key: "state",
    get: function get() {
      return Object.assign({}, _get(_getPrototypeOf$1(MaskedPattern2.prototype), "state", this), {
        _blocks: this._blocks.map(function(b) {
          return b.state;
        })
      });
    },
    set: function set2(state) {
      var _blocks = state._blocks, maskedState = _objectWithoutProperties$1(state, _excluded$3);
      this._blocks.forEach(function(b, bi) {
        return b.state = _blocks[bi];
      });
      _set(_getPrototypeOf$1(MaskedPattern2.prototype), "state", maskedState, this, true);
    }
  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf$1(MaskedPattern2.prototype), "reset", this).call(this);
      this._blocks.forEach(function(b) {
        return b.reset();
      });
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this._blocks.every(function(b) {
        return b.isComplete;
      });
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      this._blocks.forEach(function(b) {
        return b.doCommit();
      });
      _get(_getPrototypeOf$1(MaskedPattern2.prototype), "doCommit", this).call(this);
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._blocks.reduce(function(str, b) {
        return str += b.unmaskedValue;
      }, "");
    },
    set: function set2(unmaskedValue) {
      _set(_getPrototypeOf$1(MaskedPattern2.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
  }, {
    key: "value",
    get: function get() {
      return this._blocks.reduce(function(str, b) {
        return str += b.value;
      }, "");
    },
    set: function set2(value) {
      _set(_getPrototypeOf$1(MaskedPattern2.prototype), "value", value, this, true);
    }
  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      return _get(_getPrototypeOf$1(MaskedPattern2.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var blockIter = this._mapPosToBlock(this.value.length);
      var details = new ChangeDetails();
      if (!blockIter)
        return details;
      for (var bi = blockIter.index; ; ++bi) {
        var _block = this._blocks[bi];
        if (!_block)
          break;
        var blockDetails = _block._appendChar(ch, flags);
        var skip = blockDetails.skip;
        details.aggregate(blockDetails);
        if (skip || blockDetails.rawInserted)
          break;
      }
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this2 = this;
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var chunkTail = new ChunksTailDetails();
      if (fromPos === toPos)
        return chunkTail;
      this._forEachBlocksInRange(fromPos, toPos, function(b, bi, bFromPos, bToPos) {
        var blockChunk = b.extractTail(bFromPos, bToPos);
        blockChunk.stop = _this2._findStopBefore(bi);
        blockChunk.from = _this2._blockStartPos(bi);
        if (blockChunk instanceof ChunksTailDetails)
          blockChunk.blockIndex = bi;
        chunkTail.extend(blockChunk);
      });
      return chunkTail;
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (fromPos === toPos)
        return "";
      var input = "";
      this._forEachBlocksInRange(fromPos, toPos, function(b, _, fromPos2, toPos2) {
        input += b.extractInput(fromPos2, toPos2, flags);
      });
      return input;
    }
  }, {
    key: "_findStopBefore",
    value: function _findStopBefore(blockIndex) {
      var stopBefore;
      for (var si = 0; si < this._stops.length; ++si) {
        var stop = this._stops[si];
        if (stop <= blockIndex)
          stopBefore = stop;
        else
          break;
      }
      return stopBefore;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder(toBlockIndex) {
      var _this3 = this;
      var details = new ChangeDetails();
      if (this.lazy && toBlockIndex == null)
        return details;
      var startBlockIter = this._mapPosToBlock(this.value.length);
      if (!startBlockIter)
        return details;
      var startBlockIndex = startBlockIter.index;
      var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
      this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function(b) {
        if (!b.lazy || toBlockIndex != null) {
          var args = b._blocks != null ? [b._blocks.length] : [];
          var bDetails = b._appendPlaceholder.apply(b, args);
          _this3._value += bDetails.inserted;
          details.aggregate(bDetails);
        }
      });
      return details;
    }
  }, {
    key: "_mapPosToBlock",
    value: function _mapPosToBlock(pos) {
      var accVal = "";
      for (var bi = 0; bi < this._blocks.length; ++bi) {
        var _block2 = this._blocks[bi];
        var blockStartPos = accVal.length;
        accVal += _block2.value;
        if (pos <= accVal.length) {
          return {
            index: bi,
            offset: pos - blockStartPos
          };
        }
      }
    }
  }, {
    key: "_blockStartPos",
    value: function _blockStartPos(blockIndex) {
      return this._blocks.slice(0, blockIndex).reduce(function(pos, b) {
        return pos += b.value.length;
      }, 0);
    }
  }, {
    key: "_forEachBlocksInRange",
    value: function _forEachBlocksInRange(fromPos) {
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var fn = arguments.length > 2 ? arguments[2] : void 0;
      var fromBlockIter = this._mapPosToBlock(fromPos);
      if (fromBlockIter) {
        var toBlockIter = this._mapPosToBlock(toPos);
        var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
        var fromBlockStartPos = fromBlockIter.offset;
        var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
        if (toBlockIter && !isSameBlock) {
          for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
            fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
          }
          fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var removeDetails = _get(_getPrototypeOf$1(MaskedPattern2.prototype), "remove", this).call(this, fromPos, toPos);
      this._forEachBlocksInRange(fromPos, toPos, function(b, _, bFromPos, bToPos) {
        removeDetails.aggregate(b.remove(bFromPos, bToPos));
      });
      return removeDetails;
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DIRECTION.NONE;
      var beginBlockData = this._mapPosToBlock(cursorPos) || {
        index: 0,
        offset: 0
      };
      var beginBlockOffset = beginBlockData.offset, beginBlockIndex = beginBlockData.index;
      var beginBlock = this._blocks[beginBlockIndex];
      if (!beginBlock)
        return cursorPos;
      var beginBlockCursorPos = beginBlockOffset;
      if (beginBlockCursorPos !== 0 && beginBlockCursorPos < beginBlock.value.length) {
        beginBlockCursorPos = beginBlock.nearestInputPos(beginBlockOffset, forceDirection(direction));
      }
      var cursorAtRight = beginBlockCursorPos === beginBlock.value.length;
      var cursorAtLeft = beginBlockCursorPos === 0;
      if (!cursorAtLeft && !cursorAtRight)
        return this._blockStartPos(beginBlockIndex) + beginBlockCursorPos;
      var searchBlockIndex = cursorAtRight ? beginBlockIndex + 1 : beginBlockIndex;
      if (direction === DIRECTION.NONE) {
        if (searchBlockIndex > 0) {
          var blockIndexAtLeft = searchBlockIndex - 1;
          var blockAtLeft = this._blocks[blockIndexAtLeft];
          var blockInputPos = blockAtLeft.nearestInputPos(0, DIRECTION.NONE);
          if (!blockAtLeft.value.length || blockInputPos !== blockAtLeft.value.length) {
            return this._blockStartPos(searchBlockIndex);
          }
        }
        var firstInputAtRight = searchBlockIndex;
        for (var bi = firstInputAtRight; bi < this._blocks.length; ++bi) {
          var blockAtRight = this._blocks[bi];
          var _blockInputPos = blockAtRight.nearestInputPos(0, DIRECTION.NONE);
          if (!blockAtRight.value.length || _blockInputPos !== blockAtRight.value.length) {
            return this._blockStartPos(bi) + _blockInputPos;
          }
        }
        for (var _bi = searchBlockIndex - 1; _bi >= 0; --_bi) {
          var _block3 = this._blocks[_bi];
          var _blockInputPos2 = _block3.nearestInputPos(0, DIRECTION.NONE);
          if (!_block3.value.length || _blockInputPos2 !== _block3.value.length) {
            return this._blockStartPos(_bi) + _block3.value.length;
          }
        }
        return cursorPos;
      }
      if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
        var firstFilledBlockIndexAtRight;
        for (var _bi2 = searchBlockIndex; _bi2 < this._blocks.length; ++_bi2) {
          if (this._blocks[_bi2].value) {
            firstFilledBlockIndexAtRight = _bi2;
            break;
          }
        }
        if (firstFilledBlockIndexAtRight != null) {
          var filledBlock = this._blocks[firstFilledBlockIndexAtRight];
          var _blockInputPos3 = filledBlock.nearestInputPos(0, DIRECTION.RIGHT);
          if (_blockInputPos3 === 0 && filledBlock.unmaskedValue.length) {
            return this._blockStartPos(firstFilledBlockIndexAtRight) + _blockInputPos3;
          }
        }
        var firstFilledInputBlockIndex = -1;
        var firstEmptyInputBlockIndex;
        for (var _bi3 = searchBlockIndex - 1; _bi3 >= 0; --_bi3) {
          var _block4 = this._blocks[_bi3];
          var _blockInputPos4 = _block4.nearestInputPos(_block4.value.length, DIRECTION.FORCE_LEFT);
          if (!_block4.value || _blockInputPos4 !== 0)
            firstEmptyInputBlockIndex = _bi3;
          if (_blockInputPos4 !== 0) {
            if (_blockInputPos4 !== _block4.value.length) {
              return this._blockStartPos(_bi3) + _blockInputPos4;
            } else {
              firstFilledInputBlockIndex = _bi3;
              break;
            }
          }
        }
        if (direction === DIRECTION.LEFT) {
          for (var _bi4 = firstFilledInputBlockIndex + 1; _bi4 <= Math.min(searchBlockIndex, this._blocks.length - 1); ++_bi4) {
            var _block5 = this._blocks[_bi4];
            var _blockInputPos5 = _block5.nearestInputPos(0, DIRECTION.NONE);
            var blockAlignedPos = this._blockStartPos(_bi4) + _blockInputPos5;
            if (blockAlignedPos > cursorPos)
              break;
            if (_blockInputPos5 !== _block5.value.length)
              return blockAlignedPos;
          }
        }
        if (firstFilledInputBlockIndex >= 0) {
          return this._blockStartPos(firstFilledInputBlockIndex) + this._blocks[firstFilledInputBlockIndex].value.length;
        }
        if (direction === DIRECTION.FORCE_LEFT || this.lazy && !this.extractInput() && !isInput(this._blocks[searchBlockIndex])) {
          return 0;
        }
        if (firstEmptyInputBlockIndex != null) {
          return this._blockStartPos(firstEmptyInputBlockIndex);
        }
        for (var _bi5 = searchBlockIndex; _bi5 < this._blocks.length; ++_bi5) {
          var _block6 = this._blocks[_bi5];
          var _blockInputPos6 = _block6.nearestInputPos(0, DIRECTION.NONE);
          if (!_block6.value.length || _blockInputPos6 !== _block6.value.length) {
            return this._blockStartPos(_bi5) + _blockInputPos6;
          }
        }
        return 0;
      }
      if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
        var firstInputBlockAlignedIndex;
        var firstInputBlockAlignedPos;
        for (var _bi6 = searchBlockIndex; _bi6 < this._blocks.length; ++_bi6) {
          var _block7 = this._blocks[_bi6];
          var _blockInputPos7 = _block7.nearestInputPos(0, DIRECTION.NONE);
          if (_blockInputPos7 !== _block7.value.length) {
            firstInputBlockAlignedPos = this._blockStartPos(_bi6) + _blockInputPos7;
            firstInputBlockAlignedIndex = _bi6;
            break;
          }
        }
        if (firstInputBlockAlignedIndex != null && firstInputBlockAlignedPos != null) {
          for (var _bi7 = firstInputBlockAlignedIndex; _bi7 < this._blocks.length; ++_bi7) {
            var _block8 = this._blocks[_bi7];
            var _blockInputPos8 = _block8.nearestInputPos(0, DIRECTION.FORCE_RIGHT);
            if (_blockInputPos8 !== _block8.value.length) {
              return this._blockStartPos(_bi7) + _blockInputPos8;
            }
          }
          return direction === DIRECTION.FORCE_RIGHT ? this.value.length : firstInputBlockAlignedPos;
        }
        for (var _bi8 = Math.min(searchBlockIndex, this._blocks.length - 1); _bi8 >= 0; --_bi8) {
          var _block9 = this._blocks[_bi8];
          var _blockInputPos9 = _block9.nearestInputPos(_block9.value.length, DIRECTION.LEFT);
          if (_blockInputPos9 !== 0) {
            var alignedPos = this._blockStartPos(_bi8) + _blockInputPos9;
            if (alignedPos >= cursorPos)
              return alignedPos;
            break;
          }
        }
      }
      return cursorPos;
    }
  }, {
    key: "maskedBlock",
    value: function maskedBlock(name2) {
      return this.maskedBlocks(name2)[0];
    }
  }, {
    key: "maskedBlocks",
    value: function maskedBlocks(name2) {
      var _this4 = this;
      var indices = this._maskedBlocks[name2];
      if (!indices)
        return [];
      return indices.map(function(gi) {
        return _this4._blocks[gi];
      });
    }
  }]);
  return MaskedPattern2;
}(Masked);
MaskedPattern.DEFAULTS = {
  lazy: true,
  placeholderChar: "_"
};
MaskedPattern.STOP_CHAR = "`";
MaskedPattern.ESCAPE_CHAR = "\\";
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
function isInput(block) {
  if (!block)
    return false;
  var value = block.value;
  return !value || block.nearestInputPos(0, DIRECTION.NONE) !== value.length;
}
IMask.MaskedPattern = MaskedPattern;
var MaskedRange = /* @__PURE__ */ function(_MaskedPattern) {
  _inherits$1(MaskedRange2, _MaskedPattern);
  var _super = _createSuper$1(MaskedRange2);
  function MaskedRange2() {
    _classCallCheck$1(this, MaskedRange2);
    return _super.apply(this, arguments);
  }
  _createClass$1(MaskedRange2, [{
    key: "_matchFrom",
    get: function get() {
      return this.maxLength - String(this.from).length;
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      opts = Object.assign({
        to: this.to || 0,
        from: this.from || 0
      }, opts);
      var maxLength = String(opts.to).length;
      if (opts.maxLength != null)
        maxLength = Math.max(maxLength, opts.maxLength);
      opts.maxLength = maxLength;
      var fromStr = String(opts.from).padStart(maxLength, "0");
      var toStr = String(opts.to).padStart(maxLength, "0");
      var sameCharsCount = 0;
      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
        ++sameCharsCount;
      }
      opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(maxLength - sameCharsCount);
      _get(_getPrototypeOf$1(MaskedRange2.prototype), "_update", this).call(this, opts);
    }
  }, {
    key: "isComplete",
    get: function get() {
      return _get(_getPrototypeOf$1(MaskedRange2.prototype), "isComplete", this) && Boolean(this.value);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = "";
      var maxstr = "";
      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [], _ref2 = _slicedToArray(_ref, 3), placeholder = _ref2[1], num = _ref2[2];
      if (num) {
        minstr = "0".repeat(placeholder.length) + num;
        maxstr = "9".repeat(placeholder.length) + num;
      }
      minstr = minstr.padEnd(this.maxLength, "0");
      maxstr = maxstr.padEnd(this.maxLength, "9");
      return [minstr, maxstr];
    }
  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      str = _get(_getPrototypeOf$1(MaskedRange2.prototype), "doPrepare", this).call(this, str, flags).replace(/\D/g, "");
      if (!this.autofix)
        return str;
      var fromStr = String(this.from).padStart(this.maxLength, "0");
      var toStr = String(this.to).padStart(this.maxLength, "0");
      var val = this.value;
      var prepStr = "";
      for (var ci = 0; ci < str.length; ++ci) {
        var nextVal = val + prepStr + str[ci];
        var _this$boundaries = this.boundaries(nextVal), _this$boundaries2 = _slicedToArray(_this$boundaries, 2), minstr = _this$boundaries2[0], maxstr = _this$boundaries2[1];
        if (Number(maxstr) < this.from)
          prepStr += fromStr[nextVal.length - 1];
        else if (Number(minstr) > this.to)
          prepStr += toStr[nextVal.length - 1];
        else
          prepStr += str[ci];
      }
      return prepStr;
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;
      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom)
        return true;
      var _this$boundaries3 = this.boundaries(str), _this$boundaries4 = _slicedToArray(_this$boundaries3, 2), minstr = _this$boundaries4[0], maxstr = _this$boundaries4[1];
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf$1(MaskedRange2.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);
  return MaskedRange2;
}(MaskedPattern);
IMask.MaskedRange = MaskedRange;
var MaskedDate = /* @__PURE__ */ function(_MaskedPattern) {
  _inherits$1(MaskedDate2, _MaskedPattern);
  var _super = _createSuper$1(MaskedDate2);
  function MaskedDate2(opts) {
    _classCallCheck$1(this, MaskedDate2);
    return _super.call(this, Object.assign({}, MaskedDate2.DEFAULTS, opts));
  }
  _createClass$1(MaskedDate2, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.mask === Date)
        delete opts.mask;
      if (opts.pattern)
        opts.mask = opts.pattern;
      var blocks = opts.blocks;
      opts.blocks = Object.assign({}, MaskedDate2.GET_DEFAULT_BLOCKS());
      if (opts.min)
        opts.blocks.Y.from = opts.min.getFullYear();
      if (opts.max)
        opts.blocks.Y.to = opts.max.getFullYear();
      if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
        opts.blocks.m.from = opts.min.getMonth() + 1;
        opts.blocks.m.to = opts.max.getMonth() + 1;
        if (opts.blocks.m.from === opts.blocks.m.to) {
          opts.blocks.d.from = opts.min.getDate();
          opts.blocks.d.to = opts.max.getDate();
        }
      }
      Object.assign(opts.blocks, blocks);
      Object.keys(opts.blocks).forEach(function(bk) {
        var b = opts.blocks[bk];
        if (!("autofix" in b))
          b.autofix = opts.autofix;
      });
      _get(_getPrototypeOf$1(MaskedDate2.prototype), "_update", this).call(this, opts);
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;
      var date = this.date;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf$1(MaskedDate2.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
  }, {
    key: "isDateExist",
    value: function isDateExist(str) {
      return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
  }, {
    key: "date",
    get: function get() {
      return this.typedValue;
    },
    set: function set2(date) {
      this.typedValue = date;
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.isComplete ? _get(_getPrototypeOf$1(MaskedDate2.prototype), "typedValue", this) : null;
    },
    set: function set2(value) {
      _set(_getPrototypeOf$1(MaskedDate2.prototype), "typedValue", value, this, true);
    }
  }]);
  return MaskedDate2;
}(MaskedPattern);
MaskedDate.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: function format2(date) {
    var day = String(date.getDate()).padStart(2, "0");
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var year = date.getFullYear();
    return [day, month, year].join(".");
  },
  parse: function parse2(str) {
    var _str$split = str.split("."), _str$split2 = _slicedToArray(_str$split, 3), day = _str$split2[0], month = _str$split2[1], year = _str$split2[2];
    return new Date(year, month - 1, day);
  }
};
MaskedDate.GET_DEFAULT_BLOCKS = function() {
  return {
    d: {
      mask: MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      mask: MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      mask: MaskedRange,
      from: 1900,
      to: 9999
    }
  };
};
IMask.MaskedDate = MaskedDate;
var MaskElement = /* @__PURE__ */ function() {
  function MaskElement2() {
    _classCallCheck$1(this, MaskElement2);
  }
  _createClass$1(MaskElement2, [{
    key: "selectionStart",
    get: function get() {
      var start;
      try {
        start = this._unsafeSelectionStart;
      } catch (e) {
      }
      return start != null ? start : this.value.length;
    }
  }, {
    key: "selectionEnd",
    get: function get() {
      var end;
      try {
        end = this._unsafeSelectionEnd;
      } catch (e) {
      }
      return end != null ? end : this.value.length;
    }
  }, {
    key: "select",
    value: function select(start, end) {
      if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd)
        return;
      try {
        this._unsafeSelect(start, end);
      } catch (e) {
      }
    }
  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
    }
  }, {
    key: "isActive",
    get: function get() {
      return false;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
    }
  }]);
  return MaskElement2;
}();
IMask.MaskElement = MaskElement;
var HTMLMaskElement = /* @__PURE__ */ function(_MaskElement) {
  _inherits$1(HTMLMaskElement2, _MaskElement);
  var _super = _createSuper$1(HTMLMaskElement2);
  function HTMLMaskElement2(input) {
    var _this;
    _classCallCheck$1(this, HTMLMaskElement2);
    _this = _super.call(this);
    _this.input = input;
    _this._handlers = {};
    return _this;
  }
  _createClass$1(HTMLMaskElement2, [{
    key: "rootElement",
    get: function get() {
      return this.input.getRootNode ? this.input.getRootNode() : document;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.input === this.rootElement.activeElement;
    }
  }, {
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart;
    }
  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }
  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set2(value) {
      this.input.value = value;
    }
  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {
      var _this2 = this;
      Object.keys(handlers).forEach(function(event) {
        return _this2._toggleEventHandler(HTMLMaskElement2.EVENTS_MAP[event], handlers[event]);
      });
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var _this3 = this;
      Object.keys(this._handlers).forEach(function(event) {
        return _this3._toggleEventHandler(event);
      });
    }
  }, {
    key: "_toggleEventHandler",
    value: function _toggleEventHandler(event, handler) {
      if (this._handlers[event]) {
        this.input.removeEventListener(event, this._handlers[event]);
        delete this._handlers[event];
      }
      if (handler) {
        this.input.addEventListener(event, handler);
        this._handlers[event] = handler;
      }
    }
  }]);
  return HTMLMaskElement2;
}(MaskElement);
HTMLMaskElement.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
IMask.HTMLMaskElement = HTMLMaskElement;
var HTMLContenteditableMaskElement = /* @__PURE__ */ function(_HTMLMaskElement) {
  _inherits$1(HTMLContenteditableMaskElement2, _HTMLMaskElement);
  var _super = _createSuper$1(HTMLContenteditableMaskElement2);
  function HTMLContenteditableMaskElement2() {
    _classCallCheck$1(this, HTMLContenteditableMaskElement2);
    return _super.apply(this, arguments);
  }
  _createClass$1(HTMLContenteditableMaskElement2, [{
    key: "_unsafeSelectionStart",
    get: function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      return selection && selection.anchorOffset;
    }
  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      return selection && this._unsafeSelectionStart + String(selection).length;
    }
  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      if (!this.rootElement.createRange)
        return;
      var range = this.rootElement.createRange();
      range.setStart(this.input.firstChild || this.input, start);
      range.setEnd(this.input.lastChild || this.input, end);
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }, {
    key: "value",
    get: function get() {
      return this.input.textContent;
    },
    set: function set2(value) {
      this.input.textContent = value;
    }
  }]);
  return HTMLContenteditableMaskElement2;
}(HTMLMaskElement);
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
var _excluded$2 = ["mask"];
var InputMask = /* @__PURE__ */ function() {
  function InputMask2(el, opts) {
    _classCallCheck$1(this, InputMask2);
    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = "";
    this._unmaskedValue = "";
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();
    this.updateValue();
    this._onChange();
  }
  _createClass$1(InputMask2, [{
    key: "mask",
    get: function get() {
      return this.masked.mask;
    },
    set: function set2(mask) {
      if (this.maskEquals(mask))
        return;
      if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
        this.masked.updateOptions({
          mask
        });
        return;
      }
      var masked = createMask({
        mask
      });
      masked.unmaskedValue = this.masked.unmaskedValue;
      this.masked = masked;
    }
  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return mask == null || mask === this.masked.mask || mask === Date && this.masked instanceof MaskedDate;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set2(str) {
      this.masked.value = str;
      this.updateControl();
      this.alignCursor();
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._unmaskedValue;
    },
    set: function set2(str) {
      this.masked.unmaskedValue = str;
      this.updateControl();
      this.alignCursor();
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.masked.typedValue;
    },
    set: function set2(val) {
      this.masked.typedValue = val;
      this.updateControl();
      this.alignCursor();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      this.el.bindEvents({
        selectionChange: this._saveSelection,
        input: this._onInput,
        drop: this._onDrop,
        click: this._onClick,
        focus: this._onFocus,
        commit: this._onChange
      });
    }
  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      if (this.el)
        this.el.unbindEvents();
    }
  }, {
    key: "_fireEvent",
    value: function _fireEvent(ev) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var listeners = this._listeners[ev];
      if (!listeners)
        return;
      listeners.forEach(function(l) {
        return l.apply(void 0, args);
      });
    }
  }, {
    key: "selectionStart",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
  }, {
    key: "cursorPos",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    },
    set: function set2(pos) {
      if (!this.el || !this.el.isActive)
        return;
      this.el.select(pos, pos);
      this._saveSelection();
    }
  }, {
    key: "_saveSelection",
    value: function _saveSelection() {
      if (this.value !== this.el.value) {
        console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.");
      }
      this._selection = {
        start: this.selectionStart,
        end: this.cursorPos
      };
    }
  }, {
    key: "updateValue",
    value: function updateValue() {
      this.masked.value = this.el.value;
      this._value = this.masked.value;
    }
  }, {
    key: "updateControl",
    value: function updateControl() {
      var newUnmaskedValue = this.masked.unmaskedValue;
      var newValue = this.masked.value;
      var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
      this._unmaskedValue = newUnmaskedValue;
      this._value = newValue;
      if (this.el.value !== newValue)
        this.el.value = newValue;
      if (isChanged)
        this._fireChangeEvents();
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      var mask = opts.mask, restOpts = _objectWithoutProperties$1(opts, _excluded$2);
      var updateMask = !this.maskEquals(mask);
      var updateOpts = !objectIncludes(this.masked, restOpts);
      if (updateMask)
        this.mask = mask;
      if (updateOpts)
        this.masked.updateOptions(restOpts);
      if (updateMask || updateOpts)
        this.updateControl();
    }
  }, {
    key: "updateCursor",
    value: function updateCursor(cursorPos) {
      if (cursorPos == null)
        return;
      this.cursorPos = cursorPos;
      this._delayUpdateCursor(cursorPos);
    }
  }, {
    key: "_delayUpdateCursor",
    value: function _delayUpdateCursor(cursorPos) {
      var _this = this;
      this._abortUpdateCursor();
      this._changingCursorPos = cursorPos;
      this._cursorChanging = setTimeout(function() {
        if (!_this.el)
          return;
        _this.cursorPos = _this._changingCursorPos;
        _this._abortUpdateCursor();
      }, 10);
    }
  }, {
    key: "_fireChangeEvents",
    value: function _fireChangeEvents() {
      this._fireEvent("accept", this._inputEvent);
      if (this.masked.isComplete)
        this._fireEvent("complete", this._inputEvent);
    }
  }, {
    key: "_abortUpdateCursor",
    value: function _abortUpdateCursor() {
      if (this._cursorChanging) {
        clearTimeout(this._cursorChanging);
        delete this._cursorChanging;
      }
    }
  }, {
    key: "alignCursor",
    value: function alignCursor() {
      this.cursorPos = this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT);
    }
  }, {
    key: "alignCursorFriendly",
    value: function alignCursorFriendly() {
      if (this.selectionStart !== this.cursorPos)
        return;
      this.alignCursor();
    }
  }, {
    key: "on",
    value: function on(ev, handler) {
      if (!this._listeners[ev])
        this._listeners[ev] = [];
      this._listeners[ev].push(handler);
      return this;
    }
  }, {
    key: "off",
    value: function off(ev, handler) {
      if (!this._listeners[ev])
        return this;
      if (!handler) {
        delete this._listeners[ev];
        return this;
      }
      var hIndex = this._listeners[ev].indexOf(handler);
      if (hIndex >= 0)
        this._listeners[ev].splice(hIndex, 1);
      return this;
    }
  }, {
    key: "_onInput",
    value: function _onInput(e) {
      this._inputEvent = e;
      this._abortUpdateCursor();
      if (!this._selection)
        return this.updateValue();
      var details = new ActionDetails(this.el.value, this.cursorPos, this.value, this._selection);
      var oldRawValue = this.masked.rawInputValue;
      var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection).offset;
      var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
      var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
      this.updateControl();
      this.updateCursor(cursorPos);
      delete this._inputEvent;
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      if (this.value !== this.el.value) {
        this.updateValue();
      }
      this.masked.doCommit();
      this.updateControl();
      this._saveSelection();
    }
  }, {
    key: "_onDrop",
    value: function _onDrop(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }, {
    key: "_onFocus",
    value: function _onFocus(ev) {
      this.alignCursorFriendly();
    }
  }, {
    key: "_onClick",
    value: function _onClick(ev) {
      this.alignCursorFriendly();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._unbindEvents();
      this._listeners.length = 0;
      delete this.el;
    }
  }]);
  return InputMask2;
}();
IMask.InputMask = InputMask;
var MaskedEnum = /* @__PURE__ */ function(_MaskedPattern) {
  _inherits$1(MaskedEnum2, _MaskedPattern);
  var _super = _createSuper$1(MaskedEnum2);
  function MaskedEnum2() {
    _classCallCheck$1(this, MaskedEnum2);
    return _super.apply(this, arguments);
  }
  _createClass$1(MaskedEnum2, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.enum)
        opts.mask = "*".repeat(opts.enum[0].length);
      _get(_getPrototypeOf$1(MaskedEnum2.prototype), "_update", this).call(this, opts);
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this = this, _get2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.enum.some(function(e) {
        return e.indexOf(_this.unmaskedValue) >= 0;
      }) && (_get2 = _get(_getPrototypeOf$1(MaskedEnum2.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);
  return MaskedEnum2;
}(MaskedPattern);
IMask.MaskedEnum = MaskedEnum;
var MaskedNumber = /* @__PURE__ */ function(_Masked) {
  _inherits$1(MaskedNumber2, _Masked);
  var _super = _createSuper$1(MaskedNumber2);
  function MaskedNumber2(opts) {
    _classCallCheck$1(this, MaskedNumber2);
    return _super.call(this, Object.assign({}, MaskedNumber2.DEFAULTS, opts));
  }
  _createClass$1(MaskedNumber2, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf$1(MaskedNumber2.prototype), "_update", this).call(this, opts);
      this._updateRegExps();
    }
  }, {
    key: "_updateRegExps",
    value: function _updateRegExps() {
      var start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
      var midInput = "(0|([1-9]+\\d*))?";
      var mid = "\\d*";
      var end = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
      this._numberRegExpInput = new RegExp(start + midInput + end);
      this._numberRegExp = new RegExp(start + mid + end);
      this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join("") + "]", "g");
      this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
    }
  }, {
    key: "_removeThousandsSeparators",
    value: function _removeThousandsSeparators(value) {
      return value.replace(this._thousandsSeparatorRegExp, "");
    }
  }, {
    key: "_insertThousandsSeparators",
    value: function _insertThousandsSeparators(value) {
      var parts = value.split(this.radix);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
      return parts.join(this.radix);
    }
  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf$1(MaskedNumber2.prototype), "doPrepare", this)).call.apply(_get2, [this, this._removeThousandsSeparators(str.replace(this._mapToRadixRegExp, this.radix))].concat(args));
    }
  }, {
    key: "_separatorsCount",
    value: function _separatorsCount(to) {
      var extendOnSeparators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var count = 0;
      for (var pos = 0; pos < to; ++pos) {
        if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
          ++count;
          if (extendOnSeparators)
            to += this.thousandsSeparator.length;
        }
      }
      return count;
    }
  }, {
    key: "_separatorsCountFromSlice",
    value: function _separatorsCountFromSlice() {
      var slice = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
      return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : void 0;
      var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);
      var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);
      fromPos = _this$_adjustRangeWit2[0];
      toPos = _this$_adjustRangeWit2[1];
      return this._removeThousandsSeparators(_get(_getPrototypeOf$1(MaskedNumber2.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.thousandsSeparator)
        return _get(_getPrototypeOf$1(MaskedNumber2.prototype), "_appendCharRaw", this).call(this, ch, flags);
      var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
      var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
      this._value = this._removeThousandsSeparators(this.value);
      var appendDetails = _get(_getPrototypeOf$1(MaskedNumber2.prototype), "_appendCharRaw", this).call(this, ch, flags);
      this._value = this._insertThousandsSeparators(this._value);
      var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
      appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
      appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
      return appendDetails;
    }
  }, {
    key: "_findSeparatorAround",
    value: function _findSeparatorAround(pos) {
      if (this.thousandsSeparator) {
        var searchFrom = pos - this.thousandsSeparator.length + 1;
        var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
        if (separatorPos <= pos)
          return separatorPos;
      }
      return -1;
    }
  }, {
    key: "_adjustRangeWithSeparators",
    value: function _adjustRangeWithSeparators(from, to) {
      var separatorAroundFromPos = this._findSeparatorAround(from);
      if (separatorAroundFromPos >= 0)
        from = separatorAroundFromPos;
      var separatorAroundToPos = this._findSeparatorAround(to);
      if (separatorAroundToPos >= 0)
        to = separatorAroundToPos + this.thousandsSeparator.length;
      return [from, to];
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);
      var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);
      fromPos = _this$_adjustRangeWit4[0];
      toPos = _this$_adjustRangeWit4[1];
      var valueBeforePos = this.value.slice(0, fromPos);
      var valueAfterPos = this.value.slice(toPos);
      var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
      this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
      return new ChangeDetails({
        tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
      });
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      if (!this.thousandsSeparator)
        return cursorPos;
      switch (direction) {
        case DIRECTION.NONE:
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT: {
          var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
          if (separatorAtLeftPos >= 0) {
            var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
            if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
              return separatorAtLeftPos;
            }
          }
          break;
        }
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT: {
          var separatorAtRightPos = this._findSeparatorAround(cursorPos);
          if (separatorAtRightPos >= 0) {
            return separatorAtRightPos + this.thousandsSeparator.length;
          }
        }
      }
      return cursorPos;
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp;
      var valid = regexp.test(this._removeThousandsSeparators(this.value));
      if (valid) {
        var number = this.number;
        valid = valid && !isNaN(number) && (this.min == null || this.min >= 0 || this.min <= this.number) && (this.max == null || this.max <= 0 || this.number <= this.max);
      }
      return valid && _get(_getPrototypeOf$1(MaskedNumber2.prototype), "doValidate", this).call(this, flags);
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.value) {
        var number = this.number;
        var validnum = number;
        if (this.min != null)
          validnum = Math.max(validnum, this.min);
        if (this.max != null)
          validnum = Math.min(validnum, this.max);
        if (validnum !== number)
          this.unmaskedValue = String(validnum);
        var formatted = this.value;
        if (this.normalizeZeros)
          formatted = this._normalizeZeros(formatted);
        if (this.padFractionalZeros)
          formatted = this._padFractionalZeros(formatted);
        this._value = formatted;
      }
      _get(_getPrototypeOf$1(MaskedNumber2.prototype), "doCommit", this).call(this);
    }
  }, {
    key: "_normalizeZeros",
    value: function _normalizeZeros(value) {
      var parts = this._removeThousandsSeparators(value).split(this.radix);
      parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function(match, sign, zeros, num) {
        return sign + num;
      });
      if (value.length && !/\d$/.test(parts[0]))
        parts[0] = parts[0] + "0";
      if (parts.length > 1) {
        parts[1] = parts[1].replace(/0*$/, "");
        if (!parts[1].length)
          parts.length = 1;
      }
      return this._insertThousandsSeparators(parts.join(this.radix));
    }
  }, {
    key: "_padFractionalZeros",
    value: function _padFractionalZeros(value) {
      if (!value)
        return value;
      var parts = value.split(this.radix);
      if (parts.length < 2)
        parts.push("");
      parts[1] = parts[1].padEnd(this.scale, "0");
      return parts.join(this.radix);
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, ".");
    },
    set: function set2(unmaskedValue) {
      _set(_getPrototypeOf$1(MaskedNumber2.prototype), "unmaskedValue", unmaskedValue.replace(".", this.radix), this, true);
    }
  }, {
    key: "typedValue",
    get: function get() {
      return Number(this.unmaskedValue);
    },
    set: function set2(n) {
      _set(_getPrototypeOf$1(MaskedNumber2.prototype), "unmaskedValue", String(n), this, true);
    }
  }, {
    key: "number",
    get: function get() {
      return this.typedValue;
    },
    set: function set2(number) {
      this.typedValue = number;
    }
  }, {
    key: "allowNegative",
    get: function get() {
      return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
  }]);
  return MaskedNumber2;
}(Masked);
MaskedNumber.DEFAULTS = {
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: ["."],
  scale: 2,
  signed: false,
  normalizeZeros: true,
  padFractionalZeros: false
};
IMask.MaskedNumber = MaskedNumber;
var MaskedFunction = /* @__PURE__ */ function(_Masked) {
  _inherits$1(MaskedFunction2, _Masked);
  var _super = _createSuper$1(MaskedFunction2);
  function MaskedFunction2() {
    _classCallCheck$1(this, MaskedFunction2);
    return _super.apply(this, arguments);
  }
  _createClass$1(MaskedFunction2, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.mask)
        opts.validate = opts.mask;
      _get(_getPrototypeOf$1(MaskedFunction2.prototype), "_update", this).call(this, opts);
    }
  }]);
  return MaskedFunction2;
}(Masked);
IMask.MaskedFunction = MaskedFunction;
var _excluded$1 = ["compiledMasks", "currentMaskRef", "currentMask"];
var MaskedDynamic = /* @__PURE__ */ function(_Masked) {
  _inherits$1(MaskedDynamic2, _Masked);
  var _super = _createSuper$1(MaskedDynamic2);
  function MaskedDynamic2(opts) {
    var _this;
    _classCallCheck$1(this, MaskedDynamic2);
    _this = _super.call(this, Object.assign({}, MaskedDynamic2.DEFAULTS, opts));
    _this.currentMask = null;
    return _this;
  }
  _createClass$1(MaskedDynamic2, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "_update", this).call(this, opts);
      if ("mask" in opts) {
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function(m) {
          return createMask(m);
        }) : [];
      }
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var details = this._applyDispatch(ch, flags);
      if (this.currentMask) {
        details.aggregate(this.currentMask._appendChar(ch, flags));
      }
      return details;
    }
  }, {
    key: "_applyDispatch",
    value: function _applyDispatch() {
      var appended = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
      var inputValue = this.rawInputValue;
      var insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
      var tailValue = inputValue.slice(insertValue.length);
      var prevMask = this.currentMask;
      var details = new ChangeDetails();
      var prevMaskState = prevMask && prevMask.state;
      this.currentMask = this.doDispatch(appended, Object.assign({}, flags));
      if (this.currentMask) {
        if (this.currentMask !== prevMask) {
          this.currentMask.reset();
          if (insertValue) {
            var d = this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = d.inserted.length - prevValueBeforeTail.length;
          }
          if (tailValue) {
            details.tailShift += this.currentMask.append(tailValue, {
              raw: true,
              tail: true
            }).tailShift;
          }
        } else {
          this.currentMask.state = prevMaskState;
        }
      }
      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = this._applyDispatch.apply(this, arguments);
      if (this.currentMask) {
        details.aggregate(this.currentMask._appendPlaceholder());
      }
      return details;
    }
  }, {
    key: "doDispatch",
    value: function doDispatch(appended) {
      var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.dispatch(appended, this, flags);
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2, _this$currentMask;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.currentMask || (_this$currentMask = this.currentMask).doValidate.apply(_this$currentMask, args));
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.currentMask)
        this.currentMask.reset();
      this.compiledMasks.forEach(function(m) {
        return m.reset();
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this.currentMask ? this.currentMask.value : "";
    },
    set: function set2(value) {
      _set(_getPrototypeOf$1(MaskedDynamic2.prototype), "value", value, this, true);
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.unmaskedValue : "";
    },
    set: function set2(unmaskedValue) {
      _set(_getPrototypeOf$1(MaskedDynamic2.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
  }, {
    key: "typedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.typedValue : "";
    },
    set: function set2(value) {
      var unmaskedValue = String(value);
      if (this.currentMask) {
        this.currentMask.typedValue = value;
        unmaskedValue = this.currentMask.unmaskedValue;
      }
      this.unmaskedValue = unmaskedValue;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return !!this.currentMask && this.currentMask.isComplete;
    }
  }, {
    key: "remove",
    value: function remove() {
      var details = new ChangeDetails();
      if (this.currentMask) {
        var _this$currentMask2;
        details.aggregate((_this$currentMask2 = this.currentMask).remove.apply(_this$currentMask2, arguments)).aggregate(this._applyDispatch());
      }
      return details;
    }
  }, {
    key: "state",
    get: function get() {
      return Object.assign({}, _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "state", this), {
        _rawInputValue: this.rawInputValue,
        compiledMasks: this.compiledMasks.map(function(m) {
          return m.state;
        }),
        currentMaskRef: this.currentMask,
        currentMask: this.currentMask && this.currentMask.state
      });
    },
    set: function set2(state) {
      var compiledMasks = state.compiledMasks, currentMaskRef = state.currentMaskRef, currentMask = state.currentMask, maskedState = _objectWithoutProperties$1(state, _excluded$1);
      this.compiledMasks.forEach(function(m, mi) {
        return m.state = compiledMasks[mi];
      });
      if (currentMaskRef != null) {
        this.currentMask = currentMaskRef;
        this.currentMask.state = currentMask;
      }
      _set(_getPrototypeOf$1(MaskedDynamic2.prototype), "state", maskedState, this, true);
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var _this$currentMask3;
      return this.currentMask ? (_this$currentMask3 = this.currentMask).extractInput.apply(_this$currentMask3, arguments) : "";
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$currentMask4, _get3;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.currentMask ? (_this$currentMask4 = this.currentMask).extractTail.apply(_this$currentMask4, args) : (_get3 = _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "extractTail", this)).call.apply(_get3, [this].concat(args));
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.currentMask)
        this.currentMask.doCommit();
      _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "doCommit", this).call(this);
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos() {
      var _this$currentMask5, _get4;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.currentMask ? (_this$currentMask5 = this.currentMask).nearestInputPos.apply(_this$currentMask5, args) : (_get4 = _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "nearestInputPos", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "overwrite",
    get: function get() {
      return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf$1(MaskedDynamic2.prototype), "overwrite", this);
    },
    set: function set2(overwrite) {
      console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
    }
  }]);
  return MaskedDynamic2;
}(Masked);
MaskedDynamic.DEFAULTS = {
  dispatch: function dispatch(appended, masked, flags) {
    if (!masked.compiledMasks.length)
      return;
    var inputValue = masked.rawInputValue;
    var inputs = masked.compiledMasks.map(function(m, index) {
      m.reset();
      m.append(inputValue, {
        raw: true
      });
      m.append(appended, flags);
      var weight = m.rawInputValue.length;
      return {
        weight,
        index
      };
    });
    inputs.sort(function(i1, i2) {
      return i2.weight - i1.weight;
    });
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;
var PIPE_TYPE = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function createPipe(mask) {
  var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : PIPE_TYPE.MASKED;
  var to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : PIPE_TYPE.MASKED;
  var masked = createMask(mask);
  return function(value) {
    return masked.runIsolated(function(m) {
      m[from] = value;
      return m[to];
    });
  };
}
function pipe(value) {
  for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipeArgs[_key - 1] = arguments[_key];
  }
  return createPipe.apply(void 0, pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;
try {
  globalThis.IMask = IMask;
} catch (e) {
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var MASK_PROPS = {
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.instanceOf(RegExp), PropTypes.oneOf([Date, Number, IMask.Masked]), PropTypes.instanceOf(IMask.Masked)]),
  value: PropTypes.any,
  unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["typed"])]),
  prepare: PropTypes.func,
  validate: PropTypes.func,
  commit: PropTypes.func,
  overwrite: PropTypes.bool,
  onAccept: PropTypes.func,
  onComplete: PropTypes.func,
  placeholderChar: PropTypes.string,
  lazy: PropTypes.bool,
  definitions: PropTypes.object,
  blocks: PropTypes.object,
  pattern: PropTypes.string,
  format: PropTypes.func,
  parse: PropTypes.func,
  autofix: PropTypes.bool,
  radix: PropTypes.string,
  thousandsSeparator: PropTypes.string,
  mapToRadix: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.number,
  signed: PropTypes.bool,
  normalizeZeros: PropTypes.bool,
  padFractionalZeros: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  dispatch: PropTypes.func,
  inputRef: PropTypes.func
};
var MASK_PROPS_NAMES = Object.keys(MASK_PROPS);
var NON_MASK_OPTIONS_PROPS_NAMES = ["value", "unmask", "onAccept", "onComplete", "inputRef"];
var MASK_OPTIONS_PROPS_NAMES = MASK_PROPS_NAMES.filter(function(pName) {
  return NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0;
});
function IMaskMixin(ComposedComponent) {
  var MaskedComponent = /* @__PURE__ */ function(_React$Component) {
    _inherits(MaskedComponent2, _React$Component);
    var _super = _createSuper(MaskedComponent2);
    function MaskedComponent2(props) {
      var _this;
      _classCallCheck(this, MaskedComponent2);
      _this = _super.call(this, props);
      _this._inputRef = _this._inputRef.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(MaskedComponent2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.props.mask)
          return;
        this.initMask();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var maskOptions = this._extractMaskOptionsFromProps(props);
        if (maskOptions.mask) {
          if (this.maskRef) {
            this.maskRef.updateOptions(maskOptions);
            if ("value" in props && (props.value !== this.maskValue || typeof props.value !== "string" && this.maskRef.value === "" && !this.maskRef.el.isActive)) {
              this.maskValue = props.value;
            }
          } else {
            this.initMask(maskOptions);
          }
        } else {
          this.destroyMask();
          if ("value" in props)
            this.element.value = props.value;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyMask();
      }
    }, {
      key: "_inputRef",
      value: function _inputRef(el) {
        this.element = el;
        if (this.props.inputRef)
          this.props.inputRef(el);
      }
    }, {
      key: "initMask",
      value: function initMask() {
        var maskOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._extractMaskOptionsFromProps(this.props);
        this.maskRef = IMask(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
        if ("value" in this.props)
          this.maskValue = this.props.value;
      }
    }, {
      key: "destroyMask",
      value: function destroyMask() {
        if (this.maskRef) {
          this.maskRef.destroy();
          delete this.maskRef;
        }
      }
    }, {
      key: "_extractMaskOptionsFromProps",
      value: function _extractMaskOptionsFromProps(props) {
        var cloneProps = Object.assign({}, props);
        Object.keys(cloneProps).filter(function(prop) {
          return MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0;
        }).forEach(function(nonMaskProp) {
          delete cloneProps[nonMaskProp];
        });
        return cloneProps;
      }
    }, {
      key: "_extractNonMaskProps",
      value: function _extractNonMaskProps(props) {
        var cloneProps = Object.assign({}, props);
        MASK_PROPS_NAMES.forEach(function(maskProp) {
          delete cloneProps[maskProp];
        });
        return cloneProps;
      }
    }, {
      key: "maskValue",
      get: function get() {
        if (this.props.unmask === "typed")
          return this.maskRef.typedValue;
        if (this.props.unmask)
          return this.maskRef.unmaskedValue;
        return this.maskRef.value;
      },
      set: function set2(value) {
        value = value == null ? "" : value;
        if (this.props.unmask === "typed")
          this.maskRef.typedValue = value;
        else if (this.props.unmask)
          this.maskRef.unmaskedValue = value;
        else
          this.maskRef.value = value;
      }
    }, {
      key: "_onAccept",
      value: function _onAccept(e) {
        if (this.props.onAccept)
          this.props.onAccept(this.maskValue, this.maskRef, e);
      }
    }, {
      key: "_onComplete",
      value: function _onComplete(e) {
        if (this.props.onComplete)
          this.props.onComplete(this.maskValue, this.maskRef, e);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), {
          inputRef: this._inputRef
        }));
      }
    }]);
    return MaskedComponent2;
  }(React.Component);
  var nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
  MaskedComponent.propTypes = MASK_PROPS;
  return MaskedComponent;
}
var _excluded = ["inputRef"];
var InputComponent = function InputComponent2(_ref) {
  var inputRef = _ref.inputRef, props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement("input", Object.assign({}, props, {
    ref: inputRef
  }));
};
var IMaskInput = IMaskMixin(InputComponent);
const Wrapper$f = styled.div`
  border: none;
  padding: 0;
  margin: 0;

  input {
    width: 100%;
    background: transparent;
    color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    display: block;
  }

  label {
    cursor: pointer;
    color: ${({ theme }) => theme.themeColors.text};
  }

  input::placeholder {
    color: ${({ theme }) => convertHexToRGBA(theme.themeColors.text, 0.3)};
  }

  .input-text-prefix,
  input,
  input::placeholder {
    font-size: 16px;
    line-height: 18px;
  }
`;
const InputWrapper$1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const ErrorMessage$5 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const Prefix = styled.div`
  margin-right: 2px;

  &,
  * {
    color: ${({ theme }) => theme.themeColors.text};
  }
`;
const generateMaskOptions = (maskType) => {
  if (INPUT_MASK_TYPES.phone === maskType) {
    return {
      mask: "000-000-0000"
    };
  }
  if (INPUT_MASK_TYPES.dollarAmount === maskType) {
    return {
      mask: Number,
      scale: 2,
      signed: false,
      thousandsSeparator: ",",
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: ".",
      mapToRadix: ["."],
      max: 1e6
    };
  }
  if (INPUT_MASK_TYPES.centsAmount === maskType) {
    return {
      mask: Number,
      scale: 2,
      signed: true,
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: ".",
      mapToRadix: ["."],
      max: 0.99
    };
  }
  return {
    mask: null
  };
};
const TextInput = ({
  name: name2,
  inputRef,
  type,
  prefix,
  value,
  valueSanitizer,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  label,
  error,
  disabled,
  inputProps,
  autoFocus,
  maskType
}) => {
  const ref = React.useRef(null);
  const [opts, setOpts] = React.useState(generateMaskOptions(maskType));
  const [isFocused, setIsFocused] = React.useState(false);
  React.useEffect(() => {
    var _a, _b;
    if (autoFocus) {
      (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.focus();
      (_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.focus();
    }
  }, []);
  const handleChange = React.useCallback((e) => {
    if (opts.mask) {
      return;
    }
    const prevValue = value;
    let newValue = e.target.value;
    if (valueSanitizer) {
      newValue = valueSanitizer(newValue, prevValue);
    }
    onChange(name2)(newValue);
  }, [value, onChange, valueSanitizer, opts]);
  const handleAccept = React.useCallback((v) => {
    onChange(name2)(v);
  }, [value, onChange, valueSanitizer]);
  const handleFocus = () => {
    setIsFocused(true);
    onFocus && onFocus(name2);
  };
  const handleBlur = () => {
    setIsFocused(false);
    onBlur && onBlur(name2);
  };
  return /* @__PURE__ */ React.createElement(Wrapper$f, {
    className: `text-wrapper ${isFocused ? "focused" : ""}`
  }, /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, label && /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputWrapper$1, {
    className: "sc-input-wrapper"
  }, prefix && /* @__PURE__ */ React.createElement(Prefix, {
    className: "input-text-prefix"
  }, prefix), !!maskType ? /* @__PURE__ */ React.createElement(IMaskInput, __spreadValues(__spreadProps(__spreadValues({}, opts), {
    inputRef: (el) => ref.current = el,
    id: name2,
    type: type || "text",
    name: name2,
    placeholder: placeholder || "",
    value,
    onChange: handleChange,
    onAccept: (value2, mask) => {
      handleAccept(value2);
    },
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled
  }), inputProps || {})) : /* @__PURE__ */ React.createElement("input", __spreadValues({
    ref: inputRef || ref,
    id: name2,
    type: type || "text",
    name: name2,
    placeholder: placeholder || "",
    value,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled
  }, inputProps || {}))), error && /* @__PURE__ */ React.createElement(ErrorMessage$5, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
var reactDayPicker_min = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t(React);
  }(typeof self != "undefined" ? self : commonjsGlobal, function(e) {
    return function(e2) {
      function t(o) {
        if (n[o])
          return n[o].exports;
        var r = n[o] = { i: o, l: false, exports: {} };
        return e2[o].call(r.exports, r, r.exports, t), r.l = true, r.exports;
      }
      var n = {};
      return t.m = e2, t.c = n, t.d = function(e3, n2, o) {
        t.o(e3, n2) || Object.defineProperty(e3, n2, { configurable: false, enumerable: true, get: o });
      }, t.n = function(e3) {
        var n2 = e3 && e3.__esModule ? function() {
          return e3.default;
        } : function() {
          return e3;
        };
        return t.d(n2, "a", n2), n2;
      }, t.o = function(e3, t2) {
        return Object.prototype.hasOwnProperty.call(e3, t2);
      }, t.p = "", t(t.s = 8);
    }([function(t, n) {
      t.exports = e;
    }, function(e2, t, n) {
      function o(e3) {
        return new Date(e3.getTime());
      }
      function r(e3) {
        return e3 instanceof Date && !isNaN(e3.valueOf());
      }
      function a(e3, t2) {
        var n2 = o(e3);
        return n2.setMonth(e3.getMonth() + t2), n2;
      }
      function s(e3, t2) {
        return !(!e3 || !t2) && (e3.getDate() === t2.getDate() && e3.getMonth() === t2.getMonth() && e3.getFullYear() === t2.getFullYear());
      }
      function i(e3, t2) {
        return !(!e3 || !t2) && (e3.getMonth() === t2.getMonth() && e3.getFullYear() === t2.getFullYear());
      }
      function u(e3, t2) {
        return o(e3).setHours(0, 0, 0, 0) < o(t2).setHours(0, 0, 0, 0);
      }
      function l(e3, t2) {
        return o(e3).setHours(0, 0, 0, 0) > o(t2).setHours(0, 0, 0, 0);
      }
      function c(e3) {
        var t2 = new Date();
        return t2.setHours(0, 0, 0, 0), u(e3, t2);
      }
      function p(e3) {
        var t2 = new Date(new Date().getTime() + 864e5);
        return t2.setHours(0, 0, 0, 0), e3 >= t2;
      }
      function f(e3, t2, n2) {
        var r2 = o(e3);
        return r2.setHours(0, 0, 0, 0), l(r2, t2) && u(r2, n2) || l(r2, n2) && u(r2, t2);
      }
      function h(e3) {
        var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { from: null, to: null }, n2 = t2.from, o2 = t2.to;
        return n2 ? n2 && o2 && s(n2, o2) && s(e3, n2) ? (n2 = null, o2 = null) : o2 && u(e3, n2) ? n2 = e3 : o2 && s(e3, o2) ? (n2 = e3, o2 = e3) : (o2 = e3, u(o2, n2) && (o2 = n2, n2 = e3)) : n2 = e3, { from: n2, to: o2 };
      }
      function d(e3, t2) {
        var n2 = t2.from, o2 = t2.to;
        return n2 && s(e3, n2) || o2 && s(e3, o2) || n2 && o2 && f(e3, n2, o2);
      }
      function y(e3) {
        var t2 = o(e3);
        return t2.setHours(0, 0, 0), t2.setDate(t2.getDate() + 4 - (t2.getDay() || 7)), Math.ceil(((t2 - new Date(t2.getFullYear(), 0, 1)) / 864e5 + 1) / 7);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.clone = o, t.isDate = r, t.addMonths = a, t.isSameDay = s, t.isSameMonth = i, t.isDayBefore = u, t.isDayAfter = l, t.isPastDay = c, t.isFutureDay = p, t.isDayBetween = f, t.addDayToRange = h, t.isDayInRange = d, t.getWeekNumber = y, t.default = { addDayToRange: h, addMonths: a, clone: o, getWeekNumber: y, isDate: r, isDayAfter: l, isDayBefore: u, isDayBetween: f, isDayInRange: d, isFutureDay: p, isPastDay: c, isSameDay: s, isSameMonth: i };
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      t.LEFT = 37, t.UP = 38, t.RIGHT = 39, t.DOWN = 40, t.ENTER = 13, t.SPACE = 32, t.ESC = 27, t.TAB = 9;
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true }), t.default = { container: "DayPicker", wrapper: "DayPicker-wrapper", interactionDisabled: "DayPicker--interactionDisabled", months: "DayPicker-Months", month: "DayPicker-Month", navBar: "DayPicker-NavBar", navButtonPrev: "DayPicker-NavButton DayPicker-NavButton--prev", navButtonNext: "DayPicker-NavButton DayPicker-NavButton--next", navButtonInteractionDisabled: "DayPicker-NavButton--interactionDisabled", caption: "DayPicker-Caption", weekdays: "DayPicker-Weekdays", weekdaysRow: "DayPicker-WeekdaysRow", weekday: "DayPicker-Weekday", body: "DayPicker-Body", week: "DayPicker-Week", weekNumber: "DayPicker-WeekNumber", day: "DayPicker-Day", footer: "DayPicker-Footer", todayButton: "DayPicker-TodayButton", today: "today", selected: "selected", disabled: "disabled", outside: "outside" };
    }, function(e2, t, n) {
      function o(e3) {
        e3.preventDefault(), e3.stopPropagation();
      }
      function r(e3) {
        return new Date(e3.getFullYear(), e3.getMonth(), 1, 12);
      }
      function a(e3) {
        var t2 = r(e3);
        return t2.setMonth(t2.getMonth() + 1), t2.setDate(t2.getDate() - 1), t2.getDate();
      }
      function s(e3) {
        var t2 = y({}, e3.modifiers);
        return e3.selectedDays && (t2[e3.classNames.selected] = e3.selectedDays), e3.disabledDays && (t2[e3.classNames.disabled] = e3.disabledDays), t2;
      }
      function i(e3) {
        var t2 = e3.firstDayOfWeek, n2 = e3.locale, o2 = n2 === void 0 ? "en" : n2, r2 = e3.localeUtils, a2 = r2 === void 0 ? {} : r2;
        return isNaN(t2) ? a2.getFirstDayOfWeek ? a2.getFirstDayOfWeek(o2) : 0 : t2;
      }
      function u(e3) {
        return !!(e3 && e3.from && e3.to);
      }
      function l(e3, t2) {
        return t2.getMonth() - e3.getMonth() + 12 * (t2.getFullYear() - e3.getFullYear());
      }
      function c(e3) {
        for (var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, m.getFirstDayOfWeek)(), n2 = arguments[2], o2 = a(e3), r2 = [], s2 = [], i2 = [], u2 = 1; u2 <= o2; u2 += 1)
          r2.push(new Date(e3.getFullYear(), e3.getMonth(), u2, 12));
        r2.forEach(function(e4) {
          s2.length > 0 && e4.getDay() === t2 && (i2.push(s2), s2 = []), s2.push(e4), r2.indexOf(e4) === r2.length - 1 && i2.push(s2);
        });
        for (var l2 = i2[0], c2 = 7 - l2.length; c2 > 0; c2 -= 1) {
          var p2 = (0, v.clone)(l2[0]);
          p2.setDate(l2[0].getDate() - 1), l2.unshift(p2);
        }
        for (var f2 = i2[i2.length - 1], h2 = f2.length; h2 < 7; h2 += 1) {
          var d2 = (0, v.clone)(f2[f2.length - 1]);
          d2.setDate(f2[f2.length - 1].getDate() + 1), f2.push(d2);
        }
        if (n2 && i2.length < 6)
          for (var y2 = void 0, k2 = i2.length; k2 < 6; k2 += 1) {
            y2 = i2[i2.length - 1];
            for (var D2 = y2[y2.length - 1], b = [], g = 0; g < 7; g += 1) {
              var w = (0, v.clone)(D2);
              w.setDate(D2.getDate() + g + 1), b.push(w);
            }
            i2.push(b);
          }
        return i2;
      }
      function p(e3) {
        var t2 = (0, v.clone)(e3);
        return t2.setDate(1), t2.setHours(12, 0, 0, 0), t2;
      }
      function f(e3, t2) {
        var n2 = void 0;
        n2 = t2 === D.default ? t2.day + "--" + t2.outside : "" + t2.outside;
        var o2 = t2.day.replace(/ /g, "."), r2 = n2.replace(/ /g, "."), a2 = "." + o2 + ":not(." + r2 + ")";
        return e3.querySelectorAll(a2);
      }
      function h(e3) {
        return Array.prototype.slice.call(e3, 0);
      }
      function d(e3, t2) {
        return Object.prototype.hasOwnProperty.call(e3, t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var y = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      };
      t.cancelEvent = o, t.getFirstDayOfMonth = r, t.getDaysInMonth = a, t.getModifiersFromProps = s, t.getFirstDayOfWeekFromProps = i, t.isRangeOfDates = u, t.getMonthsDiff = l, t.getWeekArray = c, t.startOfMonth = p, t.getDayNodes = f, t.nodeListToArray = h, t.hasOwnProp = d;
      var v = n(1), m = n(5), k = n(3), D = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(k);
    }, function(e2, t, n) {
      function o(e3) {
        return e3.toDateString();
      }
      function r(e3) {
        return p[e3.getMonth()] + " " + e3.getFullYear();
      }
      function a(e3) {
        return c[e3];
      }
      function s(e3) {
        return l[e3];
      }
      function i() {
        return 0;
      }
      function u() {
        return p;
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.formatDay = o, t.formatMonthTitle = r, t.formatWeekdayShort = a, t.formatWeekdayLong = s, t.getFirstDayOfWeek = i, t.getMonths = u;
      var l = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], c = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], p = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      t.default = { formatDay: o, formatMonthTitle: r, formatWeekdayShort: a, formatWeekdayLong: s, getFirstDayOfWeek: i, getMonths: u };
    }, function(e2, t, n) {
      function o(e3, t2) {
        return !!t2 && (Array.isArray(t2) ? t2 : [t2]).some(function(t3) {
          return !!t3 && (t3 instanceof Date ? (0, a.isSameDay)(e3, t3) : (0, s.isRangeOfDates)(t3) ? (0, a.isDayInRange)(e3, t3) : t3.after && t3.before && (0, a.isDayAfter)(t3.before, t3.after) ? (0, a.isDayAfter)(e3, t3.after) && (0, a.isDayBefore)(e3, t3.before) : t3.after && t3.before && ((0, a.isDayAfter)(t3.after, t3.before) || (0, a.isSameDay)(t3.after, t3.before)) ? (0, a.isDayAfter)(e3, t3.after) || (0, a.isDayBefore)(e3, t3.before) : t3.after ? (0, a.isDayAfter)(e3, t3.after) : t3.before ? (0, a.isDayBefore)(e3, t3.before) : t3.daysOfWeek ? t3.daysOfWeek.some(function(t4) {
            return e3.getDay() === t4;
          }) : typeof t3 == "function" && t3(e3));
        });
      }
      function r(e3) {
        var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return Object.keys(t2).reduce(function(n2, r2) {
          var a2 = t2[r2];
          return o(e3, a2) && n2.push(r2), n2;
        }, []);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.dayMatchesModifier = o, t.getModifiersForDay = r;
      var a = n(1), s = n(4);
      t.default = { dayMatchesModifier: o, getModifiersForDay: r };
    }, function(e2, t, n) {
      function o(e3) {
        if (e3 && e3.__esModule)
          return e3;
        var t2 = {};
        if (e3 != null)
          for (var n2 in e3)
            Object.prototype.hasOwnProperty.call(e3, n2) && (t2[n2] = e3[n2]);
        return t2.default = e3, t2;
      }
      function r(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function a(e3, t2) {
        var n2 = {};
        for (var o2 in e3)
          t2.indexOf(o2) >= 0 || Object.prototype.hasOwnProperty.call(e3, o2) && (n2[o2] = e3[o2]);
        return n2;
      }
      function s(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function u(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.ModifiersUtils = t.LocaleUtils = t.DateUtils = t.DayPicker = void 0;
      var l = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      }, c = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), p = n(0), f = r(p), h = n(9), d = r(h), y = n(10), v = r(y), m = n(11), k = r(m), D = n(14), b = r(D), g = n(4), w = o(g), M = n(1), P = o(M), O = n(5), N = o(O), C = n(6), E = o(C), _ = n(3), j = r(_), x = n(2), T = t.DayPicker = function(e3) {
        function t2(e4) {
          s(this, t2);
          var n2 = i(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          n2.dayPicker = null, n2.showNextMonth = function(e5) {
            if (n2.allowNextMonth()) {
              var t3 = n2.props.pagedNavigation ? n2.props.numberOfMonths : 1, o3 = P.addMonths(n2.state.currentMonth, t3);
              n2.showMonth(o3, e5);
            }
          }, n2.showPreviousMonth = function(e5) {
            if (n2.allowPreviousMonth()) {
              var t3 = n2.props.pagedNavigation ? n2.props.numberOfMonths : 1, o3 = P.addMonths(n2.state.currentMonth, -t3);
              n2.showMonth(o3, e5);
            }
          }, n2.handleKeyDown = function(e5) {
            switch (e5.persist(), e5.keyCode) {
              case x.LEFT:
                n2.props.dir === "rtl" ? n2.showNextMonth() : n2.showPreviousMonth(), w.cancelEvent(e5);
                break;
              case x.RIGHT:
                n2.props.dir === "rtl" ? n2.showPreviousMonth() : n2.showNextMonth(), w.cancelEvent(e5);
                break;
              case x.UP:
                n2.showPreviousYear(), w.cancelEvent(e5);
                break;
              case x.DOWN:
                n2.showNextYear(), w.cancelEvent(e5);
            }
            n2.props.onKeyDown && n2.props.onKeyDown(e5);
          }, n2.handleDayKeyDown = function(e5, t3, o3) {
            switch (o3.persist(), o3.keyCode) {
              case x.LEFT:
                w.cancelEvent(o3), n2.props.dir === "rtl" ? n2.focusNextDay(o3.target) : n2.focusPreviousDay(o3.target);
                break;
              case x.RIGHT:
                w.cancelEvent(o3), n2.props.dir === "rtl" ? n2.focusPreviousDay(o3.target) : n2.focusNextDay(o3.target);
                break;
              case x.UP:
                w.cancelEvent(o3), n2.focusPreviousWeek(o3.target);
                break;
              case x.DOWN:
                w.cancelEvent(o3), n2.focusNextWeek(o3.target);
                break;
              case x.ENTER:
              case x.SPACE:
                w.cancelEvent(o3), n2.props.onDayClick && n2.handleDayClick(e5, t3, o3);
            }
            n2.props.onDayKeyDown && n2.props.onDayKeyDown(e5, t3, o3);
          }, n2.handleDayClick = function(e5, t3, o3) {
            o3.persist(), t3[n2.props.classNames.outside] && n2.props.enableOutsideDaysClick && n2.handleOutsideDayClick(e5), n2.props.onDayClick && n2.props.onDayClick(e5, t3, o3);
          }, n2.handleTodayButtonClick = function(e5) {
            var t3 = new Date(), o3 = new Date(t3.getFullYear(), t3.getMonth());
            n2.showMonth(o3), e5.target.blur(), n2.props.onTodayButtonClick && (e5.persist(), n2.props.onTodayButtonClick(new Date(t3.getFullYear(), t3.getMonth(), t3.getDate()), E.getModifiersForDay(t3, n2.props.modifiers), e5));
          };
          var o2 = n2.getCurrentMonthFromProps(e4);
          return n2.state = { currentMonth: o2 }, n2;
        }
        return u(t2, e3), c(t2, [{ key: "componentDidUpdate", value: function(e4) {
          if (e4.month !== this.props.month && !P.isSameMonth(e4.month, this.props.month)) {
            var t3 = this.getCurrentMonthFromProps(this.props);
            this.setState({ currentMonth: t3 });
          }
        } }, { key: "getCurrentMonthFromProps", value: function(e4) {
          var t3 = w.startOfMonth(e4.month || e4.initialMonth || new Date()), n2 = t3;
          if (e4.pagedNavigation && e4.numberOfMonths > 1 && e4.fromMonth) {
            var o2 = w.startOfMonth(e4.fromMonth), r2 = w.getMonthsDiff(o2, n2);
            n2 = P.addMonths(o2, Math.floor(r2 / e4.numberOfMonths) * e4.numberOfMonths);
          } else
            e4.toMonth && e4.numberOfMonths > 1 && w.getMonthsDiff(n2, e4.toMonth) <= 0 && (n2 = P.addMonths(w.startOfMonth(e4.toMonth), 1 - this.props.numberOfMonths));
          return n2;
        } }, { key: "getNextNavigableMonth", value: function() {
          return P.addMonths(this.state.currentMonth, this.props.numberOfMonths);
        } }, { key: "getPreviousNavigableMonth", value: function() {
          return P.addMonths(this.state.currentMonth, -1);
        } }, { key: "allowPreviousMonth", value: function() {
          var e4 = P.addMonths(this.state.currentMonth, -1);
          return this.allowMonth(e4);
        } }, { key: "allowNextMonth", value: function() {
          var e4 = P.addMonths(this.state.currentMonth, this.props.numberOfMonths);
          return this.allowMonth(e4);
        } }, { key: "allowMonth", value: function(e4) {
          var t3 = this.props, n2 = t3.fromMonth, o2 = t3.toMonth;
          return !(!t3.canChangeMonth || n2 && w.getMonthsDiff(n2, e4) < 0 || o2 && w.getMonthsDiff(o2, e4) > 0);
        } }, { key: "allowYearChange", value: function() {
          return this.props.canChangeMonth;
        } }, { key: "showMonth", value: function(e4, t3) {
          var n2 = this;
          this.allowMonth(e4) && this.setState({ currentMonth: w.startOfMonth(e4) }, function() {
            t3 && t3(), n2.props.onMonthChange && n2.props.onMonthChange(n2.state.currentMonth);
          });
        } }, { key: "showNextYear", value: function() {
          if (this.allowYearChange()) {
            var e4 = P.addMonths(this.state.currentMonth, 12);
            this.showMonth(e4);
          }
        } }, { key: "showPreviousYear", value: function() {
          if (this.allowYearChange()) {
            var e4 = P.addMonths(this.state.currentMonth, -12);
            this.showMonth(e4);
          }
        } }, { key: "focus", value: function() {
          this.wrapper.focus();
        } }, { key: "focusFirstDayOfMonth", value: function() {
          w.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
        } }, { key: "focusLastDayOfMonth", value: function() {
          var e4 = w.getDayNodes(this.dayPicker, this.props.classNames);
          e4[e4.length - 1].focus();
        } }, { key: "focusPreviousDay", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 !== -1 && (o2 === 0 ? this.showPreviousMonth(function() {
            return t3.focusLastDayOfMonth();
          }) : n2[o2 - 1].focus());
        } }, { key: "focusNextDay", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 !== -1 && (o2 === n2.length - 1 ? this.showNextMonth(function() {
            return t3.focusFirstDayOfMonth();
          }) : n2[o2 + 1].focus());
        } }, { key: "focusNextWeek", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 > n2.length - 8 ? this.showNextMonth(function() {
            var e5 = n2.length - o2, r2 = 7 - e5;
            w.getDayNodes(t3.dayPicker, t3.props.classNames)[r2].focus();
          }) : n2[o2 + 7].focus();
        } }, { key: "focusPreviousWeek", value: function(e4) {
          var t3 = this, n2 = w.getDayNodes(this.dayPicker, this.props.classNames), o2 = w.nodeListToArray(n2).indexOf(e4);
          o2 <= 6 ? this.showPreviousMonth(function() {
            var e5 = w.getDayNodes(t3.dayPicker, t3.props.classNames);
            e5[e5.length - 7 + o2].focus();
          }) : n2[o2 - 7].focus();
        } }, { key: "handleOutsideDayClick", value: function(e4) {
          var t3 = this.state.currentMonth, n2 = this.props.numberOfMonths, o2 = w.getMonthsDiff(t3, e4);
          o2 > 0 && o2 >= n2 ? this.showNextMonth() : o2 < 0 && this.showPreviousMonth();
        } }, { key: "renderNavbar", value: function() {
          var e4 = this.props, t3 = e4.labels, n2 = e4.locale, o2 = e4.localeUtils, r2 = e4.canChangeMonth, s2 = e4.navbarElement, i2 = a(e4, ["labels", "locale", "localeUtils", "canChangeMonth", "navbarElement"]);
          if (!r2)
            return null;
          var u2 = { month: this.state.currentMonth, classNames: this.props.classNames, className: this.props.classNames.navBar, nextMonth: this.getNextNavigableMonth(), previousMonth: this.getPreviousNavigableMonth(), showPreviousButton: this.allowPreviousMonth(), showNextButton: this.allowNextMonth(), onNextClick: this.showNextMonth, onPreviousClick: this.showPreviousMonth, dir: i2.dir, labels: t3, locale: n2, localeUtils: o2 };
          return f.default.isValidElement(s2) ? f.default.cloneElement(s2, u2) : f.default.createElement(s2, u2);
        } }, { key: "renderMonths", value: function() {
          for (var e4 = [], t3 = w.getFirstDayOfWeekFromProps(this.props), n2 = 0; n2 < this.props.numberOfMonths; n2 += 1) {
            var o2 = P.addMonths(this.state.currentMonth, n2);
            e4.push(f.default.createElement(k.default, l({ key: n2 }, this.props, { month: o2, firstDayOfWeek: t3, onDayKeyDown: this.handleDayKeyDown, onDayClick: this.handleDayClick })));
          }
          return this.props.reverseMonths && e4.reverse(), e4;
        } }, { key: "renderFooter", value: function() {
          return this.props.todayButton ? f.default.createElement("div", { className: this.props.classNames.footer }, this.renderTodayButton()) : null;
        } }, { key: "renderTodayButton", value: function() {
          return f.default.createElement("button", { type: "button", tabIndex: 0, className: this.props.classNames.todayButton, "aria-label": this.props.todayButton, onClick: this.handleTodayButtonClick }, this.props.todayButton);
        } }, { key: "render", value: function() {
          var e4 = this, t3 = this.props.classNames.container;
          return this.props.onDayClick || (t3 = t3 + " " + this.props.classNames.interactionDisabled), this.props.className && (t3 = t3 + " " + this.props.className), f.default.createElement("div", l({}, this.props.containerProps, { className: t3, ref: function(t4) {
            return e4.dayPicker = t4;
          }, lang: this.props.locale }), f.default.createElement("div", { className: this.props.classNames.wrapper, ref: function(t4) {
            return e4.wrapper = t4;
          }, tabIndex: this.props.canChangeMonth && this.props.tabIndex !== void 0 ? this.props.tabIndex : -1, onKeyDown: this.handleKeyDown, onFocus: this.props.onFocus, onBlur: this.props.onBlur }, this.renderNavbar(), f.default.createElement("div", { className: this.props.classNames.months }, this.renderMonths()), this.renderFooter()));
        } }]), t2;
      }(p.Component);
      T.defaultProps = { classNames: j.default, tabIndex: 0, numberOfMonths: 1, labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, locale: "en", localeUtils: N, showOutsideDays: false, enableOutsideDaysClick: true, fixedWeeks: false, canChangeMonth: true, reverseMonths: false, pagedNavigation: false, showWeekNumbers: false, showWeekDays: true, renderDay: function(e3) {
        return e3.getDate();
      }, renderWeek: function(e3) {
        return e3;
      }, weekdayElement: f.default.createElement(b.default, null), navbarElement: f.default.createElement(v.default, { classNames: j.default }), captionElement: f.default.createElement(d.default, { classNames: j.default }) }, T.VERSION = "7.4.10", T.DateUtils = P, T.LocaleUtils = N, T.ModifiersUtils = E, t.DateUtils = P, t.LocaleUtils = N, t.ModifiersUtils = E, t.default = T;
    }, function(e2, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var o = n(7).default;
      o.Input = n(15).default, t.default = o;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function s(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), u = n(0), l = o(u), c = n(5), p = o(c), f = n(2), h = function(e3) {
        function t2(e4) {
          r(this, t2);
          var n2 = a(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          return n2.handleKeyUp = n2.handleKeyUp.bind(n2), n2;
        }
        return s(t2, e3), i(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return e4.locale !== this.props.locale || e4.classNames !== this.props.classNames || e4.date.getMonth() !== this.props.date.getMonth() || e4.date.getFullYear() !== this.props.date.getFullYear();
        } }, { key: "handleKeyUp", value: function(e4) {
          e4.keyCode === f.ENTER && this.props.onClick(e4);
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.date, o2 = e4.months, r2 = e4.locale, a2 = e4.localeUtils, s2 = e4.onClick;
          return l.default.createElement("div", { className: t3.caption, role: "heading", "aria-live": "polite" }, l.default.createElement("div", { onClick: s2, onKeyUp: this.handleKeyUp }, o2 ? o2[n2.getMonth()] + " " + n2.getFullYear() : a2.formatMonthTitle(n2, r2)));
        } }]), t2;
      }(u.Component);
      h.defaultProps = { localeUtils: p.default }, t.default = h;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function s(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), u = n(0), l = o(u), c = n(3), p = o(c), f = n(2), h = function(e3) {
        function t2() {
          var e4, n2, o2, s2;
          r(this, t2);
          for (var i2 = arguments.length, u2 = Array(i2), l2 = 0; l2 < i2; l2++)
            u2[l2] = arguments[l2];
          return n2 = o2 = a(this, (e4 = t2.__proto__ || Object.getPrototypeOf(t2)).call.apply(e4, [this].concat(u2))), o2.handleNextClick = function() {
            o2.props.onNextClick && o2.props.onNextClick();
          }, o2.handlePreviousClick = function() {
            o2.props.onPreviousClick && o2.props.onPreviousClick();
          }, o2.handleNextKeyDown = function(e5) {
            e5.keyCode !== f.ENTER && e5.keyCode !== f.SPACE || (e5.preventDefault(), o2.handleNextClick());
          }, o2.handlePreviousKeyDown = function(e5) {
            e5.keyCode !== f.ENTER && e5.keyCode !== f.SPACE || (e5.preventDefault(), o2.handlePreviousClick());
          }, s2 = n2, a(o2, s2);
        }
        return s(t2, e3), i(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return e4.labels !== this.props.labels || e4.dir !== this.props.dir || this.props.showPreviousButton !== e4.showPreviousButton || this.props.showNextButton !== e4.showNextButton;
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.className, o2 = e4.showPreviousButton, r2 = e4.showNextButton, a2 = e4.labels, s2 = e4.dir, i2 = void 0, u2 = void 0, c2 = void 0, p2 = void 0, f2 = void 0, h2 = void 0;
          s2 === "rtl" ? (i2 = this.handleNextClick, u2 = this.handlePreviousClick, c2 = this.handleNextKeyDown, p2 = this.handlePreviousKeyDown, h2 = o2, f2 = r2) : (i2 = this.handlePreviousClick, u2 = this.handleNextClick, c2 = this.handlePreviousKeyDown, p2 = this.handleNextKeyDown, h2 = r2, f2 = o2);
          var d = f2 ? t3.navButtonPrev : t3.navButtonPrev + " " + t3.navButtonInteractionDisabled, y = h2 ? t3.navButtonNext : t3.navButtonNext + " " + t3.navButtonInteractionDisabled, v = l.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": a2.previousMonth, key: "previous", className: d, onKeyDown: f2 ? c2 : void 0, onClick: f2 ? i2 : void 0 }), m = l.default.createElement("span", { tabIndex: "0", role: "button", "aria-label": a2.nextMonth, key: "right", className: y, onKeyDown: h2 ? p2 : void 0, onClick: h2 ? u2 : void 0 });
          return l.default.createElement("div", { className: n2 || t3.navBar }, s2 === "rtl" ? [m, v] : [v, m]);
        } }]), t2;
      }(u.Component);
      h.defaultProps = { classNames: p.default, dir: "ltr", labels: { previousMonth: "Previous Month", nextMonth: "Next Month" }, showPreviousButton: true, showNextButton: true }, t.default = h;
    }, function(e2, t, n) {
      function o(e3) {
        if (e3 && e3.__esModule)
          return e3;
        var t2 = {};
        if (e3 != null)
          for (var n2 in e3)
            Object.prototype.hasOwnProperty.call(e3, n2) && (t2[n2] = e3[n2]);
        return t2.default = e3, t2;
      }
      function r(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function a(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function s(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function i(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var u = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), l = n(0), c = r(l), p = n(12), f = r(p), h = n(13), d = r(h), y = n(2), v = n(6), m = o(v), k = n(4), D = o(k), b = n(1), g = o(b), w = function(e3) {
        function t2() {
          var e4, n2, o2, r2;
          a(this, t2);
          for (var i2 = arguments.length, u2 = Array(i2), l2 = 0; l2 < i2; l2++)
            u2[l2] = arguments[l2];
          return n2 = o2 = s(this, (e4 = t2.__proto__ || Object.getPrototypeOf(t2)).call.apply(e4, [this].concat(u2))), o2.renderDay = function(e5) {
            var t3 = o2.props.month.getMonth(), n3 = D.getModifiersFromProps(o2.props), r3 = m.getModifiersForDay(e5, n3);
            g.isSameDay(e5, new Date()) && !Object.prototype.hasOwnProperty.call(n3, o2.props.classNames.today) && r3.push(o2.props.classNames.today), e5.getMonth() !== t3 && r3.push(o2.props.classNames.outside);
            var a2 = e5.getMonth() !== t3, s2 = -1;
            o2.props.onDayClick && !a2 && e5.getDate() === 1 && (s2 = o2.props.tabIndex);
            var i3 = "" + e5.getFullYear() + e5.getMonth() + e5.getDate(), u3 = {};
            return r3.forEach(function(e6) {
              u3[e6] = true;
            }), c.default.createElement(d.default, { key: (a2 ? "outside-" : "") + i3, classNames: o2.props.classNames, day: e5, modifiers: u3, modifiersStyles: o2.props.modifiersStyles, empty: a2 && !o2.props.showOutsideDays && !o2.props.fixedWeeks, tabIndex: s2, ariaLabel: o2.props.localeUtils.formatDay(e5, o2.props.locale), ariaDisabled: a2 || r3.indexOf(o2.props.classNames.disabled) > -1, ariaSelected: r3.indexOf(o2.props.classNames.selected) > -1, onClick: o2.props.onDayClick, onFocus: o2.props.onDayFocus, onKeyDown: o2.props.onDayKeyDown, onMouseEnter: o2.props.onDayMouseEnter, onMouseLeave: o2.props.onDayMouseLeave, onMouseDown: o2.props.onDayMouseDown, onMouseUp: o2.props.onDayMouseUp, onTouchEnd: o2.props.onDayTouchEnd, onTouchStart: o2.props.onDayTouchStart }, o2.props.renderDay(e5, u3));
          }, r2 = n2, s(o2, r2);
        }
        return i(t2, e3), u(t2, [{ key: "render", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.classNames, o2 = t3.month, r2 = t3.months, a2 = t3.fixedWeeks, s2 = t3.captionElement, i2 = t3.weekdayElement, u2 = t3.locale, l2 = t3.localeUtils, p2 = t3.weekdaysLong, h2 = t3.weekdaysShort, d2 = t3.firstDayOfWeek, v2 = t3.onCaptionClick, m2 = t3.showWeekNumbers, k2 = t3.showWeekDays, b2 = t3.onWeekClick, w2 = { date: o2, classNames: n2, months: r2, localeUtils: l2, locale: u2, onClick: v2 ? function(e5) {
            return v2(o2, e5);
          } : void 0 }, M = c.default.isValidElement(s2) ? c.default.cloneElement(s2, w2) : c.default.createElement(s2, w2), P = D.getWeekArray(o2, d2, a2);
          return c.default.createElement("div", { className: n2.month, role: "grid" }, M, k2 && c.default.createElement(f.default, { classNames: n2, weekdaysShort: h2, weekdaysLong: p2, firstDayOfWeek: d2, showWeekNumbers: m2, locale: u2, localeUtils: l2, weekdayElement: i2 }), c.default.createElement("div", { className: n2.body, role: "rowgroup" }, P.map(function(t4) {
            var r3 = void 0;
            return m2 && (r3 = g.getWeekNumber(t4[6])), c.default.createElement("div", { key: t4[0].getTime(), className: n2.week, role: "row" }, m2 && c.default.createElement("div", { className: n2.weekNumber, tabIndex: b2 ? 0 : -1, role: "gridcell", onClick: b2 ? function(e5) {
              return b2(r3, t4, e5);
            } : void 0, onKeyUp: b2 ? function(e5) {
              return e5.keyCode === y.ENTER && b2(r3, t4, e5);
            } : void 0 }, e4.props.renderWeek(r3, t4, o2)), t4.map(e4.renderDay));
          })));
        } }]), t2;
      }(l.Component);
      t.default = w;
    }, function(e2, t, n) {
      function o(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function r(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function a(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var s = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), i = n(0), u = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(i), l = function(e3) {
        function t2() {
          return o(this, t2), r(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return a(t2, e3), s(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return this.props !== e4;
        } }, { key: "render", value: function() {
          for (var e4 = this.props, t3 = e4.classNames, n2 = e4.firstDayOfWeek, o2 = e4.showWeekNumbers, r2 = e4.weekdaysLong, a2 = e4.weekdaysShort, s2 = e4.locale, i2 = e4.localeUtils, l2 = e4.weekdayElement, c = [], p = 0; p < 7; p += 1) {
            var f = (p + n2) % 7, h = { key: p, className: t3.weekday, weekday: f, weekdaysLong: r2, weekdaysShort: a2, localeUtils: i2, locale: s2 }, d = u.default.isValidElement(l2) ? u.default.cloneElement(l2, h) : u.default.createElement(l2, h);
            c.push(d);
          }
          return u.default.createElement("div", { className: t3.weekdays, role: "rowgroup" }, u.default.createElement("div", { className: t3.weekdaysRow, role: "row" }, o2 && u.default.createElement("div", { className: t3.weekday }), c));
        } }]), t2;
      }(i.Component);
      t.default = l;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function a(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function s(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      function i(e3, t2, n2) {
        if (e3)
          return function(o2) {
            o2.persist(), e3(t2, n2, o2);
          };
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var u = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      }, l = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), c = n(0), p = o(c), f = n(1), h = n(4), d = n(3), y = o(d), v = function(e3) {
        function t2() {
          return r(this, t2), a(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return s(t2, e3), l(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          var t3 = this, n2 = Object.keys(this.props), o2 = Object.keys(e4);
          return n2.length !== o2.length || n2.some(function(n3) {
            if (n3 === "modifiers" || n3 === "modifiersStyles" || n3 === "classNames") {
              var o3 = t3.props[n3], r2 = e4[n3], a2 = Object.keys(o3), s2 = Object.keys(r2);
              return a2.length !== s2.length || a2.some(function(e5) {
                return !(0, h.hasOwnProp)(r2, e5) || o3[e5] !== r2[e5];
              });
            }
            return n3 === "day" ? !(0, f.isSameDay)(t3.props[n3], e4[n3]) : !(0, h.hasOwnProp)(e4, n3) || t3.props[n3] !== e4[n3];
          });
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.classNames, n2 = e4.modifiersStyles, o2 = e4.day, r2 = e4.tabIndex, a2 = e4.empty, s2 = e4.modifiers, l2 = e4.onMouseEnter, c2 = e4.onMouseLeave, f2 = e4.onMouseUp, h2 = e4.onMouseDown, d2 = e4.onClick, v2 = e4.onKeyDown, m = e4.onTouchStart, k = e4.onTouchEnd, D = e4.onFocus, b = e4.ariaLabel, g = e4.ariaDisabled, w = e4.ariaSelected, M = e4.children, P = t3.day;
          t3 !== y.default ? P += " " + Object.keys(s2).join(" ") : P += Object.keys(s2).map(function(e5) {
            return " " + P + "--" + e5;
          }).join("");
          var O = void 0;
          return n2 && Object.keys(s2).filter(function(e5) {
            return !!n2[e5];
          }).forEach(function(e5) {
            O = u({}, O, n2[e5]);
          }), a2 ? p.default.createElement("div", { "aria-disabled": true, className: P, style: O }) : p.default.createElement("div", { className: P, tabIndex: r2, style: O, role: "gridcell", "aria-label": b, "aria-disabled": g, "aria-selected": w, onClick: i(d2, o2, s2), onKeyDown: i(v2, o2, s2), onMouseEnter: i(l2, o2, s2), onMouseLeave: i(c2, o2, s2), onMouseUp: i(f2, o2, s2), onMouseDown: i(h2, o2, s2), onTouchEnd: i(k, o2, s2), onTouchStart: i(m, o2, s2), onFocus: i(D, o2, s2) }, M);
        } }]), t2;
      }(c.Component);
      v.defaultProps = { tabIndex: -1 }, v.defaultProps = { modifiers: {}, modifiersStyles: {}, empty: false }, t.default = v;
    }, function(e2, t, n) {
      function o(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function r(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function a(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      Object.defineProperty(t, "__esModule", { value: true });
      var s = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), i = n(0), u = function(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }(i), l = function(e3) {
        function t2() {
          return o(this, t2), r(this, (t2.__proto__ || Object.getPrototypeOf(t2)).apply(this, arguments));
        }
        return a(t2, e3), s(t2, [{ key: "shouldComponentUpdate", value: function(e4) {
          return this.props !== e4;
        } }, { key: "render", value: function() {
          var e4 = this.props, t3 = e4.weekday, n2 = e4.className, o2 = e4.weekdaysLong, r2 = e4.weekdaysShort, a2 = e4.localeUtils, s2 = e4.locale, i2 = void 0;
          i2 = o2 ? o2[t3] : a2.formatWeekdayLong(t3, s2);
          var l2 = void 0;
          return l2 = r2 ? r2[t3] : a2.formatWeekdayShort(t3, s2), u.default.createElement("div", { className: n2, role: "columnheader" }, u.default.createElement("abbr", { title: i2 }, l2));
        } }]), t2;
      }(i.Component);
      t.default = l;
    }, function(e2, t, n) {
      function o(e3) {
        return e3 && e3.__esModule ? e3 : { default: e3 };
      }
      function r(e3, t2, n2) {
        return t2 in e3 ? Object.defineProperty(e3, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t2] = n2, e3;
      }
      function a(e3, t2) {
        if (!(e3 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      function s(e3, t2) {
        if (!e3)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || typeof t2 != "object" && typeof t2 != "function" ? e3 : t2;
      }
      function i(e3, t2) {
        if (typeof t2 != "function" && t2 !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t2);
        e3.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t2 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t2) : e3.__proto__ = t2);
      }
      function u(e3, t2) {
        var n2 = {};
        for (var o2 in e3)
          t2.indexOf(o2) >= 0 || Object.prototype.hasOwnProperty.call(e3, o2) && (n2[o2] = e3[o2]);
        return n2;
      }
      function l(e3) {
        var t2 = (e3.input, e3.selectedDay, e3.month, e3.children), n2 = e3.classNames, o2 = u(e3, ["input", "selectedDay", "month", "children", "classNames"]);
        return y.default.createElement("div", h({ className: n2.overlayWrapper }, o2), y.default.createElement("div", { className: n2.overlay }, t2));
      }
      function c(e3) {
        if ((0, k.isDate)(e3)) {
          return e3.getFullYear() + "-" + ("" + (e3.getMonth() + 1)) + "-" + ("" + e3.getDate());
        }
        return "";
      }
      function p(e3) {
        if (typeof e3 == "string") {
          var t2 = e3.split("-");
          if (t2.length === 3) {
            var n2 = parseInt(t2[0], 10), o2 = parseInt(t2[1], 10) - 1, r2 = parseInt(t2[2], 10);
            if (!(isNaN(n2) || String(n2).length > 4 || isNaN(o2) || isNaN(r2) || r2 <= 0 || r2 > 31 || o2 < 0 || o2 >= 12))
              return new Date(n2, o2, r2, 12, 0, 0, 0);
          }
        }
      }
      Object.defineProperty(t, "__esModule", { value: true }), t.HIDE_TIMEOUT = void 0;
      var f = function() {
        function e3(e4, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var o2 = t2[n2];
            o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e4, o2.key, o2);
          }
        }
        return function(t2, n2, o2) {
          return n2 && e3(t2.prototype, n2), o2 && e3(t2, o2), t2;
        };
      }(), h = Object.assign || function(e3) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var n2 = arguments[t2];
          for (var o2 in n2)
            Object.prototype.hasOwnProperty.call(n2, o2) && (e3[o2] = n2[o2]);
        }
        return e3;
      };
      t.OverlayComponent = l, t.defaultFormat = c, t.defaultParse = p;
      var d = n(0), y = o(d), v = n(7), m = o(v), k = n(1), D = n(6), b = n(2), g = t.HIDE_TIMEOUT = 100, w = function(e3) {
        function t2(e4) {
          a(this, t2);
          var n2 = s(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e4));
          return n2.input = null, n2.daypicker = null, n2.clickTimeout = null, n2.hideTimeout = null, n2.inputBlurTimeout = null, n2.inputFocusTimeout = null, n2.state = n2.getInitialStateFromProps(e4), n2.state.showOverlay = e4.showOverlay, n2.hideAfterDayClick = n2.hideAfterDayClick.bind(n2), n2.handleInputClick = n2.handleInputClick.bind(n2), n2.handleInputFocus = n2.handleInputFocus.bind(n2), n2.handleInputBlur = n2.handleInputBlur.bind(n2), n2.handleInputChange = n2.handleInputChange.bind(n2), n2.handleInputKeyDown = n2.handleInputKeyDown.bind(n2), n2.handleInputKeyUp = n2.handleInputKeyUp.bind(n2), n2.handleDayClick = n2.handleDayClick.bind(n2), n2.handleMonthChange = n2.handleMonthChange.bind(n2), n2.handleOverlayFocus = n2.handleOverlayFocus.bind(n2), n2.handleOverlayBlur = n2.handleOverlayBlur.bind(n2), n2;
        }
        return i(t2, e3), f(t2, [{ key: "componentDidUpdate", value: function(e4) {
          var t3 = {}, n2 = this.props, o2 = n2.value, r2 = n2.formatDate, a2 = n2.format, s2 = n2.dayPickerProps;
          o2 === e4.value && s2.locale === e4.dayPickerProps.locale && a2 === e4.format || ((0, k.isDate)(o2) ? t3.value = r2(o2, a2, s2.locale) : t3.value = o2);
          var i2 = e4.dayPickerProps.month;
          s2.month && s2.month !== i2 && !(0, k.isSameMonth)(s2.month, i2) && (t3.month = s2.month), e4.dayPickerProps.selectedDays !== s2.selectedDays && (t3.selectedDays = s2.selectedDays), Object.keys(t3).length > 0 && this.setState(t3);
        } }, { key: "componentWillUnmount", value: function() {
          clearTimeout(this.clickTimeout), clearTimeout(this.hideTimeout), clearTimeout(this.inputFocusTimeout), clearTimeout(this.inputBlurTimeout), clearTimeout(this.overlayBlurTimeout);
        } }, { key: "getInitialMonthFromProps", value: function(e4) {
          var t3 = e4.dayPickerProps, n2 = e4.format, o2 = void 0;
          return e4.value && (o2 = (0, k.isDate)(e4.value) ? e4.value : e4.parseDate(e4.value, n2, t3.locale)), t3.initialMonth || t3.month || o2 || new Date();
        } }, { key: "getInitialStateFromProps", value: function(e4) {
          var t3 = e4.dayPickerProps, n2 = e4.formatDate, o2 = e4.format, r2 = e4.typedValue, a2 = e4.value;
          return e4.value && (0, k.isDate)(e4.value) && (a2 = n2(e4.value, o2, t3.locale)), { value: a2, typedValue: r2, month: this.getInitialMonthFromProps(e4), selectedDays: t3.selectedDays };
        } }, { key: "getInput", value: function() {
          return this.input;
        } }, { key: "getDayPicker", value: function() {
          return this.daypicker;
        } }, { key: "updateState", value: function(e4, t3, n2) {
          var o2 = this, a2 = this.props, s2 = a2.dayPickerProps, i2 = a2.onDayChange;
          this.setState({ month: e4, value: t3, typedValue: "" }, function() {
            if (n2 && n2(), i2) {
              var t4 = h({ disabled: s2.disabledDays, selected: s2.selectedDays }, s2.modifiers), a3 = (0, D.getModifiersForDay)(e4, t4).reduce(function(e5, t5) {
                return h({}, e5, r({}, t5, true));
              }, {});
              i2(e4, a3, o2);
            }
          });
        } }, { key: "showDayPicker", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.parseDate, o2 = t3.format, r2 = t3.dayPickerProps, a2 = this.state, s2 = a2.value;
          if (!a2.showOverlay) {
            var i2 = s2 ? n2(s2, o2, r2.locale) : this.getInitialMonthFromProps(this.props);
            this.setState(function(e5) {
              return { showOverlay: true, month: i2 || e5.month };
            }, function() {
              e4.props.onDayPickerShow && e4.props.onDayPickerShow();
            });
          }
        } }, { key: "hideDayPicker", value: function() {
          var e4 = this;
          this.state.showOverlay !== false && this.setState({ showOverlay: false }, function() {
            e4.props.onDayPickerHide && e4.props.onDayPickerHide();
          });
        } }, { key: "hideAfterDayClick", value: function() {
          var e4 = this;
          this.props.hideOnDayClick && (this.hideTimeout = setTimeout(function() {
            e4.overlayHasFocus = false, e4.hideDayPicker();
          }, g));
        } }, { key: "handleInputClick", value: function(e4) {
          this.showDayPicker(), this.props.inputProps.onClick && (e4.persist(), this.props.inputProps.onClick(e4));
        } }, { key: "handleInputFocus", value: function(e4) {
          var t3 = this;
          this.showDayPicker(), this.inputFocusTimeout = setTimeout(function() {
            t3.overlayHasFocus = false;
          }, 2), this.props.inputProps.onFocus && (e4.persist(), this.props.inputProps.onFocus(e4));
        } }, { key: "handleInputBlur", value: function(e4) {
          var t3 = this;
          this.inputBlurTimeout = setTimeout(function() {
            t3.overlayHasFocus || t3.hideDayPicker();
          }, 1), this.props.inputProps.onBlur && (e4.persist(), this.props.inputProps.onBlur(e4));
        } }, { key: "handleOverlayFocus", value: function(e4) {
          e4.preventDefault(), this.overlayHasFocus = true, this.props.keepFocus && this.input && typeof this.input.focus == "function" && this.input.focus();
        } }, { key: "handleOverlayBlur", value: function() {
          var e4 = this;
          this.overlayBlurTimeout = setTimeout(function() {
            e4.overlayHasFocus = false;
          }, 3);
        } }, { key: "handleInputChange", value: function(e4) {
          var t3 = this.props, n2 = t3.dayPickerProps, o2 = t3.format, r2 = t3.inputProps, a2 = t3.onDayChange, s2 = t3.parseDate;
          r2.onChange && (e4.persist(), r2.onChange(e4));
          var i2 = e4.target.value;
          if (i2.trim() === "")
            return this.setState({ value: i2, typedValue: "" }), void (a2 && a2(void 0, {}, this));
          var u2 = s2(i2, o2, n2.locale);
          if (!u2)
            return this.setState({ value: i2, typedValue: i2 }), void (a2 && a2(void 0, {}, this));
          this.updateState(u2, i2);
        } }, { key: "handleInputKeyDown", value: function(e4) {
          e4.keyCode === b.TAB ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyDown && (e4.persist(), this.props.inputProps.onKeyDown(e4));
        } }, { key: "handleInputKeyUp", value: function(e4) {
          e4.keyCode === b.ESC ? this.hideDayPicker() : this.showDayPicker(), this.props.inputProps.onKeyUp && (e4.persist(), this.props.inputProps.onKeyUp(e4));
        } }, { key: "handleMonthChange", value: function(e4) {
          var t3 = this;
          this.setState({ month: e4 }, function() {
            t3.props.dayPickerProps && t3.props.dayPickerProps.onMonthChange && t3.props.dayPickerProps.onMonthChange(e4);
          });
        } }, { key: "handleDayClick", value: function(e4, t3, n2) {
          var o2 = this, r2 = this.props, a2 = r2.clickUnselectsDay, s2 = r2.dayPickerProps, i2 = r2.onDayChange, u2 = r2.formatDate, l2 = r2.format;
          if (s2.onDayClick && s2.onDayClick(e4, t3, n2), !(t3.disabled || s2 && s2.classNames && t3[s2.classNames.disabled])) {
            if (t3.selected && a2) {
              var c2 = this.state.selectedDays;
              if (Array.isArray(c2)) {
                c2 = c2.slice(0);
                var p2 = c2.indexOf(e4);
                c2.splice(p2, 1);
              } else
                c2 && (c2 = null);
              return this.setState({ value: "", typedValue: "", selectedDays: c2 }, this.hideAfterDayClick), void (i2 && i2(void 0, t3, this));
            }
            var f2 = u2(e4, l2, s2.locale);
            this.setState({ value: f2, typedValue: "", month: e4 }, function() {
              i2 && i2(e4, t3, o2), o2.hideAfterDayClick();
            });
          }
        } }, { key: "renderOverlay", value: function() {
          var e4 = this, t3 = this.props, n2 = t3.classNames, o2 = t3.dayPickerProps, r2 = t3.parseDate, a2 = t3.formatDate, s2 = t3.format, i2 = this.state, u2 = i2.selectedDays, l2 = i2.value, c2 = void 0;
          if (!u2 && l2) {
            var p2 = r2(l2, s2, o2.locale);
            p2 && (c2 = p2);
          } else
            u2 && (c2 = u2);
          var f2 = void 0;
          o2.todayButton && (f2 = function() {
            return e4.updateState(new Date(), a2(new Date(), s2, o2.locale), e4.hideAfterDayClick);
          });
          var d2 = this.props.overlayComponent;
          return y.default.createElement(d2, { classNames: n2, month: this.state.month, selectedDay: c2, input: this.input, tabIndex: 0, onFocus: this.handleOverlayFocus, onBlur: this.handleOverlayBlur }, y.default.createElement(m.default, h({ ref: function(t4) {
            return e4.daypicker = t4;
          }, onTodayButtonClick: f2 }, o2, { month: this.state.month, selectedDays: c2, onDayClick: this.handleDayClick, onMonthChange: this.handleMonthChange })));
        } }, { key: "render", value: function() {
          var e4 = this, t3 = this.props.component, n2 = this.props.inputProps;
          return y.default.createElement("div", { className: this.props.classNames.container, style: this.props.style }, y.default.createElement(t3, h({ ref: function(t4) {
            return e4.input = t4;
          }, placeholder: this.props.placeholder }, n2, { value: this.state.value || this.state.typedValue, onChange: this.handleInputChange, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onKeyDown: this.handleInputKeyDown, onKeyUp: this.handleInputKeyUp, onClick: n2.disabled ? void 0 : this.handleInputClick })), this.state.showOverlay && this.renderOverlay());
        } }]), t2;
      }(y.default.Component);
      w.defaultProps = { dayPickerProps: {}, value: "", typedValue: "", placeholder: "YYYY-M-D", format: "L", formatDate: c, parseDate: p, showOverlay: false, hideOnDayClick: true, clickUnselectsDay: false, keepFocus: true, component: "input", inputProps: {}, overlayComponent: l, classNames: { container: "DayPickerInput", overlayWrapper: "DayPickerInput-OverlayWrapper", overlay: "DayPickerInput-Overlay" } }, t.default = w;
    }]).default;
  });
})(reactDayPicker_min);
var DayPicker = /* @__PURE__ */ getDefaultExportFromCjs(reactDayPicker_min.exports);
var style = "";
const PickerWrapper$2 = styled.div`
  padding-top: 8px;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  .DayPicker-Month {
    border: ${({ theme }) => `1px solid ${theme.themeColors.text}`};
    border-radius: 5px;

    margin: 12px 0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: ${({ theme }) => theme.themeColors.buttonText} !important;
    background-color: ${({ theme }) => theme.themeColors.primaryCtaButton} !important;
    border-radius: 5px !important;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    color: ${({ theme }) => theme.themeColors.text} !important;
    background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)} !important;
    border-radius: 5px !important;
  }

  .DayPicker-NavBar {
    span {
      top: 10px;
      color: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
function YearMonthForm({ date, fromMonth: fromMonth2, toMonth, localeUtils, onChange }) {
  const months2 = localeUtils.getMonths();
  const years = [];
  for (let i = fromMonth2.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }
  const handleChange = function handleChange2(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };
  return /* @__PURE__ */ React.createElement("form", {
    className: "DayPicker-Caption"
  }, /* @__PURE__ */ React.createElement("select", {
    name: "month",
    onChange: handleChange,
    value: date.getMonth()
  }, months2.map((month, i) => /* @__PURE__ */ React.createElement("option", {
    key: month,
    value: i
  }, month))), /* @__PURE__ */ React.createElement("select", {
    name: "year",
    onChange: handleChange,
    value: date.getFullYear()
  }, years.map((year) => /* @__PURE__ */ React.createElement("option", {
    key: year,
    value: year
  }, year))));
}
const DatePicker = ({ name: name2, label, initialDate, toMonth, fromMonth: fromMonth2, value, error, onChange }) => {
  const [monthYear, setMonthYear] = React.useState(initialDate || null);
  const [selectedDay, setSelectedDay] = React.useState(initialDate || null);
  const handleYearMonthChange = (date) => {
    setMonthYear(date);
  };
  const handleDayClick = (d) => {
    setSelectedDay(d);
    if (d) {
      onChange(name2)(d);
    }
  };
  return /* @__PURE__ */ React.createElement(PickerWrapper$2, {
    className: "YearNavigation"
  }, /* @__PURE__ */ React.createElement(DayPicker, {
    selectedDays: selectedDay,
    onDayClick: handleDayClick,
    month: monthYear,
    captionElement: ({ date, localeUtils }) => /* @__PURE__ */ React.createElement(YearMonthForm, {
      date,
      fromMonth: fromMonth2,
      toMonth,
      localeUtils,
      onChange: handleYearMonthChange
    })
  }));
};
const PickerWrapper$1 = styled.form`
  display: block;
  margin: 0;
  padding: 0;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  select {
    color: ${({ theme }) => theme.themeColors.text};
    -webkit-appearance: auto;
  }

  .DayPicker-Month {
    border: ${({ theme }) => `1px solid ${theme.themeColors.text}`};
    border-radius: 5px;

    margin: 12px 0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: ${({ theme }) => theme.colorThemeName === COLOR_THEME_NAMES.light ? colorPalette.primary.oak : colorPalette.primary.charcoal} !important;
    background-color: ${({ theme }) => theme.themeColors.primaryCtaButton} !important;
    border-radius: 5px !important;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    color: ${({ theme }) => theme.themeColors.text} !important;
    background-color: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.2)} !important;
    border-radius: 5px !important;
  }

  .DayPicker-NavBar {
    span {
      top: 10px;
      color: ${({ theme }) => theme.themeColors.text};
    }
  }
`;
const InputWrapper = styled.div`
  display: block;
  margin: 0;
  padding: 8px 0;
  height: 46px;
`;
const InputSpacing = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 200px;
  height: 29px;
`;
const ErrorMessage$4 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const currentMonth = new Date().getMonth();
const currentYear = new Date().getFullYear();
const fromMonth = new Date(currentYear, currentMonth);
const defaultToMonth = new Date(currentYear + 10, currentMonth);
const ExpiryDatePicker = ({ name: name2, label, toMonth, value, error, onChange }) => {
  const massagedValue = value === "" || !value ? new Date() : value;
  const years = [];
  for (let i = fromMonth.getFullYear(); i <= (toMonth || defaultToMonth).getFullYear(); i += 1) {
    years.push(i);
  }
  const handleChange = (e) => {
    const { year, month } = e.target.form;
    const date = new Date(year.value, month.value);
    onChange(name2)(date);
  };
  return /* @__PURE__ */ React.createElement(PickerWrapper$1, {
    className: "DayPicker-Caption"
  }, label && /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputWrapper, {
    className: "input-wrapper"
  }, /* @__PURE__ */ React.createElement(InputSpacing, null, /* @__PURE__ */ React.createElement("select", {
    name: "month",
    onChange: handleChange,
    value: massagedValue.getMonth()
  }, months.map((month, i) => /* @__PURE__ */ React.createElement("option", {
    key: month,
    value: i
  }, month))), /* @__PURE__ */ React.createElement("select", {
    name: "year",
    onChange: handleChange,
    value: massagedValue.getFullYear()
  }, years.map((year) => /* @__PURE__ */ React.createElement("option", {
    key: year,
    value: year
  }, year))))), error && /* @__PURE__ */ React.createElement(ErrorMessage$4, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$e = styled.div`
  border: none;

  select {
    display: block;
    width: 100%;

    color: ${({ theme }) => theme.themeColors.text};
    cursor: pointer;

    option {
      color: ${({ theme }) => theme.themeColors.text};
      background: ${({ theme }) => theme.themeColors.component};
      font-size: 16px;
    }
  }
`;
const ErrorMessage$3 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const createDropdownItem = ({ text, value, disabled }) => {
  return {
    text,
    value,
    disabled
  };
};
const Option = ({ item }) => {
  const { text, disabled, value } = item;
  const textWithDisabledMessage = text;
  return /* @__PURE__ */ React.createElement("option", {
    value,
    disabled
  }, disabled ? textWithDisabledMessage : text);
};
const Dropdown = ({ name: name2, value, label, items, onChange, error }) => {
  const handleSelection = React.useCallback((e) => {
    const value2 = e.target.value;
    {
      onChange(name2)(value2);
    }
  }, [onChange, name2]);
  return /* @__PURE__ */ React.createElement(Wrapper$e, null, label && /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement("select", {
    name: name2,
    value,
    onChange: handleSelection
  }, items.map((item) => /* @__PURE__ */ React.createElement(Option, {
    key: `${name2}-${item.value}`,
    item
  }))), error && /* @__PURE__ */ React.createElement(ErrorMessage$3, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$d = styled.div``;
const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
`;
const ErrorMessage$2 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const createMultiSelectItem = ({ text, value }) => {
  return {
    text,
    value
  };
};
const MultiSelect = ({ name: name2, values, items, onChange, error, ItemComponent }) => {
  const handleSelection = React.useCallback((value) => {
    if (values.includes(value)) {
      const nextValues = values.filter((v) => v !== value);
      onChange(name2)(nextValues);
    } else {
      const nextValues = [...values, value];
      onChange(name2)(nextValues);
    }
  }, [onChange, name2, values]);
  return /* @__PURE__ */ React.createElement(Wrapper$d, null, /* @__PURE__ */ React.createElement(ItemsWrapper, null, items.map((item) => /* @__PURE__ */ React.createElement(ItemComponent, __spreadProps(__spreadValues({
    key: item.value
  }, item), {
    onClick: handleSelection,
    isSelected: values.includes(item.value)
  })))), error && /* @__PURE__ */ React.createElement(ErrorMessage$2, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$c = styled.div`
  padding-right: 16px;
  padding-bottom: 16px;

  button {
    padding: 6px 8px;
  }

  svg {
    margin-left: 12px;
    line-height: 18px;
    height: 14px;
    width: 14px;
  }

  @media (max-width: 360px) {
    padding-right: 8px;

    svg {
      margin-left: 6px;
    }
  }
`;
const UnselectedWrapper = styled.div`
  * {
    transition: all 150ms;
  }
  button {
    display: block;

    background: transparent;
    border: 2px solid ${({ theme }) => theme.themeColors.text};
    border-radius: 5px;
    cursor: pointer;

    * {
      fill: ${({ theme }) => theme.themeColors.text};
      color: ${({ theme }) => theme.themeColors.text};
    }
  }

  button:hover {
    display: block;

    border: 2px solid ${({ theme }) => theme.themeColors.text};
    border-radius: 5px;
    background: ${({ theme }) => theme.themeColors.text};

    cursor: pointer;
    * {
      fill: ${({ theme }) => theme.themeColors.appBackground};
      color: ${({ theme }) => theme.themeColors.appBackground};
    }
  }
`;
const SelectedWrapper = styled.div`
  * {
    transition: all 150ms;
  }
  button {
    display: block;

    border: 2px solid ${({ theme }) => convertHexToRGBA(theme.themeColors.appBackground, 0.2)};
    border-radius: 5px;
    background: ${({ theme }) => theme.themeColors.text};

    cursor: pointer;
    * {
      fill: ${({ theme }) => theme.themeColors.appBackground};
      color: ${({ theme }) => theme.themeColors.appBackground};
    }
  }
`;
const MultiSelectItem = ({ text, value, isSelected, onClick }) => {
  const handleClick = React.useCallback(() => {
    onClick(value);
  }, [onClick, value]);
  if (isSelected) {
    return /* @__PURE__ */ React.createElement(Wrapper$c, null, /* @__PURE__ */ React.createElement(SelectedWrapper, null, /* @__PURE__ */ React.createElement("button", {
      name,
      value,
      onClick: handleClick
    }, /* @__PURE__ */ React.createElement(Body5, null, text), /* @__PURE__ */ React.createElement(Plus, null))));
  }
  return /* @__PURE__ */ React.createElement(Wrapper$c, null, /* @__PURE__ */ React.createElement(UnselectedWrapper, null, /* @__PURE__ */ React.createElement("button", {
    name,
    value,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement(Body5, null, text), /* @__PURE__ */ React.createElement(Plus, null))));
};
const Wrapper$b = styled.div`
  border: none;

  select {
    display: block;
    width: 100%;

    color: ${({ theme }) => theme.themeColors.text};
    cursor: pointer;

    option {
      color: ${({ theme }) => theme.themeColors.text};
      background: ${({ theme }) => theme.themeColors.component};
      font-size: 16px;
    }
  }
`;
const CheckboxWrapper = styled.div`
  background: transparent;
  width: 36px;
`;
const Box = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;

  transition: all 0.2s ease;

  background: transparent;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};

  height: 20px;
  width: 20px;

  &::before,
  &::after {
    position: absolute;
    display: block;
    content: '';
    width: 2px;
    transition: all 0.2s ease;
  }
  &::before {
    height: 3px;
    left: 1px;
    top: 20px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &::after {
    height: 7px;
    right: 3px;
    top: 20px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${({ theme, checked }) => checked ? `
    background-color: ${theme.themeColors.primaryCtaButton};
    
      &::before {
        height: 6px;
        left: 4px;
        top: 9px;
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
        background-color: ${theme.themeColors.component};
      }
      &::after {
        height: 13px;
        right: 6px;
        top: 3px;
        background-color: ${theme.themeColors.component};
      }
  ` : ""};
`;
const ErrorMessage$1 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const Checkbox = ({ name: name2, value, label, onChange, error, stopPropagation }) => {
  const handleClick = React.useCallback((e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    {
      onChange(name2)(!value);
    }
  }, [onChange, name2, value]);
  return /* @__PURE__ */ React.createElement(Wrapper$b, null, label && /* @__PURE__ */ React.createElement("label", {
    className: "no-select"
  }, /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(CheckboxWrapper, null, /* @__PURE__ */ React.createElement(Box, {
    id: `checkbox-${name2}`,
    checked: value,
    onClick: handleClick
  })), error && /* @__PURE__ */ React.createElement(ErrorMessage$1, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$a = styled.div`
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 0;
  }

  .sc-input-wrapper {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    padding: 7px 0 9px 0;
    font-size: 18px;
    line-height: 27px;
  }

  input {
    padding: 8px 0 8px 3px;

    transform-origin: left;
    transition: border 0.3s ease;
    font-size: 16px;
    line-height: 27px;
    border: none !important;

    &:focus {
      outline: none;
    }
  }

  ${({ theme, isLifted }) => isLifted ? `
      label {
        left: 0px;
      }
    ` : `
      label {
        top: 32px;
        left: 0;

        pointer-events: none;

        * {
          font-size: 16px;
        }
      }
      
      .input-text-prefix {
        display: none;
      }
    `};

  .sc-error-text {
    padding: 4px 0 0 3px;
  }

  ${({ theme, error }) => error !== null ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.error};
      }

      label * {
        color: ${theme.themeColors.error};
     }
  ` : ""};

  ${({ theme, isFocused }) => isFocused ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.primaryCtaButton};
      }

      label * {
        color: ${theme.themeColors.primaryCtaButton};
     }
  ` : ""};
`;
const LabelSpacing = styled.div`
  height: 20px;
`;
const FloatingLabelTextInput = (props) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const { value, placeholder, error, onFocus, onBlur, forceLiftedState } = props;
  const handleFocus = (name2) => {
    onFocus && onFocus(name2);
    setIsFocused(true);
  };
  const handleBlur = (name2) => {
    onBlur && onBlur(name2);
    setIsFocused(false);
  };
  const showLabelAsValue = !isFocused && value === "";
  return /* @__PURE__ */ React.createElement(Wrapper$a, {
    error,
    isFocused,
    isLifted: !showLabelAsValue || forceLiftedState
  }, /* @__PURE__ */ React.createElement(LabelSpacing, null), /* @__PURE__ */ React.createElement(TextInput, __spreadProps(__spreadValues({}, props), {
    value: showLabelAsValue ? "" : value,
    placeholder,
    onFocus: handleFocus,
    onBlur: handleBlur
  })));
};
const Wrapper$9 = styled.div`
  width: 100%;

  label {
    padding: 0;
    margin: 0;
  }

  select {
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    font-size: 16px;
    line-height: 18px;
    height: 46px; // line height doesn't change height of select
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const FloatingLabelDropdown = (props) => {
  return /* @__PURE__ */ React.createElement(Wrapper$9, null, /* @__PURE__ */ React.createElement(Dropdown, __spreadValues({}, props)));
};
const Wrapper$8 = styled.div``;
function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}
function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}
function countDecimals(str) {
  const num = parseFloat(str);
  if (Math.floor(num) === num)
    return 0;
  return str.split(".")[1].length || 0;
}
const FloatingLabelCurrencyInput = (props) => {
  const valueSanitizer = (newValue, prevValue) => {
    if (newValue === "") {
      return "0";
    }
    if (isNaN(newValue)) {
      return prevValue;
    }
    if (countDecimals(newValue) > 2) {
      return prevValue;
    }
    const parsedFloat = parseFloat(newValue);
    if (isFloat(parsedFloat) && isInt(parsedFloat)) {
      return prevValue;
    }
    if (newValue[newValue.length - 1] === ".") {
      return newValue;
    }
    return parseFloat(newValue).toString();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$8, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, __spreadProps(__spreadValues({}, props), {
    prefix: "$",
    valueSanitizer
  })));
};
const Wrapper$7 = styled.div`
  position: relative;

  label {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 0;
  }

  .sc-input-wrapper {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${({ theme }) => theme.themeColors.text};
  }

  .input-text-prefix {
    padding: 8px 0;
  }

  input {
    padding: 8px 0 8px 3px;

    transform-origin: left;
    transition: border 0.3s ease;
    font-size: 16px;
    line-height: 27px;

    &:focus {
      outline: none;
    }
  }

  ${({ theme, isLifted }) => isLifted || true ? `
      label {
        left: 0px;
      }
    ` : `
      label {
        top: 25px;
        left: 0;

        pointer-events: none;

        * {
          font-size: 16px;
        }
      }
      
      .input-text-prefix {
        display: none;
      }
    `};

  .sc-error-text {
    padding: 4px 0 0 3px;
  }

  ${({ theme, error }) => error !== null ? `
      .sc-input-wrapper {
        border-color: ${theme.themeColors.error};
      }

      label * {
        color: ${theme.themeColors.error};
     }
  ` : ""};
`;
const InputMock = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
  padding: 8px 0 8px 3px;

  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${({ theme }) => theme.themeColors.text};

  font-size: 16px;
  line-height: 27px;
  color: ${({ theme }) => theme.themeColors.text};
  cursor: default;
`;
const ErrorMessage = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const stringifyDate = (d) => {
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
};
const FloatingLabelDatePicker = (props) => {
  const { name: name2, label, value, error } = props;
  return /* @__PURE__ */ React.createElement(Wrapper$7, __spreadValues({}, props), /* @__PURE__ */ React.createElement("label", {
    htmlFor: name2,
    className: "no-select"
  }, label && /* @__PURE__ */ React.createElement(Body5, null, label)), /* @__PURE__ */ React.createElement(InputMock, null, value !== "" ? typeof value === "object" ? stringifyDate(value) : value : "Select With Calender Below"), error && /* @__PURE__ */ React.createElement(ErrorMessage, {
    className: "sc-error-text"
  }, /* @__PURE__ */ React.createElement(Body5, null, error)), /* @__PURE__ */ React.createElement(DatePicker, __spreadValues({}, props)));
};
const PickerWrapper = styled.form`
  display: block;
  margin: 0;
  padding: 0;

  * {
    color: ${({ theme }) => theme.themeColors.text};
  }

  .input-wrapper {
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
  }

  select {
    color: ${({ theme }) => theme.themeColors.text};
    -webkit-appearance: auto;
  }
`;
const FloatingLabelExpiryDatePicker = (props) => {
  return /* @__PURE__ */ React.createElement(PickerWrapper, null, /* @__PURE__ */ React.createElement(ExpiryDatePicker, __spreadValues({}, props)));
};
const Wrapper$6 = styled.div`
  position: relative;
`;
const InputsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const SingleInputWrapper = styled.div`
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }
`;
const ErrorText = styled.div`
  padding-top: 8px;
  color: ${({ theme }) => theme.themeColors.error};
`;
const FloatingLabelDateEntry = (props) => {
  const { name: name2, value, error, onChange, autoFocus } = props;
  const [month, setMonth] = React.useState("");
  const [day, setDay] = React.useState("");
  const [year, setYear] = React.useState("");
  const monthRef = React.useRef(null);
  const dayRef = React.useRef(null);
  const yearRef = React.useRef(null);
  const handleMonthChange = (n) => (v) => {
    var _a;
    setMonth(v);
    if (value.length === 2) {
      (_a = dayRef == null ? void 0 : dayRef.current) == null ? void 0 : _a.focus();
    }
  };
  const handleDayChange = (n) => (v) => {
    var _a;
    setDay(v);
    if (v.length === 2) {
      (_a = yearRef == null ? void 0 : yearRef.current) == null ? void 0 : _a.focus();
    }
  };
  const handleYearChange = (n) => (v) => {
    setYear(v);
  };
  React.useEffect(() => {
    if (value !== "") {
      const d = new Date(value);
      if (!isNaN(d.getDate())) {
        const [month2, day2, year2] = value.split("/");
        setMonth(month2);
        setDay(day2);
        setYear(year2);
      }
    }
  }, []);
  React.useEffect(() => {
    var _a;
    if (month.length === 1 && ["3", "4", "5", "6", "7", "8", "9"].includes(month)) {
      setMonth("0" + month);
      (_a = dayRef == null ? void 0 : dayRef.current) == null ? void 0 : _a.focus();
    }
    let autoFormattedMonth = month === "1" ? "01" : month;
    let autoFormattedDay = day.length === 1 ? "0" + day : day;
    const concatDate = `${autoFormattedMonth}/${autoFormattedDay}/${year}`;
    const d = new Date(concatDate);
    if (!isNaN(d.getDate()) && month.length > 0 && day.length > 0 && year.length === 4) {
      if (month !== autoFormattedMonth)
        setMonth(autoFormattedMonth);
      if (day !== autoFormattedDay)
        setDay(autoFormattedDay);
      onChange(name2)(concatDate);
    }
  }, [name2, month, day, year, onChange]);
  return /* @__PURE__ */ React.createElement(Wrapper$6, null, /* @__PURE__ */ React.createElement(InputsWrapper, null, /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, __spreadProps(__spreadValues({}, props), {
    name: props.name ? `${props.name}-month` : "date-month",
    inputRef: monthRef,
    onChange: handleMonthChange,
    label: "Month",
    value: month,
    placeholder: "MM",
    forceLiftedState: true,
    autoFocus,
    error: null
  }))), /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, __spreadProps(__spreadValues({}, props), {
    name: props.name ? `${props.name}-day` : "date-day",
    inputRef: dayRef,
    onChange: handleDayChange,
    label: "Day",
    value: day,
    placeholder: "DD",
    forceLiftedState: true,
    autoFocus: false,
    error: null
  }))), /* @__PURE__ */ React.createElement(SingleInputWrapper, null, /* @__PURE__ */ React.createElement(FloatingLabelTextInput, __spreadProps(__spreadValues({}, props), {
    name: props.name ? `${props.name}-year` : "date-year",
    inputRef: yearRef,
    onChange: handleYearChange,
    label: "Year",
    value: year,
    placeholder: "YYYY",
    forceLiftedState: true,
    autoFocus: false,
    error: null
  })))), error !== null && /* @__PURE__ */ React.createElement(ErrorText, null, error));
};
const Wrapper$5 = styled.div`
  select {
    padding: 4px 0;
    margin: 0 4px;

    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    border-top: none;
    border-left: none;
    border-right: none;

    font-size: 16px;
    line-height: 18px;

    // web-ui global overrides
    display: inline-block !important;
    width: auto !important;
    background: none !important;
    -webkit-appearance: auto;
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const InlineTextDropdown = (props) => {
  return /* @__PURE__ */ React.createElement(Wrapper$5, null, /* @__PURE__ */ React.createElement(Dropdown, __spreadProps(__spreadValues({}, props), {
    label: null
  })));
};
const Wrapper$4 = styled.div`
  label {
    padding: 0;
    margin: 0;
  }

  select {
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.text};
    font-size: 16px;
    line-height: 18px;
  }

  .sc-error-text {
    padding: 4px 0 0 3px;
  }
`;
const AgreementWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Error$1 = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;
const AgreementCheckbox = (props) => {
  const { label, error } = props;
  return /* @__PURE__ */ React.createElement(Wrapper$4, null, /* @__PURE__ */ React.createElement(AgreementWrapper, null, /* @__PURE__ */ React.createElement(Checkbox, __spreadProps(__spreadValues({}, props), {
    label: null,
    error: null
  })), /* @__PURE__ */ React.createElement(Body5, null, label)), error && /* @__PURE__ */ React.createElement(Error$1, null, /* @__PURE__ */ React.createElement(Body5, null, error)));
};
const Wrapper$3 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Neutral = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.neutral};
  }
`;
const Positive = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.positive};
  }
`;
const Negative = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    width: ${({ size }) => `${size > 0 ? size : 24}px`};
  }

  path {
    fill: ${({ theme }) => theme.themeColors.negative};
  }
`;
const ChangeIndicator = ({ value, size }) => {
  if (value === 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Neutral, {
      size
    }, /* @__PURE__ */ React.createElement(Minus, null)));
  }
  if (value > 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Positive, {
      size
    }, /* @__PURE__ */ React.createElement(CaretUp, null)));
  }
  if (value < 0) {
    return /* @__PURE__ */ React.createElement(Wrapper$3, null, /* @__PURE__ */ React.createElement(Negative, {
      size
    }, /* @__PURE__ */ React.createElement(CaretDown, null)));
  }
  return null;
};
const isDarkBg$1 = css`
  svg {
    background: #2b2927;
    border-radius: 9px;
    .border-color-app-store {
      fill: #2b2927;
    }
  }
`;
const Wrapper$2 = styled.div`
  cursor: pointer;

  g {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  ${(props) => props.isDarkBg ? isDarkBg$1 : ""};
`;
function AppStore({ forceDarkTheme, height, width, isDarkBg: isDarkBg2, onAfterClick, url }) {
  const handleClick = () => {
    window == null ? void 0 : window.open(url, "_blank").focus();
    onAfterClick();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$2, {
    forceDarkTheme,
    isDarkBg: isDarkBg2,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "0 0 205 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    className: "border-color-app-store",
    d: "M196.667 1.17426C200.169 1.17426 203.019 3.93509 203.019 7.32796V51.296C203.019 54.6889 200.169 57.4497 196.667 57.4497H7.5641C4.06192 57.4497 1.21215 54.6889 1.21215 51.296V7.32796C1.21215 3.93509 4.06192 1.17426 7.5641 1.17426H196.667ZM196.667 -5.01847e-05H7.5641C3.40574 -5.01847e-05 0 3.29938 0 7.32796V51.296C0 55.3246 3.40574 58.624 7.5641 58.624H196.667C200.825 58.624 204.231 55.3246 204.231 51.296V7.32796C204.231 3.29938 200.825 -5.01847e-05 196.667 -5.01847e-05Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M45.578 28.9951C45.5341 24.2715 49.5703 21.9734 49.7549 21.8665C47.469 18.6377 43.926 18.1966 42.6809 18.1614C39.7052 17.858 36.8187 19.8864 35.3029 19.8864C33.7568 19.8864 31.4225 18.1907 28.9067 18.2406C25.6692 18.2889 22.6406 20.1048 20.9795 22.9246C17.5515 28.6742 20.1081 37.1234 23.3925 41.7708C25.0354 44.0469 26.9551 46.5882 29.4679 46.4988C31.9263 46.4006 32.8446 44.9805 35.8112 44.9805C38.7506 44.9805 39.6129 46.4988 42.1756 46.4417C44.814 46.4006 46.4751 44.1553 48.0605 41.8587C49.9591 39.25 50.7216 36.6808 50.7518 36.5489C50.6898 36.5283 45.6279 34.6568 45.578 28.9951Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M40.7369 15.1042C42.0591 13.5023 42.9638 11.3229 42.7127 9.11133C40.799 9.1934 38.4057 10.3937 37.0275 11.9605C35.8082 13.3411 34.7189 15.6039 35.0003 17.732C37.15 17.8874 39.3572 16.6812 40.7369 15.1042Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M81.1547 46.1737H77.7191L75.8372 40.4446H69.2957L67.503 46.1737H64.1582L70.6391 26.6694H74.642L81.1547 46.1737ZM75.2699 38.041L73.5679 32.9481C73.3879 32.4278 73.0506 31.2025 72.5528 29.2738H72.4923C72.2941 30.1033 71.9749 31.3286 71.5362 32.9481L69.8646 38.041H75.2699Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M97.8218 38.9671C97.8218 41.3589 97.1546 43.2496 95.8203 44.6375C94.6252 45.873 93.1411 46.49 91.3696 46.49C89.4574 46.49 88.0837 45.8246 87.2472 44.4939H87.1866V51.9025H83.9613V36.7379C83.9613 35.2342 83.9205 33.6909 83.8418 32.1081H86.6783L86.8584 34.3372H86.9189C87.9945 32.6577 89.6268 31.8193 91.8174 31.8193C93.5299 31.8193 94.9595 32.4745 96.1032 33.7862C97.2499 35.0994 97.8218 36.8258 97.8218 38.9671ZM94.5359 39.0814C94.5359 37.7125 94.2182 36.584 93.5798 35.6959C92.8824 34.7696 91.946 34.3065 90.772 34.3065C89.9763 34.3065 89.2532 34.5644 88.6072 35.073C87.9597 35.5859 87.5361 36.2557 87.3379 37.0852C87.2381 37.4722 87.1882 37.7887 87.1882 38.0379V40.3828C87.1882 41.4058 87.5119 42.2691 88.1594 42.974C88.8069 43.679 89.648 44.0307 90.6828 44.0307C91.8976 44.0307 92.8431 43.5764 93.5193 42.6707C94.1971 41.7634 94.5359 40.5675 94.5359 39.0814Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M114.518 38.9671C114.518 41.3589 113.851 43.2496 112.516 44.6375C111.322 45.873 109.838 46.49 108.066 46.49C106.154 46.49 104.78 45.8246 103.945 44.4939H103.885V51.9025H100.66V36.7379C100.66 35.2342 100.619 33.6909 100.54 32.1081H103.377L103.557 34.3372H103.617C104.691 32.6577 106.324 31.8193 108.516 31.8193C110.227 31.8193 111.656 32.4745 112.803 33.7862C113.945 35.0994 114.518 36.8258 114.518 38.9671ZM111.233 39.0814C111.233 37.7125 110.913 36.584 110.275 35.6959C109.578 34.7696 108.644 34.3065 107.469 34.3065C106.672 34.3065 105.95 34.5644 105.302 35.073C104.655 35.5859 104.233 36.2557 104.035 37.0852C103.936 37.4722 103.885 37.7887 103.885 38.0379V40.3828C103.885 41.4058 104.209 42.2691 104.853 42.974C105.501 43.6775 106.342 44.0307 107.38 44.0307C108.594 44.0307 109.54 43.5764 110.216 42.6707C110.894 41.7634 111.233 40.5675 111.233 39.0814Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M133.186 40.7022C133.186 42.3613 132.592 43.7111 131.398 44.7532C130.086 45.8919 128.26 46.4606 125.914 46.4606C123.748 46.4606 122.011 46.0561 120.696 45.2456L121.444 42.6412C122.86 43.4708 124.413 43.887 126.106 43.887C127.321 43.887 128.266 43.6202 128.946 43.0897C129.622 42.5592 129.959 41.8469 129.959 40.9587C129.959 40.1673 129.681 39.5004 129.123 38.9596C128.567 38.4188 127.64 37.9161 126.345 37.4515C122.82 36.1779 121.059 34.3122 121.059 31.8588C121.059 30.2554 121.677 28.9408 122.913 27.9178C124.144 26.8933 125.787 26.3818 127.841 26.3818C129.673 26.3818 131.195 26.6911 132.41 27.3081L131.604 29.8553C130.469 29.2573 129.186 28.9584 127.751 28.9584C126.616 28.9584 125.729 29.2295 125.094 29.7688C124.557 30.251 124.288 30.8387 124.288 31.5349C124.288 32.3058 124.595 32.9433 125.212 33.4446C125.749 33.9077 126.725 34.4089 128.141 34.9497C129.873 35.6254 131.145 36.4153 131.964 37.3211C132.779 38.2239 133.186 39.3539 133.186 40.7022Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M143.851 34.4527H140.296V41.281C140.296 43.0177 140.922 43.8853 142.178 43.8853C142.754 43.8853 143.232 43.837 143.61 43.7403L143.699 46.1131C143.064 46.3432 142.227 46.4589 141.191 46.4589C139.917 46.4589 138.922 46.0823 138.203 45.3304C137.488 44.5771 137.128 43.3138 137.128 41.5389V34.4498H135.01V32.1048H137.128V29.5298L140.296 28.6035V32.1048H143.851V34.4527Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M159.891 39.0237C159.891 41.1855 159.252 42.9604 157.979 44.3483C156.643 45.7772 154.87 46.4895 152.66 46.4895C150.53 46.4895 148.834 45.8051 147.569 44.4362C146.304 43.0673 145.672 41.3394 145.672 39.2568C145.672 37.0774 146.322 35.2923 147.628 33.9044C148.93 32.515 150.688 31.8203 152.899 31.8203C155.029 31.8203 156.743 32.5047 158.036 33.8751C159.274 35.2044 159.891 36.9206 159.891 39.0237ZM156.545 39.1249C156.545 37.8278 156.259 36.7154 155.679 35.7877C155.003 34.665 154.036 34.1052 152.784 34.1052C151.487 34.1052 150.502 34.6665 149.826 35.7877C149.247 36.7169 148.961 37.8469 148.961 39.1835C148.961 40.4806 149.247 41.5929 149.826 42.5192C150.523 43.6419 151.498 44.2017 152.755 44.2017C153.986 44.2017 154.953 43.6301 155.65 42.4899C156.245 41.5446 156.545 40.4205 156.545 39.1249Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M170.374 34.8561C170.055 34.7989 169.715 34.7696 169.358 34.7696C168.223 34.7696 167.346 35.1844 166.728 36.0154C166.191 36.7482 165.922 37.6744 165.922 38.7927V46.172H162.698L162.728 36.5371C162.728 34.9162 162.688 33.4403 162.607 32.1095H165.417L165.535 34.8004H165.624C165.964 33.8756 166.501 33.131 167.237 32.5727C167.955 32.07 168.731 31.8193 169.568 31.8193C169.866 31.8193 170.135 31.8399 170.374 31.8765V34.8561Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M184.8 38.4742C184.8 39.034 184.762 39.5059 184.682 39.8914H175.006C175.044 41.2808 175.511 42.3433 176.41 43.0761C177.225 43.7313 178.28 44.0596 179.574 44.0596C181.007 44.0596 182.314 43.8383 183.49 43.3942L183.995 45.5633C182.621 46.1437 181 46.4324 179.128 46.4324C176.877 46.4324 175.11 45.7904 173.824 44.508C172.541 43.2256 171.898 41.5036 171.898 39.3433C171.898 37.2225 172.496 35.4565 173.693 34.048C174.945 32.5443 176.638 31.7925 178.768 31.7925C180.86 31.7925 182.444 32.5443 183.52 34.048C184.372 35.2425 184.8 36.7198 184.8 38.4742ZM181.724 37.6637C181.745 36.7374 181.535 35.9372 181.098 35.2616C180.54 34.3925 179.682 33.9586 178.528 33.9586C177.473 33.9586 176.615 34.3822 175.96 35.2322C175.423 35.9079 175.104 36.7184 175.006 37.6622H181.724V37.6637Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M74.2041 14.6694C74.2041 16.3944 73.6701 17.6929 72.6036 18.565C71.6157 19.3696 70.2118 19.7726 68.3934 19.7726C67.4917 19.7726 66.7202 19.7345 66.0742 19.6583V10.233C66.9169 10.1011 67.8246 10.0337 68.8049 10.0337C70.537 10.0337 71.8426 10.3986 72.7231 11.1285C73.7094 11.9536 74.2041 13.1334 74.2041 14.6694ZM72.5325 14.7119C72.5325 13.5936 72.2269 12.7363 71.6157 12.1383C71.0045 11.5418 70.1119 11.2428 68.9365 11.2428C68.4372 11.2428 68.0121 11.2751 67.6597 11.3425V18.5078C67.8548 18.5371 68.2118 18.5503 68.7307 18.5503C69.944 18.5503 70.8805 18.2235 71.54 17.5698C72.1996 16.9162 72.5325 15.9635 72.5325 14.7119Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M83.0677 16.1752C83.0677 17.2377 82.7545 18.1083 82.1282 18.7913C81.4717 19.4933 80.6018 19.8436 79.5156 19.8436C78.4687 19.8436 77.6352 19.5079 77.0134 18.8338C76.3931 18.1611 76.083 17.3125 76.083 16.2895C76.083 15.2196 76.4022 14.3417 77.0436 13.6602C77.6851 12.9787 78.5474 12.6372 79.6336 12.6372C80.6805 12.6372 81.5216 12.9728 82.1585 13.6455C82.7636 14.2992 83.0677 15.1434 83.0677 16.1752ZM81.4233 16.225C81.4233 15.5875 81.2811 15.0408 80.9982 14.585C80.6653 14.0339 80.1918 13.7584 79.5761 13.7584C78.9392 13.7584 78.4551 14.0339 78.1223 14.585C77.8379 15.0408 77.6972 15.5963 77.6972 16.2528C77.6972 16.8904 77.8394 17.4371 78.1223 17.8929C78.4657 18.4439 78.9438 18.7195 79.561 18.7195C80.1661 18.7195 80.6411 18.4395 80.983 17.8782C81.2765 17.4136 81.4233 16.8625 81.4233 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M94.9527 12.7778L92.7213 19.6867H91.269L90.3446 16.6866C90.1101 15.9377 89.9195 15.1931 89.7713 14.4545H89.7425C89.6049 15.2137 89.4142 15.9567 89.1692 16.6866L88.1873 19.6867H86.7184L84.6201 12.7778H86.2494L87.0558 16.0622C87.2509 16.839 87.4113 17.5791 87.5399 18.2797H87.5686C87.6866 17.7023 87.8818 16.9665 88.1571 16.0769L89.1692 12.7793H90.4611L91.4308 16.0066C91.6653 16.7936 91.8559 17.5513 92.0027 18.2812H92.0465C92.154 17.5704 92.3158 16.8126 92.5307 16.0066L93.396 12.7793H94.9527V12.7778Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M103.172 19.6872H101.586V15.7301C101.586 14.5107 101.108 13.901 100.149 13.901C99.6788 13.901 99.299 14.0681 99.004 14.4037C98.7121 14.7394 98.5638 15.1351 98.5638 15.588V19.6858H96.9784V14.7526C96.9784 14.1458 96.9587 13.4877 96.9209 12.7755H98.3142L98.3883 13.8556H98.4322C98.6168 13.52 98.8921 13.243 99.2537 13.0217C99.6833 12.7637 100.164 12.6333 100.691 12.6333C101.356 12.6333 101.91 12.8414 102.35 13.2591C102.898 13.7706 103.172 14.5342 103.172 15.5484V19.6872Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M107.544 19.6873H105.96V9.6084H107.544V19.6873Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M116.878 16.1752C116.878 17.2377 116.565 18.1083 115.939 18.7913C115.282 19.4933 114.411 19.8436 113.326 19.8436C112.278 19.8436 111.444 19.5079 110.824 18.8338C110.204 18.1611 109.894 17.3125 109.894 16.2895C109.894 15.2196 110.213 14.3417 110.854 13.6602C111.496 12.9787 112.358 12.6372 113.443 12.6372C114.491 12.6372 115.331 12.9728 115.969 13.6455C116.574 14.2992 116.878 15.1434 116.878 16.1752ZM115.232 16.225C115.232 15.5875 115.09 15.0408 114.807 14.585C114.476 14.0339 114.001 13.7584 113.387 13.7584C112.748 13.7584 112.264 14.0339 111.933 14.585C111.648 15.0408 111.508 15.5963 111.508 16.2528C111.508 16.8904 111.65 17.4371 111.933 17.8929C112.276 18.4439 112.754 18.7195 113.372 18.7195C113.977 18.7195 114.45 18.4395 114.792 17.8782C115.087 17.4136 115.232 16.8625 115.232 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M124.551 19.6867H123.127L123.009 18.8909H122.965C122.478 19.5255 121.784 19.8436 120.882 19.8436C120.209 19.8436 119.664 19.634 119.255 19.2178C118.882 18.8396 118.696 18.3692 118.696 17.8108C118.696 16.9666 119.059 16.3232 119.79 15.8777C120.519 15.4321 121.545 15.2137 122.866 15.224V15.095C122.866 14.1849 122.372 13.7305 121.385 13.7305C120.681 13.7305 120.061 13.902 119.525 14.242L119.203 13.2337C119.866 12.8365 120.684 12.6372 121.649 12.6372C123.513 12.6372 124.448 13.5898 124.448 15.4951V18.0394C124.448 18.7297 124.483 19.2793 124.551 19.6867ZM122.905 17.3125V16.247C121.156 16.2177 120.282 16.6823 120.282 17.6393C120.282 17.9998 120.382 18.2695 120.586 18.4498C120.79 18.6301 121.05 18.7195 121.36 18.7195C121.708 18.7195 122.034 18.6125 122.33 18.4C122.628 18.186 122.811 17.9148 122.879 17.5821C122.896 17.5074 122.905 17.4165 122.905 17.3125Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M133.56 19.6873H132.153L132.079 18.5779H132.035C131.585 19.4221 130.82 19.8442 129.744 19.8442C128.885 19.8442 128.169 19.5173 127.602 18.8637C127.035 18.21 126.752 17.3614 126.752 16.3194C126.752 15.2011 127.059 14.2954 127.676 13.6036C128.274 12.9588 129.006 12.6363 129.877 12.6363C130.835 12.6363 131.505 12.9485 131.886 13.5743H131.917V9.6084H133.504V17.826C133.504 18.4987 133.522 19.1187 133.56 19.6873ZM131.917 16.7737V15.6218C131.917 15.4224 131.902 15.2612 131.873 15.1381C131.784 14.7688 131.591 14.4581 131.299 14.2075C131.004 13.9568 130.649 13.8308 130.239 13.8308C129.647 13.8308 129.185 14.058 128.844 14.5138C128.507 14.9696 128.336 15.5514 128.336 16.2622C128.336 16.9452 128.498 17.4992 128.823 17.9257C129.166 18.38 129.629 18.6072 130.209 18.6072C130.729 18.6072 131.145 18.4181 131.461 18.0385C131.767 17.6883 131.917 17.2662 131.917 16.7737Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M147.119 16.1752C147.119 17.2377 146.806 18.1083 146.18 18.7913C145.523 19.4933 144.655 19.8436 143.567 19.8436C142.522 19.8436 141.688 19.5079 141.065 18.8338C140.445 18.1611 140.135 17.3125 140.135 16.2895C140.135 15.2196 140.454 14.3417 141.095 13.6602C141.737 12.9787 142.599 12.6372 143.687 12.6372C144.732 12.6372 145.575 12.9728 146.21 13.6455C146.815 14.2992 147.119 15.1434 147.119 16.1752ZM145.477 16.225C145.477 15.5875 145.334 15.0408 145.051 14.585C144.717 14.0339 144.245 13.7584 143.628 13.7584C142.992 13.7584 142.508 14.0339 142.174 14.585C141.89 15.0408 141.749 15.5963 141.749 16.2528C141.749 16.8904 141.891 17.4371 142.174 17.8929C142.517 18.4439 142.996 18.7195 143.613 18.7195C144.218 18.7195 144.694 18.4395 145.036 17.8782C145.328 17.4136 145.477 16.8625 145.477 16.225Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M155.644 19.6872H154.06V15.7301C154.06 14.5107 153.582 13.901 152.621 13.901C152.151 13.901 151.771 14.0681 151.478 14.4037C151.184 14.7394 151.037 15.1351 151.037 15.588V19.6858H149.451V14.7526C149.451 14.1458 149.432 13.4877 149.395 12.7755H150.786L150.86 13.8556H150.904C151.09 13.52 151.366 13.243 151.726 13.0217C152.157 12.7637 152.637 12.6333 153.164 12.6333C153.829 12.6333 154.382 12.8414 154.823 13.2591C155.372 13.7706 155.644 14.5342 155.644 15.5484V19.6872Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M166.314 13.9292H164.568V17.2854C164.568 18.1384 164.878 18.5649 165.493 18.5649C165.777 18.5649 166.013 18.5415 166.199 18.4931L166.24 19.6583C165.927 19.7726 165.515 19.8297 165.008 19.8297C164.382 19.8297 163.895 19.6451 163.543 19.2757C163.189 18.9064 163.013 18.285 163.013 17.413V13.9292H161.971V12.7787H163.013V11.5124L164.567 11.0581V12.7773H166.312V13.9292H166.314Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M174.707 19.6873H173.12V15.7595C173.12 14.5211 172.642 13.9011 171.685 13.9011C170.949 13.9011 170.447 14.2602 170.172 14.9784C170.125 15.1293 170.098 15.314 170.098 15.5309V19.6859H168.514V9.6084H170.098V13.7722H170.128C170.627 13.0145 171.343 12.6363 172.27 12.6363C172.927 12.6363 173.47 12.8444 173.901 13.2621C174.438 13.7824 174.707 14.5563 174.707 15.5793V19.6873Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M183.365 15.906C183.365 16.1815 183.343 16.4131 183.306 16.6022H178.551C178.572 17.2851 178.799 17.8054 179.239 18.166C179.642 18.4884 180.16 18.6496 180.796 18.6496C181.499 18.6496 182.141 18.5411 182.719 18.3228L182.967 19.3897C182.291 19.6741 181.495 19.8162 180.573 19.8162C179.469 19.8162 178.599 19.5011 177.97 18.8709C177.338 18.2407 177.024 17.395 177.024 16.3339C177.024 15.2919 177.316 14.4243 177.905 13.7325C178.519 12.9938 179.35 12.6245 180.398 12.6245C181.424 12.6245 182.203 12.9938 182.729 13.7325C183.154 14.3187 183.365 15.0442 183.365 15.906ZM181.852 15.5088C181.864 15.053 181.76 14.6602 181.545 14.329C181.269 13.9025 180.85 13.6885 180.283 13.6885C179.766 13.6885 179.344 13.8967 179.021 14.3144C178.758 14.647 178.602 15.0442 178.551 15.5088H181.852Z"
  }))));
}
var DownloadOnAppStore = withTheme(AppStore);
const isDarkBg = css`
  svg {
    background: #2b2927;
    border-radius: 9px;
    .border-color-android-app-store {
      fill: #2b2927;
    }
  }
`;
const Wrapper$1 = styled.div`
  cursor: pointer;

  g {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  .text-stroke {
    fill: ${(props) => props.forceDarkTheme ? props.theme.secondary.white : props.theme.themeColors.text};
  }
  ${(props) => props.isDarkBg ? isDarkBg : ""};
`;
function GooglePlay({ forceDarkTheme, theme, height, width, isDarkBg: isDarkBg2, onAfterClick, url }) {
  const handleClick = () => {
    window == null ? void 0 : window.open(url, "_blank").focus();
    onAfterClick();
  };
  return /* @__PURE__ */ React.createElement(Wrapper$1, {
    forceDarkTheme,
    isDarkBg: isDarkBg2,
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement("svg", {
    width,
    height,
    viewBox: "35 30 203 59",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /* @__PURE__ */ React.createElement("path", {
    className: "border-color-android-app-store",
    d: "M230.743 31.1779C234.229 31.1779 237.065 33.9472 237.065 37.3505V81.4532C237.065 84.8565 234.229 87.6258 230.743 87.6258H42.5286C39.0428 87.6258 36.2065 84.8565 36.2065 81.4532V37.3505C36.2065 33.9472 39.0428 31.1779 42.5286 31.1779H230.743ZM230.743 30H42.5286C38.3897 30 35 33.3096 35 37.3505V81.4532C35 85.4942 38.3897 88.8037 42.5286 88.8037H230.743C234.882 88.8037 238.272 85.4942 238.272 81.4532V37.3505C238.272 33.3096 234.882 30 230.743 30Z"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "text-stroke",
    d: "M106.397 45.0591C106.397 46.2866 106.02 47.2698 105.279 48.003C104.426 48.8722 103.316 49.3095 101.955 49.3095C100.654 49.3095 99.5439 48.8648 98.633 47.9883C97.7201 47.0989 97.2646 46.0073 97.2646 44.7008C97.2646 43.3942 97.7201 42.3027 98.633 41.4206C99.5439 40.5367 100.654 40.092 101.955 40.092C102.602 40.092 103.22 40.2225 103.809 40.4651C104.396 40.7095 104.874 41.0403 105.22 41.4482L104.434 42.2237C103.83 41.5272 103.007 41.1836 101.955 41.1836C101.006 41.1836 100.184 41.507 99.4856 42.1594C98.7948 42.8135 98.4485 43.6607 98.4485 44.7008C98.4485 45.7409 98.7948 46.5954 99.4856 47.2496C100.184 47.8946 101.006 48.2253 101.955 48.2253C102.962 48.2253 103.809 47.8946 104.477 47.2422C104.917 46.8104 105.168 46.215 105.234 45.4542H101.955V44.3921H106.329C106.382 44.6218 106.397 44.8441 106.397 45.0591Z",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "text-stroke",
    d: "M113.337 41.3765H109.229V44.1697H112.933V45.2319H109.229V48.025H113.337V49.1074H108.065V40.2942H113.337V41.3765Z",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M118.234 49.1074H117.071V41.3765H114.551V40.2942H120.756V41.3765H118.234V49.1074Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M125.247 49.1074V40.2942H126.408V49.1074H125.247Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M131.556 49.1074H130.403V41.3765H127.873V40.2942H134.086V41.3765H131.556V49.1074Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M145.834 47.9736C144.944 48.8648 143.841 49.3095 142.525 49.3095C141.202 49.3095 140.099 48.8648 139.209 47.9736C138.32 47.0842 137.878 45.9926 137.878 44.7008C137.878 43.4089 138.32 42.3174 139.209 41.428C140.099 40.5367 141.202 40.092 142.525 40.092C143.833 40.092 144.936 40.5367 145.826 41.4353C146.722 42.3321 147.164 43.4163 147.164 44.7008C147.164 45.9926 146.722 47.0842 145.834 47.9736ZM140.069 47.2349C140.739 47.8946 141.554 48.2253 142.525 48.2253C143.489 48.2253 144.311 47.8946 144.974 47.2349C145.642 46.5751 145.981 45.728 145.981 44.7008C145.981 43.6736 145.642 42.8264 144.974 42.1667C144.311 41.507 143.489 41.1762 142.525 41.1762C141.554 41.1762 140.739 41.507 140.069 42.1667C139.401 42.8264 139.062 43.6736 139.062 44.7008C139.062 45.728 139.401 46.5751 140.069 47.2349Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M148.796 49.1074V40.2942H150.208L154.597 47.1485H154.647L154.597 45.4542V40.2942H155.758V49.1074H154.546L149.95 41.915H149.899L149.95 43.6166V49.1074H148.796Z",
    className: "text-stroke",
    strokeWidth: "0.180935",
    strokeMiterlimit: "10"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M137.592 61.9783C134.056 61.9783 131.167 64.6061 131.167 68.2317C131.167 71.8279 134.056 74.4833 137.592 74.4833C141.136 74.4833 144.025 71.8279 144.025 68.2317C144.025 64.6061 141.136 61.9783 137.592 61.9783ZM137.592 72.0209C135.652 72.0209 133.982 70.457 133.982 68.2317C133.982 65.9769 135.652 64.4407 137.592 64.4407C139.533 64.4407 141.21 65.9769 141.21 68.2317C141.21 70.457 139.533 72.0209 137.592 72.0209ZM123.572 61.9783C120.028 61.9783 117.147 64.6061 117.147 68.2317C117.147 71.8279 120.028 74.4833 123.572 74.4833C127.114 74.4833 129.998 71.8279 129.998 68.2317C129.998 64.6061 127.114 61.9783 123.572 61.9783ZM123.572 72.0209C121.63 72.0209 119.955 70.457 119.955 68.2317C119.955 65.9769 121.63 64.4407 123.572 64.4407C125.513 64.4407 127.182 65.9769 127.182 68.2317C127.182 70.457 125.513 72.0209 123.572 72.0209ZM106.889 63.8949V66.5521H113.388C113.198 68.0369 112.69 69.1284 111.91 69.8892C110.962 70.808 109.484 71.8279 106.889 71.8279C102.889 71.8279 99.7574 68.6764 99.7574 64.7715C99.7574 60.8665 102.889 57.715 106.889 57.715C109.051 57.715 110.625 58.5401 111.786 59.6096L113.704 57.7371C112.08 56.2229 109.919 55.0597 106.889 55.0597C101.404 55.0597 96.7949 59.4166 96.7949 64.7715C96.7949 70.1263 101.404 74.4833 106.889 74.4833C109.853 74.4833 112.08 73.535 113.83 71.7562C115.624 70.005 116.183 67.5426 116.183 65.5543C116.183 64.9368 116.13 64.369 116.036 63.8949H106.889ZM175.109 65.9549C174.58 64.5565 172.948 61.9783 169.624 61.9783C166.331 61.9783 163.588 64.5124 163.588 68.2317C163.588 71.7342 166.302 74.4833 169.941 74.4833C172.882 74.4833 174.58 72.732 175.278 71.7121L173.095 70.2917C172.367 71.3317 171.375 72.0209 169.941 72.0209C168.516 72.0209 167.494 71.3832 166.839 70.1263L175.404 66.666L175.109 65.9549ZM166.376 68.0369C166.302 65.6259 168.294 64.3911 169.72 64.3911C170.838 64.3911 171.787 64.9368 172.103 65.7178L166.376 68.0369ZM159.414 74.1029H162.229V55.7267H159.414V74.1029ZM154.803 63.3712H154.708C154.076 62.6398 152.87 61.9783 151.341 61.9783C148.134 61.9783 145.202 64.7274 145.202 68.2519C145.202 71.7562 148.134 74.4833 151.341 74.4833C152.87 74.4833 154.076 73.8162 154.708 73.0628H154.803V73.9595C154.803 76.3503 153.494 77.6348 151.385 77.6348C149.664 77.6348 148.597 76.4219 148.157 75.4021L145.708 76.3999C146.414 78.0574 148.283 80.0972 151.385 80.0972C154.686 80.0972 157.471 78.2007 157.471 73.5865V62.3587H154.803V63.3712ZM151.582 72.0209C149.642 72.0209 148.017 70.435 148.017 68.2519C148.017 66.0486 149.642 64.4407 151.582 64.4407C153.494 64.4407 155.002 66.0486 155.002 68.2519C155.002 70.435 153.494 72.0209 151.582 72.0209ZM188.292 55.7267H181.557V74.1029H184.365V67.1401H188.292C191.41 67.1401 194.469 64.9368 194.469 61.4325C194.469 57.93 191.403 55.7267 188.292 55.7267ZM188.365 64.584H184.365V58.2828H188.365C190.462 58.2828 191.659 59.9826 191.659 61.4325C191.659 62.8548 190.462 64.584 188.365 64.584ZM205.724 61.9434C203.695 61.9434 201.585 62.8181 200.717 64.7568L203.209 65.7766C203.746 64.7568 204.732 64.426 205.775 64.426C207.232 64.426 208.709 65.2805 208.732 66.7892V66.9821C208.223 66.6954 207.136 66.271 205.797 66.271C203.113 66.271 200.379 67.7135 200.379 70.4056C200.379 72.868 202.577 74.4539 205.048 74.4539C206.938 74.4539 207.981 73.6214 208.636 72.653H208.732V74.0735H211.444V67.0244C211.444 63.7663 208.952 61.9434 205.724 61.9434ZM205.385 72.0135C204.467 72.0135 203.187 71.5688 203.187 70.457C203.187 69.0347 204.783 68.489 206.164 68.489C207.401 68.489 207.981 68.7554 208.732 69.1064C208.511 70.808 207.011 72.0135 205.385 72.0135ZM221.325 62.3458L218.097 70.3119H218.001L214.664 62.3458H211.636L216.65 73.4781L213.789 79.6727H216.723L224.449 62.3458H221.325ZM196.012 74.1029H198.828V55.7267H196.012V74.1029Z",
    className: "text-stroke"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M50.7119 41.0827C50.2696 41.5347 50.0137 42.2385 50.0137 43.15V75.6611C50.0137 76.5725 50.2696 77.2764 50.7119 77.7284L50.8211 77.8276L69.4807 59.6169V59.1869L50.8211 40.9761L50.7119 41.0827Z",
    fill: "url(#paint0_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.6944 65.6902L69.4814 59.6169V59.1869L75.7019 53.1135L75.8412 53.1926L83.2079 57.2849C85.3103 58.4463 85.3103 60.3574 83.2079 61.5261L75.8412 65.6112L75.6944 65.6902Z",
    fill: "url(#paint1_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.8404 65.6109L69.4806 59.4016L50.7119 77.7282C51.4102 78.4448 52.5489 78.5312 53.8438 77.8145L75.8404 65.6109Z",
    fill: "url(#paint2_linear)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.8404 53.1926L53.8438 40.9889C52.5489 40.2796 51.4102 40.366 50.7119 41.0827L69.4806 59.4019L75.8404 53.1926Z",
    fill: "url(#paint3_linear)"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", {
    id: "filter0_d",
    x: "0.0714417",
    y: "0.892868",
    width: "273.129",
    height: "128.661",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */ React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */ React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /* @__PURE__ */ React.createElement("feOffset", {
    dy: "5.82143"
  }), /* @__PURE__ */ React.createElement("feGaussianBlur", {
    stdDeviation: "17.4643"
  }), /* @__PURE__ */ React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /* @__PURE__ */ React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /* @__PURE__ */ React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "67.8239",
    y1: "75.9996",
    x2: "43.1593",
    y2: "50.7374",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.0066",
    stopColor: "#00A1FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.2601",
    stopColor: "#00BEFF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.5122",
    stopColor: "#00D2FF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.7604",
    stopColor: "#00DFFF"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#00E3FF"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "85.9455",
    y1: "59.3998",
    x2: "49.5119",
    y2: "59.3998",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#FFE000"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.4087",
    stopColor: "#FFBD00"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.7754",
    stopColor: "#FFA500"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#FF9C00"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: "72.3822",
    y1: "56.0261",
    x2: "38.9349",
    y2: "21.7684",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#C31162"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: "45.9874",
    y1: "88.5447",
    x2: "60.9231",
    y2: "73.2472",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    stopColor: "#32A071"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.0685",
    stopColor: "#2DA771"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.4762",
    stopColor: "#15CF74"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "0.8009",
    stopColor: "#06E775"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    stopColor: "#00F076"
  })))));
}
var DownloadOnGooglePlay = withTheme(GooglePlay);
const Wrapper = styled.svg`
  height: ${({ size }) => size === "small" ? "32px" : "64px"};
  width: ${({ size }) => size === "small" ? "32px" : "64px"};

  .outline-stroke {
    stroke: ${({ theme }) => theme.themeColors.appBackground};
    stroke-opacity: 1;
  }
  .rotating-stroke {
    stroke: ${({ theme }) => theme.themeColors.primaryCtaButton};
    stroke-opacity: 0.8;
  }
`;
const Icon = ({ size }) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    size
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "outline-stroke"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2px"
  }, /* @__PURE__ */ React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18",
    className: "rotating-stroke"
  }, /* @__PURE__ */ React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "700ms",
    repeatCount: "indefinite"
  })))));
};
function LoadingAnimation({ size }) {
  return /* @__PURE__ */ React.createElement(Icon, {
    size
  });
}
const SvgWrapper = styled.svg`
  width: 40px;

  rect,
  circle {
    fill: ${({ theme, color }) => color || theme.themeColors.border};
  }
`;
const SVG_LOADING_ICON_TYPES = {
  balls: "3balls",
  bars: "bars"
};
const SvgLoadingIcon = ({ type, color }) => {
  if (type === SVG_LOADING_ICON_TYPES.balls) {
    return /* @__PURE__ */ React.createElement(SvgWrapper, {
      version: "1.1",
      id: "L4",
      x: "0px",
      y: "0px",
      viewBox: "0 0 76 22",
      enableBackground: "new 0 0 0 0",
      xmlSpace: "preserve",
      color
    }, /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "12",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.1"
    })), /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "38",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.2"
    })), /* @__PURE__ */ React.createElement("circle", {
      stroke: "none",
      cx: "64",
      cy: "10",
      r: "10"
    }, /* @__PURE__ */ React.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.3"
    })));
  }
  if (type === SVG_LOADING_ICON_TYPES.bars) {
    return /* @__PURE__ */ React.createElement(SvgWrapper, {
      version: "1.1",
      id: "L9",
      x: "0px",
      y: "0px",
      viewBox: "0 0 30 30",
      enableBackground: "new 0 0 0 0",
      xmlSpace: "preserve",
      color
    }, /* @__PURE__ */ React.createElement("rect", {
      x: "5",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0",
      dur: "0.7s",
      repeatCount: "indefinite"
    })), /* @__PURE__ */ React.createElement("rect", {
      x: "13",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0.2s",
      dur: "0.7s",
      repeatCount: "indefinite"
    })), /* @__PURE__ */ React.createElement("rect", {
      x: "21",
      y: "0",
      width: "4",
      height: "8"
    }, /* @__PURE__ */ React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      values: "0 0; 0 20; 0 0",
      begin: "0.4s",
      dur: "0.7s",
      repeatCount: "indefinite"
    })));
  }
  return null;
};
const useScript = (src, onBeforeLoad) => {
  const [status, setStatus] = React.useState(src ? "loading" : "idle");
  React.useEffect(() => {
    if (!src) {
      setStatus("idle");
      return;
    }
    let script = document == null ? void 0 : document.querySelector(`script[src="${src}"]`);
    if (!script && document) {
      onBeforeLoad && onBeforeLoad();
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading");
      document.body.appendChild(script);
      const setAttributeFromEvent = (event) => {
        script.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(script == null ? void 0 : script.getAttribute("data-status"));
    }
    const setStateFromEvent = (event) => {
      setStatus(event.type === "load" ? "ready" : "error");
    };
    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent);
    return () => {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};
const ADJUST_EVENT_NAMES = {
  VIEW_SECURITY_SCREEN: "lxfonv",
  VIEW_TRADE_SCREEN: "sv1w0c",
  COMPLETED_LIVE_SIGNUP: "llm728",
  COMPLETED_PAPER_SIGNUP: "ohhbcj",
  PLACED_LIVE_TRADE: "52bu6x",
  ADDED_IDEA: "s2pxm9",
  POSTED_THOUGHT: "4w1su4"
};
const initializeAdjust = (Adjust2, appToken, adjustEnvironment, config = {}) => {
};
const addAdjustSessionCallbackParams = (properties = []) => {
};
const logAdjustEvent = (eventId, callbackParams = []) => {
};
const sendAdjustRevenueEvent = (eventId, value, callbackParams = []) => {
};
export { ADJUST_EVENT_NAMES, AgreementCheckbox, Bank, BaseText, Body1, Body10, Body2, Body3, Body4, Body5, Body6, Body7, Body8, Body9, Calendar, CaretDown, CaretUp, ChangeIndicator, Check$1 as Check, Check as CheckCircle, Checkbox, Close, Column, CommonProps, Compass, Container, Copy, DatePicker, Delete, DownloadOnAppStore, DownloadOnGooglePlay, Dropdown, ExpiryDatePicker, Fire, FloatingLabelCurrencyInput, FloatingLabelDateEntry, FloatingLabelDatePicker, FloatingLabelDropdown, FloatingLabelExpiryDatePicker, FloatingLabelTextInput, H1, H3, H5, Heartbeat, INPUT_MASK_TYPES, InlineTextDropdown, Lightbulb, ListToggle, LoadingAnimation, LoadingSpinner, Lock, LogoFull, LogoShort, Microchip, Minus, MinusCircle, Modal, ModalWrapper, Money, MultiSelect, MultiSelectItem, Overlay, Page, Paper, PercentSign, Place, Plug, Plus, PlusCircle, Podcast, Row, SVG_LOADING_ICON_TYPES, Shield, Spacing, SvgLoadingIcon, Text, TextInput, Toggle, Tree, ValueChangeText, Warning, addAdjustSessionCallbackParams, convertHexToRGBA, createDropdownItem, createListToggleItem, createMultiSelectItem, createToggleItem, defineFontSettings, initializeAdjust, logAdjustEvent, sendAdjustRevenueEvent, useScreenSize, useScript };
